import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import * as firebase from 'firebase/app';
import { Observable, BehaviorSubject, throwError } from 'rxjs';
import { map, catchError, filter, pairwise } from 'rxjs/operators';
import { ProductInterface } from '../interface/product-interface';
import { HttpHeaders, HttpResponse } from '@angular/common/http';
import { HttpClient } from '@angular/common/http';
import { HTTP } from '@ionic-native/http/ngx';
import { NavController, LoadingController, ToastController } from '@ionic/angular';
import { NavigationExtras, Router, RoutesRecognized, Event } from '@angular/router';
import { AngularFireMessaging } from '@angular/fire/messaging';
import { environment } from '../../environments/environment';
import { callbackify } from 'util';
import * as moment from 'moment';

@Injectable({
  providedIn: 'root'
})
export class DatabaseService {

  //for build uncomment this - https://risingbee-b2b-m.appspot.com
  public API_HOST = environment.API_HOST;
  //for N computing
  //public API_HOST  = "//localhost:8899";
  //for other
  //public API_HOST = "//localhost:8888";
  public logedInUserData: {};
  public BrokerUserData: {};
  public profileUserData: {};
  //userDetail = {};

  public _ConnectedBuyerData: BehaviorSubject<Array<ProductInterface>>;
  public ConnectedBuyerData: Observable<ProductInterface[]>;

  public _ConnectedData: BehaviorSubject<Array<ProductInterface>>;
  public ConnectedData: Observable<ProductInterface[]>;

  public _productData: BehaviorSubject<Array<ProductInterface>>;
  public productData: Observable<ProductInterface[]>;

  public _albumData: BehaviorSubject<Array<ProductInterface>>;
  public albumData: Observable<ProductInterface[]>;


  public _publicProductData: BehaviorSubject<Array<ProductInterface>>;
  public publicProductData: Observable<ProductInterface[]>;

  public _CategoryWiseData: BehaviorSubject<Array<ProductInterface>>;
  public CategoryWiseData: Observable<ProductInterface[]>;

  public _AllConnectionsData: BehaviorSubject<Array<ProductInterface>>;
  public AllConnectionsData: Observable<ProductInterface[]>;

  public previousPageUrl: any = window.location.pathname;
  currentTabUrl: any;

  private persistedPrivateProductList: any = {};
  private persistedConnectionsProductList: any = {};
  private persistedPublicProductList: any = {};
  private persistedProductList: any = {};
  public persistedProductListOutOfStock: any = {};
  public persistedConnectionsProductListLastVisible: any = {};
  public persistedPrivateProductListLastVisible: any = {};
  public persistedPublicProductListLastVisible: any = {};
  public persistedProductListLastVisible: any = {};
  public persistedProductListOutOfStockLastVisible: any = {};
  public userCategoriesViaFieldWiseLoadingNow: any = {};
  public userFieldObjectViaFieldWiseLoadingNow: any = {};

  public forceLoggedInUserFieldReload: any = true;
  public loggedInUserFields: any = [];
  public loggedInUserCategSubCateg: any = {};

  public adminCategoryList: any = {};
  public adminSubCategoryList: any = {};
  public adminFieldsList: any = {};
  public adminFieldsListEach: any = {};

  relationConnectedCollectionUsers = {};
  relationSendCollectionUsers = {};
  relationReceivedCollectionUsers = {};
  relationIgnoredCollectionUsers = {};
  allPublicUsersListByField = {};
  allPublicUsersListByFilter = {};
  allPublicSuggestedUsersListByFilter = {};
  public fetchWishListOneOrManyFN: any;
  public STORAGE_REF: any;

  latestProduct: "";
  latestPublicProduct: '';
  latestConnection: "";
  filterBy: any;
  createdLink: any;
  dynamicProductsList: any = {};
  createdLinkObject: any = [];
  productType: string = "public";
  userInfo: any;
  brokerUserId: any;
  lastVisible: any;
  ownerUrl: any;
  ownerName: any;
  serverkey: any;
  latestAlbum: "";
  public userCategoriesViaFieldWise: any = [];
  logendInUserCartCount = 0;
  phoneBookList: any;
  public recentlyCreatedProductsList: any = {};
  public uploadedProductImagelist: any = {};
  public userBrandObjectViaFieldWise: any = {};
  requestAccessArray: any = [];
  public fetchAlbumOneOrManyFN: any;
  apk: any;

  constructor(
    public afs: AngularFirestore,
    private http: HttpClient,
    public navCtrl: NavController,
    public router: Router,
    private afMessaging: AngularFireMessaging,
    private loadingCtrl: LoadingController,
    private nativeHttp: HTTP,
    public toastCtrl: ToastController,
  ) {
    this.STORAGE_REF = firebase.storage();
    this.userInfo = localStorage;
    this.brokerUserId = environment.projectOwnerId;
    localStorage.setItem("brokerUserId", this.brokerUserId);
    // get logedin user detail from collection.
    // this.getUserCollection(function () {

    // }, false);
    this.ownerUrl = environment.ownerUrl;
    this.ownerName = environment.ownerName;
    this.apk = environment.APK;
    this.serverkey = environment.notificationServerKey;
    if (!this.BrokerUserData && localStorage.userType != "intermediary") {
      this.getBrokerCollection();
    }

    this.router.events
      .pipe(filter((e: Event) => e instanceof RoutesRecognized),
        pairwise()
      ).subscribe((e: any) => {
        this.previousPageUrl = e[0].urlAfterRedirects;
      });
  }

  getCartCount() {
    var self = this;
    if (localStorage.id != undefined && localStorage.userType == "buyer") {
      self.afs.collection("UserCollection").doc(localStorage.id).ref
        .collection("CartListCollection")
        .get().then(function (querySnapsort) {
          if (!querySnapsort.empty) {
            self.logendInUserCartCount = querySnapsort.docs.length;
            localStorage.setItem("logendInUserCartCount", querySnapsort.docs.length.toString());
            // console.log("Document logendInUserCartCount:", querySnapsort.docs.length);
          } else {
            localStorage.setItem("logendInUserCartCount", "");
            // doc.data() will be undefined in this case
            localStorage.setItem("logendInUserCartCount", "");
            console.log("No such document!");
          }
        }).catch(function (error) {
          console.log("Error getting document:", error);
        });
    }
  }

  // get logedin user detail from collection.
  getUserCollection(callback, doUpdate) {
    var self = this;

    if ((!self.logedInUserData || self.logedInUserData == {} && localStorage.id != undefined) || doUpdate) {
      var docRef = this.getCollection('UserCollection', ref => ref
        .where("id", "==", localStorage.id))

      docRef.subscribe(data => {
        if (data.length) {
          self.logedInUserData = data[0];
          // console.log("Document data:", data[0]);
          callback(self.logedInUserData);
        } else {
          console.log("No such document!");
          callback(null);
        }
      });



      // docRef.get().then(function (doc) {
      //   if (doc.exists) {
      //     self.logedInUserData = doc.data();
      //     console.log("Document data:", doc.data());
      //   } else {
      //     // doc.data() will be undefined in this case
      //     console.log("No such document!");
      //   }
      // }).catch(function (error) {
      //   console.log("Error getting document:", error);
      // });
    }
  }

  //quickAddProduct
  addProductDetailsInFBWithData(callback, object) {
    var self = this;
    object["updateDate"] = new Date().getTime();
    object["createDate"] = new Date().getTime();
    // Add a new document
    var docRef = self.afs.collection("ProductCollection").ref.doc();
    object["id"] = docRef.id;
    // set new object in doc ref
    docRef.set(object).then(function () {

      // catalog created - add user activity.
      self.addUserActivity({
        fireFor: "CREATE_PRODUCT",
        object: object
      });
      callback(true, object);
    }).catch(function (error) {
      console.error("Error writing document: ", error);
      callback(false);
    });
  }

  //updateProductDetailsInFB
  updateProductDetailsInFB(callback, productId, object) {
    var self = this;
    object["updateDate"] = new Date().getTime();
    // Add a new document
    self.afs.collection("ProductCollection").ref.doc(productId).update(object).then(function (docRef) {
      callback(true, productId);
    }).catch(function (error) {
      callback(false, productId);
    });
  }

  //updatedProductFromFirestoreIndex
  updatedProductFromFirestore(callback, productObject, oldProductObject, categoryId, changeProductType) {
    var self = this;
    switch (changeProductType) {
      case 'updatedProductCategory':
        const productSpliceFunction = () => {
          //splice products
          if (self.persistedProductList[localStorage.currentFieldKeyId] &&
            self.persistedProductList[localStorage.currentFieldKeyId][oldProductObject.userCategoryId]
          ) {
            const index3 = self.persistedProductList[localStorage.currentFieldKeyId][oldProductObject.userCategoryId].findIndex(x => x.id === productObject.id);
            if (index3 != -1) {
              self.persistedProductList[localStorage.currentFieldKeyId][oldProductObject.userCategoryId].splice(index3, 1);
            }
          }

          //public products list
          if (self.persistedPublicProductList[localStorage.currentFieldKeyId] &&
            self.persistedPublicProductList[localStorage.currentFieldKeyId][oldProductObject.userCategoryId]
          ) {
            const index3 = self.persistedPublicProductList[localStorage.currentFieldKeyId][oldProductObject.userCategoryId].findIndex(x => x.id === productObject.id);
            if (index3 != -1) {
              self.persistedPublicProductList[localStorage.currentFieldKeyId][oldProductObject.userCategoryId].splice(index3, 1);
            }
          }
          //private Connections list
          if (self.persistedConnectionsProductList[localStorage.currentFieldKeyId] &&
            self.persistedConnectionsProductList[localStorage.currentFieldKeyId][oldProductObject.userCategoryId]
          ) {
            const index3 = self.persistedConnectionsProductList[localStorage.currentFieldKeyId][oldProductObject.userCategoryId].findIndex(x => x.id === productObject.id);
            if (index3 != -1) {
              self.persistedConnectionsProductList[localStorage.currentFieldKeyId][oldProductObject.userCategoryId].splice(index3, 1);
            }
          }
          //Private list
          if (self.persistedPrivateProductList[localStorage.currentFieldKeyId] &&
            self.persistedPrivateProductList[localStorage.currentFieldKeyId][oldProductObject.userCategoryId]
          ) {
            const index3 = self.persistedPrivateProductList[localStorage.currentFieldKeyId][oldProductObject.userCategoryId].findIndex(x => x.id === productObject.id);
            if (index3 != -1) {
              self.persistedPrivateProductList[localStorage.currentFieldKeyId][oldProductObject.userCategoryId].splice(index3, 1);
            }
          }
          //out of stock list
          if (self.persistedProductListOutOfStock[localStorage.currentFieldKeyId] &&
            self.persistedProductListOutOfStock[localStorage.currentFieldKeyId][oldProductObject.userCategoryId]
          ) {
            const index3 = self.persistedProductListOutOfStock[localStorage.currentFieldKeyId][oldProductObject.userCategoryId].findIndex(x => x.id === productObject.id);
            if (index3 != -1) {
              self.persistedProductListOutOfStock[localStorage.currentFieldKeyId][oldProductObject.userCategoryId].splice(index3, 1);
            }
          }
        }

        productSpliceFunction();
        //updated products data
        if (self.persistedProductList[localStorage.currentFieldKeyId] &&
          self.persistedProductList[localStorage.currentFieldKeyId][productObject.userCategoryId]
        ) {
          const index3 = self.persistedProductList[localStorage.currentFieldKeyId][productObject.userCategoryId].findIndex(x => x.id === productObject.id);
          if (index3 == -1) {
            self.persistedProductList[localStorage.currentFieldKeyId][productObject.userCategoryId].unshift(productObject);
          }
        }

        //public products list
        if (self.persistedPublicProductList[localStorage.currentFieldKeyId] &&
          self.persistedPublicProductList[localStorage.currentFieldKeyId][productObject.userCategoryId]
        ) {
          const index3 = self.persistedPublicProductList[localStorage.currentFieldKeyId][productObject.userCategoryId].findIndex(x => x.id === productObject.id);
          if (index3 == -1) {
            self.persistedPublicProductList[localStorage.currentFieldKeyId][productObject.userCategoryId].unshift(productObject);
          }
        }
        //private Connections list
        if (self.persistedConnectionsProductList[localStorage.currentFieldKeyId] &&
          self.persistedConnectionsProductList[localStorage.currentFieldKeyId][productObject.userCategoryId]
        ) {
          const index3 = self.persistedConnectionsProductList[localStorage.currentFieldKeyId][productObject.userCategoryId].findIndex(x => x.id === productObject.id);
          if (index3 == -1) {
            self.persistedConnectionsProductList[localStorage.currentFieldKeyId][productObject.userCategoryId].unshift(productObject);
          }
        }
        //Private list
        if (self.persistedPrivateProductList[localStorage.currentFieldKeyId] &&
          self.persistedPrivateProductList[localStorage.currentFieldKeyId][productObject.userCategoryId]
        ) {
          const index3 = self.persistedPrivateProductList[localStorage.currentFieldKeyId][productObject.userCategoryId].findIndex(x => x.id === productObject.id);
          if (index3 == -1) {
            self.persistedPrivateProductList[localStorage.currentFieldKeyId][productObject.userCategoryId].unshift(productObject);
          }
        }
        //out of stock list
        if (self.persistedProductListOutOfStock[localStorage.currentFieldKeyId] &&
          self.persistedProductListOutOfStock[localStorage.currentFieldKeyId][productObject.userCategoryId]
        ) {
          const index3 = self.persistedProductListOutOfStock[localStorage.currentFieldKeyId][productObject.userCategoryId].findIndex(x => x.id === productObject.id);
          if (index3 == -1) {
            self.persistedProductListOutOfStock[localStorage.currentFieldKeyId][productObject.userCategoryId].unshift(productObject);
          }
        }
        callback(true);
        break;
      case 'updatedProduct':
        //updating list
        if (self.persistedProductList[localStorage.currentFieldKeyId] &&
          self.persistedProductList[localStorage.currentFieldKeyId][categoryId]
        ) {
          const indexU = self.persistedProductList[localStorage.currentFieldKeyId][categoryId].findIndex(x => x.id === productObject.id);
          if (indexU != -1) {
            self.persistedProductList[localStorage.currentFieldKeyId][categoryId].splice(indexU, 1, productObject);
          }
        }

        //public products list
        if (self.persistedPublicProductList[localStorage.currentFieldKeyId] &&
          self.persistedPublicProductList[localStorage.currentFieldKeyId][categoryId]
        ) {
          const index3 = self.persistedPublicProductList[localStorage.currentFieldKeyId][categoryId].findIndex(x => x.id === productObject.id);
          if (index3 != -1) {
            self.persistedPublicProductList[localStorage.currentFieldKeyId][categoryId].splice(index3, 1, productObject);
          }
        }
        //private Connections list
        if (self.persistedConnectionsProductList[localStorage.currentFieldKeyId] &&
          self.persistedConnectionsProductList[localStorage.currentFieldKeyId][categoryId]
        ) {
          const index3 = self.persistedConnectionsProductList[localStorage.currentFieldKeyId][categoryId].findIndex(x => x.id === productObject.id);
          if (index3 != -1) {
            self.persistedConnectionsProductList[localStorage.currentFieldKeyId][categoryId].splice(index3, 1, productObject);
          }
        }
        //Private list
        if (self.persistedPrivateProductList[localStorage.currentFieldKeyId] &&
          self.persistedPrivateProductList[localStorage.currentFieldKeyId][categoryId]
        ) {
          const index3 = self.persistedPrivateProductList[localStorage.currentFieldKeyId][categoryId].findIndex(x => x.id === productObject.id);
          if (index3 != -1) {
            self.persistedPrivateProductList[localStorage.currentFieldKeyId][categoryId].splice(index3, 1, productObject);
          }
        }
        //out of stock list
        if (self.persistedProductListOutOfStock[localStorage.currentFieldKeyId] &&
          self.persistedProductListOutOfStock[localStorage.currentFieldKeyId][categoryId]
        ) {
          const index3 = self.persistedProductListOutOfStock[localStorage.currentFieldKeyId][categoryId].findIndex(x => x.id === productObject.id);
          if (index3 != -1) {
            self.persistedProductListOutOfStock[localStorage.currentFieldKeyId][categoryId].splice(index3, 1, productObject);
          }
        }
        callback(true);
        break;
      case 'deleteProduct':
        //updating list
        if (self.persistedProductList[localStorage.currentFieldKeyId] &&
          self.persistedProductList[localStorage.currentFieldKeyId][categoryId]
        ) {
          const indexU = self.persistedProductList[localStorage.currentFieldKeyId][categoryId].findIndex(x => x.id === productObject.id);
          if (indexU != -1) {
            self.persistedProductList[localStorage.currentFieldKeyId][categoryId].splice(indexU, 1);
          }
        }

        //public products list
        if (self.persistedPublicProductList[localStorage.currentFieldKeyId] &&
          self.persistedPublicProductList[localStorage.currentFieldKeyId][categoryId]
        ) {
          const index3 = self.persistedPublicProductList[localStorage.currentFieldKeyId][categoryId].findIndex(x => x.id === productObject.id);
          if (index3 != -1) {
            self.persistedPublicProductList[localStorage.currentFieldKeyId][categoryId].splice(index3, 1);
          }
        }
        //private Connections list
        if (self.persistedConnectionsProductList[localStorage.currentFieldKeyId] &&
          self.persistedConnectionsProductList[localStorage.currentFieldKeyId][categoryId]
        ) {
          const index3 = self.persistedConnectionsProductList[localStorage.currentFieldKeyId][categoryId].findIndex(x => x.id === productObject.id);
          if (index3 != -1) {
            self.persistedConnectionsProductList[localStorage.currentFieldKeyId][categoryId].splice(index3, 1);
          }
        }
        //Private list
        if (self.persistedPrivateProductList[localStorage.currentFieldKeyId] &&
          self.persistedPrivateProductList[localStorage.currentFieldKeyId][categoryId]
        ) {
          const index3 = self.persistedPrivateProductList[localStorage.currentFieldKeyId][categoryId].findIndex(x => x.id === productObject.id);
          if (index3 != -1) {
            self.persistedPrivateProductList[localStorage.currentFieldKeyId][categoryId].splice(index3, 1);
          }
        }
        //out of stock list
        if (self.persistedProductListOutOfStock[localStorage.currentFieldKeyId] &&
          self.persistedProductListOutOfStock[localStorage.currentFieldKeyId][categoryId]
        ) {
          const index3 = self.persistedProductListOutOfStock[localStorage.currentFieldKeyId][categoryId].findIndex(x => x.id === productObject.id);
          if (index3 != -1) {
            self.persistedProductListOutOfStock[localStorage.currentFieldKeyId][categoryId].splice(index3, 1);
          }
        }
        callback(true);
        break;
      case 'addProduct':
        //add Product in list
        if (!self.persistedProductList[localStorage.currentFieldKeyId]) {
          self.persistedProductList[localStorage.currentFieldKeyId] = {};
        }
        if (!self.persistedProductList[localStorage.currentFieldKeyId][categoryId]) {
          self.persistedProductList[localStorage.currentFieldKeyId][categoryId] = [];
        }
        const index3 = self.persistedProductList[localStorage.currentFieldKeyId][categoryId].findIndex(x => x.id === productObject.id);
        if (index3 == -1) {
          self.persistedProductList[productObject.fieldId][categoryId].unshift(productObject);
        }
        callback(true);
        break;
      case 'updateProductType':
        //add Product in list
        if (self.persistedProductList[localStorage.currentFieldKeyId] && self.persistedProductList[localStorage.currentFieldKeyId][categoryId]) {
          const index3 = self.persistedProductList[localStorage.currentFieldKeyId][categoryId].findIndex(x => x.id === productObject.id);
          if (index3 != -1) {
            self.persistedProductList[productObject.fieldId][categoryId].splice(index3, 1, productObject);
          }
        }
        //add Product in connections list
        if (productObject.withConnection && productObject.productType == 'private') {
          if (!self.persistedConnectionsProductList[localStorage.currentFieldKeyId]) {
            self.persistedConnectionsProductList[localStorage.currentFieldKeyId] = {};
          }
          if (!self.persistedConnectionsProductList[localStorage.currentFieldKeyId][categoryId]) {
            self.persistedConnectionsProductList[localStorage.currentFieldKeyId][categoryId] = [];
          }
          const index3 = self.persistedConnectionsProductList[localStorage.currentFieldKeyId][categoryId].findIndex(x => x.id === productObject.id);
          if (index3 == -1) {
            self.persistedConnectionsProductList[productObject.fieldId][categoryId].unshift(productObject);
          }
        }
        //add Product in private list
        if (!productObject.withConnection && productObject.productType == 'private') {
          if (!self.persistedPrivateProductList[localStorage.currentFieldKeyId]) {
            self.persistedPrivateProductList[localStorage.currentFieldKeyId] = {};
          }
          if (!self.persistedPrivateProductList[localStorage.currentFieldKeyId][categoryId]) {
            self.persistedPrivateProductList[localStorage.currentFieldKeyId][categoryId] = [];
          }
          const index3 = self.persistedPrivateProductList[localStorage.currentFieldKeyId][categoryId].findIndex(x => x.id === productObject.id);
          if (index3 == -1) {
            self.persistedPrivateProductList[productObject.fieldId][categoryId].unshift(productObject);
          }
        }
        //add Product in public list
        if (productObject.productType == 'public') {
          if (!self.persistedPublicProductList[localStorage.currentFieldKeyId]) {
            self.persistedPublicProductList[localStorage.currentFieldKeyId] = {};
          }
          if (!self.persistedPublicProductList[localStorage.currentFieldKeyId][categoryId]) {
            self.persistedPublicProductList[localStorage.currentFieldKeyId][categoryId] = [];
          }
          const index3 = self.persistedPublicProductList[localStorage.currentFieldKeyId][categoryId].findIndex(x => x.id === productObject.id);
          if (index3 == -1) {
            self.persistedPublicProductList[productObject.fieldId][categoryId].unshift(productObject);
          }
        }
        callback(true);
        break;
    }
  }

  //updatedProductFromFirestoreIndex
  updatedProductFromFirestoreIndex(callback, productObject, categoryId, pageType, changeProductType, withConnection) {
    var self = this;
    const productSpliceFunction = () => {
      //updating list
      if (self.persistedProductList[localStorage.currentFieldKeyId] &&
        self.persistedProductList[localStorage.currentFieldKeyId][categoryId] &&
        changeProductType != 'OutOfStock'
      ) {
        const indexU = self.persistedProductList[localStorage.currentFieldKeyId][categoryId].findIndex(x => x.id === productObject.id);
        if (indexU != -1) {
          self.persistedProductList[localStorage.currentFieldKeyId][categoryId].splice(indexU, 1, productObject);
        }
      }
      //splice products
      if (self.persistedProductList[localStorage.currentFieldKeyId] &&
        self.persistedProductList[localStorage.currentFieldKeyId][categoryId] &&
        changeProductType == 'OutOfStock'
      ) {
        const index3 = self.persistedProductList[localStorage.currentFieldKeyId][categoryId].findIndex(x => x.id === productObject.id);
        if (index3 != -1) {
          self.persistedProductList[localStorage.currentFieldKeyId][categoryId].splice(index3, 1);
        }
      }

      //public products list
      if (self.persistedPublicProductList[localStorage.currentFieldKeyId] &&
        self.persistedPublicProductList[localStorage.currentFieldKeyId][categoryId] &&
        changeProductType != 'public'
      ) {
        const index3 = self.persistedPublicProductList[localStorage.currentFieldKeyId][categoryId].findIndex(x => x.id === productObject.id);
        if (index3 != -1) {
          self.persistedPublicProductList[localStorage.currentFieldKeyId][categoryId].splice(index3, 1);
        }
      }
      //private Connections list
      if (self.persistedConnectionsProductList[localStorage.currentFieldKeyId] &&
        self.persistedConnectionsProductList[localStorage.currentFieldKeyId][categoryId] &&
        (changeProductType != 'private' || withConnection == false && changeProductType == 'private')
      ) {
        const index3 = self.persistedConnectionsProductList[localStorage.currentFieldKeyId][categoryId].findIndex(x => x.id === productObject.id);
        if (index3 != -1) {
          self.persistedConnectionsProductList[localStorage.currentFieldKeyId][categoryId].splice(index3, 1);
        }
      }
      //Private list
      if (self.persistedPrivateProductList[localStorage.currentFieldKeyId] &&
        self.persistedPrivateProductList[localStorage.currentFieldKeyId][categoryId] &&
        changeProductType != 'private'
      ) {
        const index3 = self.persistedPrivateProductList[localStorage.currentFieldKeyId][categoryId].findIndex(x => x.id === productObject.id);
        if (index3 != -1) {
          self.persistedPrivateProductList[localStorage.currentFieldKeyId][categoryId].splice(index3, 1);
        }
      }
      //out of stock list
      if (self.persistedProductListOutOfStock[localStorage.currentFieldKeyId] &&
        self.persistedProductListOutOfStock[localStorage.currentFieldKeyId][categoryId] &&
        pageType == 'OutOfStock'
      ) {
        const index3 = self.persistedProductListOutOfStock[localStorage.currentFieldKeyId][categoryId].findIndex(x => x.id === productObject.id);
        if (index3 != -1) {
          self.persistedProductListOutOfStock[localStorage.currentFieldKeyId][categoryId].splice(index3, 1);
        }
      }
    }

    if (changeProductType == 'OutOfStock') {
      //out of stock list
      if (self.persistedProductListOutOfStock[localStorage.currentFieldKeyId] &&
        self.persistedProductListOutOfStock[localStorage.currentFieldKeyId][categoryId]
      ) {
        const index3 = self.persistedProductListOutOfStock[localStorage.currentFieldKeyId][categoryId].findIndex(x => x.id === productObject.id);
        if (index3 == -1) {
          self.persistedProductListOutOfStock[localStorage.currentFieldKeyId][categoryId].unshift(productObject);
        }
      }
      productSpliceFunction();
    } else if (changeProductType == 'private') {
      //private Connections list
      if (self.persistedConnectionsProductList[localStorage.currentFieldKeyId] &&
        self.persistedConnectionsProductList[localStorage.currentFieldKeyId][categoryId] &&
        withConnection == true
      ) {
        const index3 = self.persistedConnectionsProductList[localStorage.currentFieldKeyId][categoryId].findIndex(x => x.id === productObject.id);
        if (index3 != -1) {
          self.persistedConnectionsProductList[localStorage.currentFieldKeyId][categoryId].splice(index3, 1, productObject);
        } else {
          self.persistedConnectionsProductList[localStorage.currentFieldKeyId][categoryId].unshift(productObject);
        }
      }
      //Private list
      if (self.persistedPrivateProductList[localStorage.currentFieldKeyId] &&
        self.persistedPrivateProductList[localStorage.currentFieldKeyId][categoryId]
      ) {
        const index3 = self.persistedPrivateProductList[localStorage.currentFieldKeyId][categoryId].findIndex(x => x.id === productObject.id);
        if (index3 != -1) {
          self.persistedPrivateProductList[localStorage.currentFieldKeyId][categoryId].splice(index3, 1, productObject);
        } else {
          self.persistedPrivateProductList[localStorage.currentFieldKeyId][categoryId].unshift(productObject);
        }
      }
      productSpliceFunction();
    } else if (changeProductType == 'public') {
      if (self.persistedPublicProductList[localStorage.currentFieldKeyId] &&
        self.persistedPublicProductList[localStorage.currentFieldKeyId][categoryId]
      ) {
        const index3 = self.persistedPublicProductList[localStorage.currentFieldKeyId][categoryId].findIndex(x => x.id === productObject.id);
        if (index3 == -1) {
          self.persistedPublicProductList[localStorage.currentFieldKeyId][categoryId].unshift(productObject);
        }
      }
      productSpliceFunction();
    }
    callback(true);
  }

  /*  
       @Copyright Notice:
       @Type: TS   
       @For:  auth-data-seller.
       @Description : getLoggedInUserCategSubCateg For get user's CategSubCateg
   */
  getLoggedInUserCategSubCateg(callback, userId, userTypeId, fieldId) {
    var self = this;
    //check if user category exist in login user field

    if (self.loggedInUserFields && self.loggedInUserFields.find(x => x.fieldId == fieldId)
    ) {
      const matchedFieldArray = self.loggedInUserFields.filter(x => x.fieldId == fieldId);
      // clear previous data
      if (!self.loggedInUserCategSubCateg[userId]) {
        // initialize if undefined
        self.loggedInUserCategSubCateg[userId] = {};
      }
      self.loggedInUserCategSubCateg[userId][fieldId] = [];
      // update new data
      self.loggedInUserCategSubCateg[userId][fieldId] = matchedFieldArray;
      // do callback from local storage service
      callback(true, self.loggedInUserCategSubCateg[userId][fieldId]);
    } else {
      // 1. if forceLoggedInUserCategSubCategReload is true means data needs to be loaded again
      // 2. usually we change it's value (self.forceLoggedInUserCategSubCategReload = true) when any change made in categories from profile
      // fetching logged in user's CategSubCateg
      var docRef = self.afs.collection("UserCategoryCollection").ref
        .where("userId", "==", userId)
        .where("fieldId", "==", fieldId);
      docRef.get().then(function (querySnapshot) {
        if (!querySnapshot.empty) {
          // clear previous data
          if (!self.loggedInUserCategSubCateg[userId]) {
            // initialize if undefined
            self.loggedInUserCategSubCateg[userId] = {};
          }
          self.loggedInUserCategSubCateg[userId][fieldId] = [];
          // update new data
          querySnapshot.forEach(function (doc) {
            self.loggedInUserCategSubCateg[userId][fieldId].push(doc.data());
          });
          // new CategSubCategReload fetched - mark this flag false
          //self.forceLoggedInUserCategSubCategReload = false;
          // do callback
          callback(true, self.loggedInUserCategSubCateg[userId][fieldId]);
        } else {
          callback(true, null);
        }
      }).catch(function (error) {
        console.log("error", error);
      });
    }
  }


  //getProductFromFirestoreIndex
  getProductFromFirestoreIndex(callback, productObject, categoryId, changeProductType) {
    var self = this;
    //var categoryId : any;
    switch (changeProductType) {
      case 'outOfStockProduct':
        if (localStorage.userType != "buyer") {
          var indexO = self.persistedProductList[productObject.fieldId][categoryId].findIndex(x => x.id === productObject.id);
          if (indexO != -1) {
            self.persistedProductList[productObject.fieldId][categoryId].splice(indexO, 1);
          }
          productObject['isDeleted'] = true;
          if (self.persistedProductListOutOfStock[productObject.fieldId] != undefined) {
            if (self.persistedProductListOutOfStock[productObject.fieldId][categoryId] != undefined) {
              self.persistedProductListOutOfStock[productObject.fieldId][categoryId].unshift(productObject);
            } else {
              self.persistedProductListOutOfStock[productObject.fieldId][categoryId] = [];
              self.persistedProductListOutOfStock[productObject.fieldId][categoryId].unshift(productObject);
            }
          } else {
            self.persistedProductListOutOfStock[productObject.fieldId] = {}
            self.persistedProductListOutOfStock[productObject.fieldId][categoryId] = [];
            self.persistedProductListOutOfStock[productObject.fieldId][categoryId].unshift(productObject);
          }
          callback(true);
        } else {
          var checkOutOfStock = () => {
            categoryId = undefined;
            if (self.persistedProductList[productObject.fieldId][categoryId]) {
              var indexO = self.persistedProductList[productObject.fieldId][categoryId].findIndex(x => x.id === productObject.id);
              if (indexO != -1) {
                self.persistedProductList[productObject.fieldId][categoryId].splice(indexO, 1);
              }
              productObject['isDeleted'] = true;
              if (self.persistedProductListOutOfStock[productObject.fieldId] != undefined) {
                if (self.persistedProductListOutOfStock[productObject.fieldId][categoryId] != undefined) {
                  self.persistedProductListOutOfStock[productObject.fieldId][categoryId].unshift(productObject);
                } else {
                  self.persistedProductListOutOfStock[productObject.fieldId][categoryId] = [];
                  self.persistedProductListOutOfStock[productObject.fieldId][categoryId].unshift(productObject);
                }
              } else {
                self.persistedProductListOutOfStock[productObject.fieldId] = {}
                self.persistedProductListOutOfStock[productObject.fieldId][categoryId] = [];
                self.persistedProductListOutOfStock[productObject.fieldId][categoryId].unshift(productObject);
              }
            }
            callback(true);
          }
          if (categoryId == "" || categoryId == undefined || categoryId == null) {
            checkOutOfStock();
          } else {
            if (self.persistedProductList[productObject.fieldId][categoryId]) {
              var indexO = self.persistedProductList[productObject.fieldId][categoryId].findIndex(x => x.id === productObject.id);
              if (indexO != -1) {
                self.persistedProductList[productObject.fieldId][categoryId].splice(indexO, 1);
              }
              productObject['isDeleted'] = true;
              if (self.persistedProductListOutOfStock[productObject.fieldId] != undefined) {
                if (self.persistedProductListOutOfStock[productObject.fieldId][categoryId] != undefined) {
                  self.persistedProductListOutOfStock[productObject.fieldId][categoryId].unshift(productObject);
                } else {
                  self.persistedProductListOutOfStock[productObject.fieldId][categoryId] = [];
                  self.persistedProductListOutOfStock[productObject.fieldId][categoryId].unshift(productObject);
                }
              } else {
                self.persistedProductListOutOfStock[productObject.fieldId] = {}
                self.persistedProductListOutOfStock[productObject.fieldId][categoryId] = [];
                self.persistedProductListOutOfStock[productObject.fieldId][categoryId].unshift(productObject);
              }
            }
            checkOutOfStock();
          }
        }
        break;
      case 'restoreProduct':
        if (localStorage.userType != "buyer") {
          var indexR = self.persistedProductListOutOfStock[productObject.fieldId][categoryId].findIndex(x => x.id === productObject.id);
          if (indexR != -1) {
            self.persistedProductListOutOfStock[productObject.fieldId][categoryId].splice(indexR, 1);
          }
          productObject['isDeleted'] = false;
          if (self.persistedProductList[productObject.fieldId] != undefined) {
            self.persistedProductList[productObject.fieldId][categoryId].unshift(productObject);
          } else {
            self.persistedProductList[productObject.fieldId] = {}
            self.persistedProductList[productObject.fieldId][categoryId] = [];
            self.persistedProductList[productObject.fieldId][categoryId].unshift(productObject);
          }
          callback(true);
        } else {
          var checkRestoreProduct = () => {
            categoryId = undefined;
            if (self.persistedProductListOutOfStock[productObject.fieldId][categoryId]) {
              var indexR = self.persistedProductListOutOfStock[productObject.fieldId][categoryId].findIndex(x => x.id === productObject.id);
              if (indexR != -1) {
                self.persistedProductListOutOfStock[productObject.fieldId][categoryId].splice(indexR, 1);
              }
              productObject['isDeleted'] = false;
              if (self.persistedProductList[productObject.fieldId] != undefined) {
                if (self.persistedProductList[productObject.fieldId][categoryId] != undefined) {
                  self.persistedProductList[productObject.fieldId][categoryId].unshift(productObject);
                } else {
                  self.persistedProductList[productObject.fieldId][categoryId] = [];
                  self.persistedProductList[productObject.fieldId][categoryId].unshift(productObject);
                }
              } else {
                self.persistedProductList[productObject.fieldId] = {}
                self.persistedProductList[productObject.fieldId][categoryId] = [];
                self.persistedProductList[productObject.fieldId][categoryId].unshift(productObject);
              }
            }
            callback(true);
          }
          if (categoryId == "" || categoryId == undefined || categoryId == null) {
            checkRestoreProduct();
          } else {
            if (self.persistedProductListOutOfStock[productObject.fieldId][categoryId]) {
              var indexR = self.persistedProductListOutOfStock[productObject.fieldId][categoryId].findIndex(x => x.id === productObject.id);
              if (indexR != -1) {
                self.persistedProductListOutOfStock[productObject.fieldId][categoryId].splice(indexR, 1);
              }
              productObject['isDeleted'] = false;
              if (self.persistedProductList[productObject.fieldId] != undefined) {
                if (self.persistedProductList[productObject.fieldId][categoryId] != undefined) {
                  self.persistedProductList[productObject.fieldId][categoryId].unshift(productObject);
                } else {
                  self.persistedProductList[productObject.fieldId][categoryId] = [];
                  self.persistedProductList[productObject.fieldId][categoryId].unshift(productObject);
                }
              } else {
                self.persistedProductList[productObject.fieldId] = {}
                self.persistedProductList[productObject.fieldId][categoryId] = [];
                self.persistedProductList[productObject.fieldId][categoryId].unshift(productObject);
              }
            }
            checkRestoreProduct();
          }
        }
        break;
      case 'updatedProduct':
        if (localStorage.userType != "buyer") {
          if (!self.persistedProductList[productObject.fieldId]) {
            self.persistedProductList[productObject.fieldId] = {}
          }
          if (!self.persistedProductList[productObject.fieldId][categoryId]) {
            self.persistedProductList[productObject.fieldId][categoryId] = [];
          }
          var indexU = self.persistedProductList[productObject.fieldId][categoryId].findIndex(x => x.id === productObject.id);
          if (indexU != -1) {
            self.persistedProductList[productObject.fieldId][categoryId].splice(indexU, 1, productObject);
          }
          callback(true);
        } else {
          var checkUpdateProduct = () => {
            categoryId = undefined;
            if (self.persistedProductList[productObject.fieldId][categoryId]) {
              var indexU = self.persistedProductList[productObject.fieldId][categoryId].findIndex(x => x.id === productObject.id);
              if (indexU != -1) {
                self.persistedProductList[productObject.fieldId][categoryId].splice(indexU, 1, productObject);
              }
            }
            callback(true);
          }
          if (categoryId == "" || categoryId == undefined || categoryId == null) {
            checkUpdateProduct();
          } else {
            if (self.persistedProductList[productObject.fieldId][categoryId]) {
              var indexU = self.persistedProductList[productObject.fieldId][categoryId].findIndex(x => x.id === productObject.id);
              if (indexU != -1) {
                self.persistedProductList[productObject.fieldId][categoryId].splice(indexU, 1, productObject);
              }
            }
            checkUpdateProduct();
          }
        }
        break;
      case 'deleteProduct':
        if (localStorage.userType != "buyer") {
          // var index2 = self.persistedProductListOutOfStock[productObject.fieldId][categoryId].findIndex(x=>x.id === productObject.id);
          // if(index2 != -1){
          //     self.persistedProductListOutOfStock[productObject.fieldId][categoryId].splice(index2, 1);
          // }
          if (self._productData && self._productData["_value"]) {
            var index2 = self._productData["_value"].findIndex(x => x.id == productObject.id)
            if (index2 != -1) {
              self._productData["_value"].splice(index2, 1)
            }
          }
          callback(true);
        } else {
          var checkDeleteProduct = () => {
            categoryId = undefined;
            if (self.persistedProductListOutOfStock[productObject.fieldId][categoryId]) {
              var index2 = self.persistedProductListOutOfStock[productObject.fieldId][categoryId].findIndex(x => x.id === productObject.id);
              if (index2 != -1) {
                self.persistedProductListOutOfStock[productObject.fieldId][categoryId].splice(index2, 1);
              }
            }
            callback(true);
          }
          if (categoryId == "" || categoryId == undefined || categoryId == null) {
            checkDeleteProduct();
          } else {
            if (self.persistedProductListOutOfStock[productObject.fieldId][categoryId]) {
              var index2 = self.persistedProductListOutOfStock[productObject.fieldId][categoryId].findIndex(x => x.id === productObject.id);
              if (index2 != -1) {
                self.persistedProductListOutOfStock[productObject.fieldId][categoryId].splice(index2, 1);
              }
            }
            checkDeleteProduct();
          }
        }
        break;
      case 'addProduct':
        if (localStorage.userType != "buyer") {
          if (!self.persistedProductList[localStorage.currentFieldKeyId]) {
            self.persistedProductList[localStorage.currentFieldKeyId] = {};
          }
          if (!self.persistedProductList[localStorage.currentFieldKeyId][categoryId]) {
            self.persistedProductList[localStorage.currentFieldKeyId][categoryId] = [];
          }
          var index3 = self.persistedProductList[localStorage.currentFieldKeyId][categoryId].findIndex(x => x.id === productObject.id);
          if (index3 == -1) {
            self.persistedProductList[productObject.fieldId][categoryId].unshift(productObject);
          }
        } else {
          //this add product is only for retailer user
          var checkAddProduct = () => {
            categoryId = undefined;
            if (!self.persistedProductList[localStorage.currentFieldKeyId]) {
              self.persistedProductList[localStorage.currentFieldKeyId] = {};
            }
            if (!self.persistedProductList[localStorage.currentFieldKeyId][categoryId]) {
              self.persistedProductList[localStorage.currentFieldKeyId][categoryId] = [];
            }
            var index3 = self.persistedProductList[localStorage.currentFieldKeyId][categoryId].findIndex(x => x.id === productObject.id);
            if (index3 == -1) {
              self.persistedProductList[productObject.fieldId][categoryId].unshift(productObject);
            }
            callback(true);
          }
          if (categoryId == "" || categoryId == undefined || categoryId == null) {
            checkAddProduct();
          } else {
            if (!self.persistedProductList[localStorage.currentFieldKeyId]) {
              self.persistedProductList[localStorage.currentFieldKeyId] = {};
            }
            if (!self.persistedProductList[localStorage.currentFieldKeyId][categoryId]) {
              self.persistedProductList[localStorage.currentFieldKeyId][categoryId] = [];
            }
            var index3 = self.persistedProductList[localStorage.currentFieldKeyId][categoryId].findIndex(x => x.id === productObject.id);
            if (index3 == -1) {
              self.persistedProductList[productObject.fieldId][categoryId].unshift(productObject);
            }
            checkAddProduct();
          }
        }
        break;
      case 'updatedProductCategory':
        if (!self.persistedProductList[productObject.fieldId]) {
          self.persistedProductList[productObject.fieldId] = {}
        }
        if (!self.persistedProductList[productObject.fieldId][categoryId]) {
          self.persistedProductList[productObject.fieldId][categoryId] = [];
        }
        var index3 = self.persistedProductList[productObject.fieldId][categoryId].findIndex(x => x.id === productObject.id);
        if (index3 != -1) {
          self.persistedProductList[localStorage.currentFieldKeyId][categoryId].splice(index3, 1);
        }
        callback(true);
        break;
    }
  }

  getLogedInUserlatestProducts(callback, limit) {
    var self = this;
    var list = [];
    var count = 0;
    if (limit != undefined) {
      var query = self.afs.collection("ProductCollection").ref
        .where("userId", "==", localStorage.id)
        .where("fieldId", "==", localStorage.currentFieldKeyId)

      query.limit(limit).orderBy("createDate", 'desc').get().then(function (querySnapshot) {
        //hold the last visible if the product.....
        querySnapshot.forEach(function (doc) {
          // doc.data() is never undefined for query doc snapshots
          var object = doc.data();
          count++;
          list.push(object);
        });
        if (querySnapshot.size == count) {
          callback(list);
        }
      })
    }
  }

  getLogedInUserlatestAlbum(callback, limit) {
    var self = this;
    var list = [];
    var count = 0;
    if (limit != undefined) {
      var query = self.afs.collection("ProductsAlbumCollection").ref
        .where("userId", "==", localStorage.id)
        .where("fieldId", "==", localStorage.currentFieldKeyId)

      query.limit(limit).orderBy("createDate", 'desc').get().then(function (querySnapshot) {
        //hold the last visible if the product.....
        querySnapshot.forEach(function (doc) {
          // doc.data() is never undefined for query doc snapshots
          var object = doc.data();
          count++;
          //get images of productIds from productCollection
          const myPromise = self.fetchProductImageCollection((object['productId']));
          myPromise.then(imageList => {
            object["albumProdImages"] = imageList;
          })
          list.push(object);
        });
        if (querySnapshot.size == count) {
          callback(list);
        }
      })
    }
  }

  //Description : getProductFromFirestore For show get public products.
  getProductFromFirestore(callback, categoryId, isOuOfStock, productType, withConnection, limit) {
    //console.log("getProductFromFirestore")
    // here we are calling function for fetch all product details..
    var list = [];
    var self = this;
    var lastVisible = "";
    var isOuOfStockQuery: any;
    var query: any;
    query = self.afs.collection("ProductCollection").ref
      .where("userId", "==", localStorage.id)
      .where("fieldId", "==", localStorage.currentFieldKeyId)
    if (categoryId) {
      query = query.where('userCategoryId', '==', categoryId);
    }
    //product get via delete or isOuOfStock wise...
    if (isOuOfStock) {
      if (!self.persistedProductListOutOfStock[localStorage.currentFieldKeyId]) {
        self.persistedProductListOutOfStock[localStorage.currentFieldKeyId] = {};
      }
      if (!self.persistedProductListOutOfStockLastVisible[localStorage.currentFieldKeyId]) {
        self.persistedProductListOutOfStockLastVisible[localStorage.currentFieldKeyId] = {};
      }
      const callOutOfStockFunction = () => {
        //create the fire-store query for get product via categoryId wise.....
        query = query.where('isDeleted', '==', true);
        //get data from firestore and iterate one by one.....
        query.limit(25).orderBy("createDate", 'desc').get().then(function (querySnapshot) {
          //hold the last visible if the product.....
          var lastVisible = querySnapshot.docs[querySnapshot.docs.length - 1];

          querySnapshot.forEach(function (doc) {
            // doc.data() is never undefined for query doc snapshots
            var object = doc.data();
            list.push(object);
          });
          self.persistedProductListOutOfStock[localStorage.currentFieldKeyId][categoryId] = list;
          self.persistedProductListOutOfStockLastVisible[localStorage.currentFieldKeyId][categoryId] = lastVisible;
          callback(true, self.persistedProductListOutOfStock[localStorage.currentFieldKeyId][categoryId], self.persistedProductListOutOfStockLastVisible[localStorage.currentFieldKeyId][categoryId]);
        }).catch(function (error) {
          callback(false, null);
        });
      }
      //call function
      //callOutOfStockFunction();
      //for retailer user
      if (localStorage.userType != "buyer") {
        if (self.persistedProductListOutOfStock[localStorage.currentFieldKeyId] &&
          self.persistedProductListOutOfStockLastVisible[localStorage.currentFieldKeyId] &&
          self.persistedProductListOutOfStock[localStorage.currentFieldKeyId][categoryId] &&
          self.persistedProductListOutOfStock[localStorage.currentFieldKeyId][categoryId].length > 0 &&
          self.persistedProductListOutOfStockLastVisible[localStorage.currentFieldKeyId][categoryId]) {
          callback(true, self.persistedProductListOutOfStock[localStorage.currentFieldKeyId][categoryId], self.persistedProductListOutOfStockLastVisible[localStorage.currentFieldKeyId][categoryId]);
        } else {
          //call function
          callOutOfStockFunction();
        }
      } else {
        //call function
        callOutOfStockFunction();
      }

    } else if (productType == 'public') {
      if (!self.persistedPublicProductList[localStorage.currentFieldKeyId]) {
        self.persistedPublicProductList[localStorage.currentFieldKeyId] = {};
      }
      if (!self.persistedPublicProductListLastVisible[localStorage.currentFieldKeyId]) {
        self.persistedPublicProductListLastVisible[localStorage.currentFieldKeyId] = {};
      }
      const callFetchProductFunction = () => {
        //create the fire-store query for get product via categoryId wise.....
        query = query.where("productType", "==", productType);
        query = query.where('isDeleted', '==', false);
        //get data from firestore and iterate one by one.....
        query.limit(25).orderBy("createDate", 'desc').get().then(function (querySnapshot) {
          //hold the last visible if the product.....
          lastVisible = querySnapshot.docs[querySnapshot.docs.length - 1];

          querySnapshot.forEach(function (doc) {
            // doc.data() is never undefined for query doc snapshots
            var object = doc.data();
            list.push(object);
          });
          self.persistedPublicProductList[localStorage.currentFieldKeyId][categoryId] = list;
          self.persistedPublicProductListLastVisible[localStorage.currentFieldKeyId][categoryId] = lastVisible;
          callback(true, self.persistedPublicProductList[localStorage.currentFieldKeyId][categoryId], self.persistedPublicProductListLastVisible[localStorage.currentFieldKeyId][categoryId]);
        }).catch(function (error) {
          callback(false, null);
          console.log("error:-" + error);
        });
      }
      //callFetchProductFunction();

      //for retailer user
      if (localStorage.userType != "buyer") {
        if (self.persistedPublicProductList[localStorage.currentFieldKeyId][categoryId] &&
          self.persistedPublicProductList[localStorage.currentFieldKeyId][categoryId].length > 0 &&
          self.persistedPublicProductListLastVisible[localStorage.currentFieldKeyId][categoryId]) {
          callback(true, self.persistedPublicProductList[localStorage.currentFieldKeyId][categoryId], self.persistedPublicProductListLastVisible[localStorage.currentFieldKeyId][categoryId]);
        } else {
          //call function
          callFetchProductFunction();
        }
      } else {
        //call function
        callFetchProductFunction();
      }

    } else if (productType == 'private') {
      if (withConnection) {
        if (!self.persistedConnectionsProductList[localStorage.currentFieldKeyId]) {
          self.persistedConnectionsProductList[localStorage.currentFieldKeyId] = {};
        }
        if (!self.persistedConnectionsProductListLastVisible[localStorage.currentFieldKeyId]) {
          self.persistedConnectionsProductListLastVisible[localStorage.currentFieldKeyId] = {};
        }
        const callFetchProductFunction = () => {
          //create the fire-store query for get product via categoryId wise.....
          query = query.where("productType", "==", productType);
          query = query.where("withConnection", "==", true);
          query = query.where('isDeleted', '==', false);
          //get data from firestore and iterate one by one.....
          query.limit(25).orderBy("createDate", 'desc').get().then(function (querySnapshot) {
            //hold the last visible if the product.....
            lastVisible = querySnapshot.docs[querySnapshot.docs.length - 1];

            querySnapshot.forEach(function (doc) {
              // doc.data() is never undefined for query doc snapshots
              var object = doc.data();
              list.push(object);
            });
            self.persistedConnectionsProductList[localStorage.currentFieldKeyId][categoryId] = list;
            self.persistedConnectionsProductListLastVisible[localStorage.currentFieldKeyId][categoryId] = lastVisible;
            callback(true, self.persistedConnectionsProductList[localStorage.currentFieldKeyId][categoryId], self.persistedConnectionsProductListLastVisible[localStorage.currentFieldKeyId][categoryId]);
          }).catch(function (error) {
            callback(false, null);
            console.log("error:-" + error);
          });
        }
        //callFetchProductFunction();

        //for retailer user
        if (localStorage.userType != "buyer") {
          if (self.persistedConnectionsProductList[localStorage.currentFieldKeyId][categoryId] &&
            self.persistedConnectionsProductList[localStorage.currentFieldKeyId][categoryId].length > 0 &&
            self.persistedConnectionsProductListLastVisible[localStorage.currentFieldKeyId][categoryId]) {
            callback(true, self.persistedConnectionsProductList[localStorage.currentFieldKeyId][categoryId], self.persistedConnectionsProductListLastVisible[localStorage.currentFieldKeyId][categoryId]);
          } else {
            //call function
            callFetchProductFunction();
          }
        } else {
          //call function
          callFetchProductFunction();
        }

      } else {
        if (!self.persistedPrivateProductList[localStorage.currentFieldKeyId]) {
          self.persistedPrivateProductList[localStorage.currentFieldKeyId] = {};
        }
        if (!self.persistedPrivateProductListLastVisible[localStorage.currentFieldKeyId]) {
          self.persistedPrivateProductListLastVisible[localStorage.currentFieldKeyId] = {};
        }
        const callFetchProductFunction = () => {

          query = query.where("productType", "==", productType);
          query = query.where('isDeleted', '==', false);
          //get data from firestore and iterate one by one.....
          query.limit(25).orderBy("createDate", 'desc').get().then(function (querySnapshot) {
            //hold the last visible if the product.....
            lastVisible = querySnapshot.docs[querySnapshot.docs.length - 1];

            querySnapshot.forEach(function (doc) {
              // doc.data() is never undefined for query doc snapshots
              var object = doc.data();
              list.push(object);
            });
            self.persistedPrivateProductList[localStorage.currentFieldKeyId][categoryId] = list;
            self.persistedPrivateProductListLastVisible[localStorage.currentFieldKeyId][categoryId] = lastVisible;
            callback(true, self.persistedPrivateProductList[localStorage.currentFieldKeyId][categoryId], self.persistedPrivateProductListLastVisible[localStorage.currentFieldKeyId][categoryId]);
          }).catch(function (error) {
            callback(false, null);
            console.log("error:-" + error);
          });
        }
        //callFetchProductFunction();

        //for retailer user
        if (localStorage.userType != "buyer") {
          if (self.persistedPrivateProductList[localStorage.currentFieldKeyId][categoryId] &&
            self.persistedPrivateProductList[localStorage.currentFieldKeyId][categoryId].length > 0 &&
            self.persistedPrivateProductListLastVisible[localStorage.currentFieldKeyId][categoryId]) {
            callback(true, self.persistedPrivateProductList[localStorage.currentFieldKeyId][categoryId], self.persistedPrivateProductListLastVisible[localStorage.currentFieldKeyId][categoryId]);
          } else {
            //call function
            callFetchProductFunction();
          }
        } else {
          //call function
          callFetchProductFunction();
        }
      }
    } else {
      if (!self.persistedProductList[localStorage.currentFieldKeyId]) {
        self.persistedProductList[localStorage.currentFieldKeyId] = {};
      }
      if (!self.persistedProductListLastVisible[localStorage.currentFieldKeyId]) {
        self.persistedProductListLastVisible[localStorage.currentFieldKeyId] = {};
      }
      const callFetchProductFunction = () => {
        query = query.where('isDeleted', '==', false);
        //get data from firestore and iterate one by one.....
        query.orderBy("createDate", 'desc').limit(limit).get().then(function (querySnapshot) {
          //hold the last visible if the product.....
          lastVisible = querySnapshot.docs[querySnapshot.docs.length - 1];

          querySnapshot.forEach(function (doc) {
            // doc.data() is never undefined for query doc snapshots
            var object = doc.data();
            list.push(object);
          });
          self.persistedProductList[localStorage.currentFieldKeyId][categoryId] = list;
          self.persistedProductListLastVisible[localStorage.currentFieldKeyId][categoryId] = lastVisible;
          callback(true, self.persistedProductList[localStorage.currentFieldKeyId][categoryId], self.persistedProductListLastVisible[localStorage.currentFieldKeyId][categoryId]);
        }).catch(function (error) {
          callback(false, null);
          console.log("Error documents ", error);
        });
      }
      //callFetchProductFunction();
      //for retailer user
      if (localStorage.userType != "buyer") {
        if (self.persistedProductList[localStorage.currentFieldKeyId][categoryId] &&
          self.persistedProductList[localStorage.currentFieldKeyId][categoryId].length > 0 &&
          self.persistedProductListLastVisible[localStorage.currentFieldKeyId][categoryId]) {
          callback(true, self.persistedProductList[localStorage.currentFieldKeyId][categoryId], self.persistedProductListLastVisible[localStorage.currentFieldKeyId][categoryId]);
        } else {
          //call function
          callFetchProductFunction();
        }
      } else {
        //call function
        callFetchProductFunction();
      }
    }
  }

  //updated publicProduct
  updatedPublicProductId(productId, addOrRemove) {
    var self = this;
    // initialize empty object
    var productIdToUpdate = {};
    // add key as fieldId and value as productId to be add in given array
    if (productIdToUpdate[localStorage.currentFieldKeyId] == undefined) {
      productIdToUpdate[localStorage.currentFieldKeyId] = [];
    }
    //do the update here
    let ref = self.afs.collection("UserCollection").doc(localStorage.id).ref;
    //ref.update(productIdToUpdate);
    // var docRef = self.afs.collection("UserCollection").doc(userId).ref;
    //   docRef.get().then(function (doc)
    // get to update new field
    ref.get().then(function (doc) {
      if (doc.exists) {

        console.log("Document data:", doc.data());
        const docData = doc.data();
        var productObjectToUpdate: any = [];
        let trueOrFalse = false;
        // check if currentFieldKeyId array contains productId(s) in user document object
        if (addOrRemove) {
          if (docData[localStorage.currentFieldKeyId] && docData[localStorage.currentFieldKeyId].length > 0) {
            productObjectToUpdate = docData[localStorage.currentFieldKeyId];
            var index = productObjectToUpdate.findIndex(x => x.id == productId.id);
            if (index != -1) {
              productObjectToUpdate.splice(index, 1, productId);
              productIdToUpdate[localStorage.currentFieldKeyId] = productObjectToUpdate;
              // add date for fatch latest PUBLIC-USER who upload public product
              productIdToUpdate["updatedPublicProdDate"] = firebase.firestore.FieldValue.serverTimestamp();
              ref.update(productIdToUpdate);
            } else {
              productObjectToUpdate.unshift(productId);
              productIdToUpdate[localStorage.currentFieldKeyId] = productObjectToUpdate;
              // add date for fatch latest PUBLIC-USER who upload public product
              productIdToUpdate["updatedPublicProdDate"] = firebase.firestore.FieldValue.serverTimestamp();
              ref.update(productIdToUpdate);
            }
          }

          // assign it true if it contains productId(s)
          trueOrFalse = true;
        } else {
          if (docData[localStorage.currentFieldKeyId] && docData[localStorage.currentFieldKeyId].length > 0) {
            productObjectToUpdate = docData[localStorage.currentFieldKeyId];
            var index = productObjectToUpdate.findIndex(x => x.id == productId.id);
            if (index != -1) {
              productObjectToUpdate.splice(index, 1);
              productIdToUpdate[localStorage.currentFieldKeyId] = productObjectToUpdate;
              ref.update(productIdToUpdate);
            }
            if (docData[localStorage.currentFieldKeyId] && docData[localStorage.currentFieldKeyId].length > 0) {
              trueOrFalse = true;
            }
          }
        }

        let newObj = {};
        if (docData.publicProduct) {
          newObj['publicProduct'] = docData.publicProduct
        } else {
          newObj['publicProduct'] = {};
        }
        var filedNameLC = localStorage.currentFieldName.trim().toLowerCase();
        // update publicProduct field value as per value of trurOrFalse
        newObj['publicProduct'][filedNameLC] = trueOrFalse;
        ref.update(newObj);

      } else {
        // doc.data() will be undefined in this case
        console.log("No such document!");
      }
    }).catch(function (error) {
      console.log("Error getting document:", error);
    });
  }

  _fetchReShareWithInProductForSeller(callback, productId) {
    var self = this;
    var list = [];

    // Add a new document
    var docRef = self.afs.collection("ProductCollection").doc(productId)
      .collection("ReShareWithCollection").ref;
    docRef.get().then(function (querySnapshot) {
      querySnapshot.forEach(function (doc) {
        var object = doc.data();
        list.push(object);
      });
      callback(true, list);
    });
  }

  // call from show user profile in detail page
  getProfileDetail(callback, userId) {
    var self = this;
    if (userId != "") {
      var docRef = self.afs.collection("UserCollection").doc(userId).ref;
      docRef.get().then(function (doc) {
        if (doc.exists) {
          callback(doc.data());
          // self.profileUserData = doc.data();
          // console.log("Document data:", doc.data());
        } else {
          callback(null);
          // doc.data() will be undefined in this case
          console.log("No such document!");
        }
      }).catch(function (error) {
        callback(null);
        console.log("Error getting document:", error);
      });
    }
  }
  getBrokerCollection() {
    var self = this;
    var docRef = self.afs.collection("UserCollection").doc(self.brokerUserId).ref;
    docRef.get().then(function (doc) {
      if (doc.exists) {
        self.BrokerUserData = doc.data();

        // console.log("Document data:", doc.data());
      } else {
        // doc.data() will be undefined in this case
        console.log("No such document!");
      }
    }).catch(function (error) {
      console.log("Error getting document:", error);
    });
  }

  chekEmailOrNumberExistGCP(callback, object) {

    var ref = this.getCollection('UserCollection', ref => ref
      .where("phoneNumber", "==", "+" + object.countryCode + Number(object.data)))
    ref.subscribe(data => {

      // check broker user relation
      if (data.length && this.brokerUserId != data[0].id && data[0].userType != "seller") {
        var brokerRef = this.afs.collection("RelationConnectedCollection").ref
          .where("userId", "==", this.brokerUserId)
          .where("connectedUserId", "==", data[0].id)
        brokerRef.get().then(function (querySnapshort) {
          // if data is empty  it means user is not avalieble
          // or querySnapshort is empty user is not connected with broker.
          if (data.length && !querySnapshort.empty) {
            data['isExist'] = true;
            callback(true, data);
          } else {
            callback(true, data);
          }
        })
      } else if (data.length && this.brokerUserId == data[0].id) {
        data['isExist'] = true;
        callback(true, data);
      } else {
        callback(true, data);
      }
    });
  }


  //check emailexist
  checkEmailExistGCP(callback, email) {
    var ref = this.afs.collection("UserCollection").ref
      .where("emailLC", "==", email.toLowerCase());
    ref.get().then(function (querySnapshot) {
      if (!querySnapshot.empty) {
        callback(true);
      } else {
        callback(false);
      }
    });
  }

  //check Number
  checkNumberExistGCP(callback, object) {
    var ref = this.afs.collection("UserCollection").ref.where("phoneNumber", "==", "+" + object.countryCode + Number(object.data));
    ref.get().then(function (querySnapshot) {
      if (!querySnapshot.empty) {
        callback(true);
      } else {
        callback(false);
      }
    });
  }

  /*
		@Copyright Notice:
		@(#)
		@Type: TS   
		@For:  create-account-next.html.
		@Description : updateUserTypeDetail for update updateUserTypeDetail
	 */
  updateUserTypeDetail(callback, userId, userTypeId, toUpdateObject) {
    var self = this;
    var querry: any;
    if (userId) {
      querry = self.afs.collection("UserCollection").ref.doc(userId)
      querry.update(toUpdateObject)
        .then(function () {
          callback(true);
          //});
        }).catch(function (error) {
          console.error("Error writing document3: ", error);
        });
    }
  }

  // You need to return the doc to get the current cursor.
  getCollection(ref, queryFn?): Observable<any[]> {
    return this.afs.collection(ref, queryFn).snapshotChanges().pipe(
      map(actions => {
        return actions.map(a => {
          const data = a.payload.doc.data();
          const id = a.payload.doc.id;
          const doc = a.payload.doc;
          return { id, ...data, doc };
        });
      })
    )
  }

  addDailyProduct = (callback: any, Product: ProductInterface) => {
    Product["updateDate"] = firebase.firestore.FieldValue.serverTimestamp();

    let docRefId = this.afs.collection("ProductCollection").ref.doc().id;
    Product["id"] = docRefId;
    let docRef = this.afs.collection("ProductCollection")
      .doc(docRefId).set(Product)
      .then(function (docRef) {
        callback();
      })
      .catch(function (error) {
        console.error("Error writing document3: ", error);
      });
  }



  getRelation = (callback: any, doRefresh) => {
    var self = this;
    if (doRefresh) {
      self.latestConnection = "";
    }
    if (self.latestConnection == "" || !self.latestConnection) {
      self._ConnectedData = new BehaviorSubject<ProductInterface[]>([]);
      self.ConnectedData = self._ConnectedData.asObservable();
    }

    let collectionName = "";
    let shareWithUserId = "";
    let shareWithCollection = "";
    if (localStorage.userType == "intermediary") {
      collectionName = "ReShareWithTimestampCollection";
      shareWithUserId = "reShareWithUserId",
        shareWithCollection = "ReShareWithCollection"
    } else {
      collectionName = "ShareWithTimestampCollection";
      shareWithUserId = "shareWithUserId",
        shareWithCollection = "ShareWithCollection"
    }
    if (self.latestConnection != "" && self.latestConnection != undefined) {
      var userRef = self.getCollection(collectionName, ref => ref
        .where(shareWithUserId, "==", localStorage.id)
        .where("logedInUserId", "==", self.brokerUserId)
        .where("fieldId", "==", localStorage.currentFieldKeyId)
        .orderBy('timestamp', 'desc')
        .startAfter(self.latestConnection)
        .limit(3))
    } else if (self.brokerUserId != localStorage.id) {
      var userRef = self.getCollection(collectionName, ref => ref
        .where(shareWithUserId, "==", localStorage.id)
        .where("logedInUserId", "==", self.brokerUserId)
        .where("fieldId", "==", localStorage.currentFieldKeyId)
        .orderBy('timestamp', 'desc')
        .limit(3))
    } else {
      var userRef = self.getCollection(collectionName, ref => ref
        .where(shareWithUserId, "==", localStorage.id)
        .where("fieldId", "==", localStorage.currentFieldKeyId)
        .orderBy('timestamp', 'desc')
        .limit(3))
    }

    userRef.subscribe(userData => {
      var loopIndexCount = 0;
      if (userData.length > 0) {
        if (userData[userData.length - 1]) {
          self.latestConnection = userData[userData.length - 1].doc;
        }
        var userObjectCheck = [];
        userData.forEach(function (data) {
          // And save it again for more queries

          var userObject = {};
          var query1 = self.afs.collection(collectionName).doc(data.id).collection("sellers").ref;
          query1.get().then(function (docArray) {
            if (!docArray.empty) {

              docArray.forEach(function (doc) {
                if (doc.exists) {
                  if (self._ConnectedData.value &&
                    self._ConnectedData.value.findIndex(x => x["userObj"].userId == doc.data().userId) == -1
                    && userObjectCheck.findIndex(x => x.userId == doc.data().userId) == -1) {
                    userObject = doc.data();
                    var userObjectCopy = userObject;
                    if (!userObjectCopy["selected"]) {
                      //userObjectCopy["selected"] = "";
                      userObjectCopy["selected"] = false;
                    }
                    var productsArray = [];
                    let connectionObject = {};
                    var productsUserObj = [];
                    userObjectCheck.push(userObject);
                    // var query2 = query1.doc(doc.data().userId).collection("products").limit(3)

                    if (localStorage.userType == "intermediary") {
                      var query2 = self.afs.collection(shareWithCollection).ref
                        .where(shareWithUserId, "==", localStorage.id)
                        //.where("userId", "==", selectedUserId)
                        .where("fieldId", "==", localStorage.currentFieldKeyId)
                        .where("productObject.userId", "==", doc.data().userId)
                        .orderBy('timestamp', 'desc')
                        .limit(3);

                    } else {
                      var query2 = self.afs.collection(shareWithCollection).ref
                        .where(shareWithUserId, "==", localStorage.id)
                        .where("userId", "==", self.brokerUserId)
                        .where("productObject.userId", "==", doc.data().userId)
                        .where("fieldId", "==", localStorage.currentFieldKeyId)
                        .orderBy('timestamp', 'desc')
                        .limit(3);
                    }

                    query2.get().then(function (productArray) {

                      if (!productArray.empty) {
                        productArray.forEach(function (product) {
                          productsArray.push(product.data()["productObject"]);
                        })

                        connectionObject['userObj'] = userObjectCopy;
                        connectionObject['products'] = productsArray;


                        productsUserObj.push(connectionObject);
                        // console.log("productsUserObj", productsUserObj)

                        const currentValue = self._ConnectedData.value;
                        // ... concat two arrays into single array
                        const updatedValue = [...currentValue, ...productsUserObj];

                        self._ConnectedData.next(updatedValue);
                      }
                      loopIndexCount++;
                      if (loopIndexCount == docArray.size) {
                        callback(true, connectionObject);
                      }
                    })
                  }
                }
              })
            }
          })
        })
      } else {
        callback(true, null);
      }
    })
  }

  getRelationLoadMore = (callback: any) => {
    var self = this;
    // self.latestConnection = "";
    let connectionObject = {};
    // var scoresRef = self.afs.collection("ShareWithTimestampCollection").ref
    //   .where("shareWithUserId", "==", localStorage.id)
    //   .orderBy('timestamp', 'desc')
    //   .limit(3);

    let collectionName = "";
    let shareWithUserId = "";
    let shareWithCollection = "";
    if (localStorage.userType == "intermediary") {
      collectionName = "ReShareWithTimestampCollection";
      shareWithUserId = "reShareWithUserId";
      shareWithCollection = "ReShareWithCollection";
    } else {
      collectionName = "ShareWithTimestampCollection";
      shareWithUserId = "shareWithUserId";
      shareWithCollection = "ShareWithCollection";
    }
    if (self.brokerUserId != localStorage.id) {
      var userRef = self.getCollection(collectionName, ref => ref
        .where(shareWithUserId, "==", localStorage.id)
        .where("logedInUserId", "==", self.brokerUserId)
        .where("fieldId", "==", localStorage.currentFieldKeyId)
        .orderBy('timestamp', 'desc')
        .startAfter(self.latestConnection)
        .limit(3))
    } else {
      var userRef = self.getCollection(collectionName, ref => ref
        .where(shareWithUserId, "==", localStorage.id)
        .where("fieldId", "==", localStorage.currentFieldKeyId)
        .orderBy('timestamp', 'desc')
        .startAfter(self.latestConnection)
        .limit(3))
    }

    // var userRef = self.getCollection('ShareWithTimestampCollection', ref => ref
    // .where("shareWithUserId", "==", localStorage.id)
    // .where("fieldId", "==", localStorage.currentFieldKeyId)
    // .orderBy('timestamp', 'desc')
    // .startAfter(self.latestConnection)
    // .limit(3))

    userRef.subscribe(data => {
      // scoresRef.get().then(function (querySnapshot) {
      var productsUserObj = [];
      var loopIndexCount = 0;
      if (data.length) {
        // And save it again for more queries
        if (data[data.length - 1]) {
          self.latestConnection = data[data.length - 1].doc;
        }
        // data[0]["selected"] = false;
        // connectionObject['userObj'] = data;
        // var doc = querySnapshot.docs[loopIndex];

        var object = data[0];
        //object["id"] = data[0];
        var query1 = self.afs.collection("ShareWithTimestampCollection").doc(data[0].id).collection("sellers").ref;
        query1.get().then(function (docArray) {
          if (!docArray.empty) {
            docArray.forEach(function (doc) {
              if (doc.exists) {
                connectionObject['userObj'] = doc.data();
                var productsArray = [];
                // var query2 = query1.doc(doc.data().userId).collection("products").limit(3)
                if (localStorage.userType == "intermediary") {
                  var query2 = self.afs.collection(shareWithCollection).ref
                    .where(shareWithUserId, "==", localStorage.id)
                    //.where("userId", "==", selectedUserId)
                    .where("fieldId", "==", localStorage.currentFieldKeyId)
                    .where("productObject.userId", "==", doc.data().userId)
                    .orderBy('timestamp', 'desc')
                    .limit(3);

                } else {
                  var query2 = self.afs.collection(shareWithCollection).ref
                    .where(shareWithUserId, "==", localStorage.id)
                    .where("userId", "==", self.brokerUserId)
                    .where("productObject.userId", "==", doc.data().userId)
                    .where("fieldId", "==", localStorage.currentFieldKeyId)
                    .orderBy('timestamp', 'desc')
                    .limit(3);
                }


                query2.get().then(function (productArray) {
                  if (!productArray.empty) {
                    productArray.forEach(function (product) {
                      productsArray.push(product.data()["productObject"]);
                    })
                    connectionObject['products'] = productsArray;


                    productsUserObj.push(connectionObject);
                    console.log("productsUserObj", productsUserObj)

                    const currentValue = self._ConnectedData.value;
                    // ... concat two arrays into single array
                    const updatedValue = [...currentValue, ...productsUserObj];

                    self._ConnectedData.next(updatedValue);
                  }
                  loopIndexCount++;
                  // self._ConnectedData.next(productsUserObj);
                  if (loopIndexCount == docArray.size) {
                    callback(true, connectionObject);
                  }
                })
              }
            })
          }
        })
      }
    })
  }

  async getAlbumFirst(selectedUserId, brokerId, categoryKeyId, subCategoryKeyId, selectedUserObj) {
    var self = this;
    var dataProductId;
    var albumquery: any;
    let collectionName = "";
    let shareWithUserId = "";

    self._albumData = new BehaviorSubject<ProductInterface[]>([]);
    self.albumData = self._albumData.asObservable();

    if (localStorage.userType == "intermediary") {
      collectionName = "ReShareWithAlbumCollection";
      shareWithUserId = "reShareWithUserId"
    } else {
      collectionName = "ShareWithAlbumCollection";
      shareWithUserId = "shareWithUserId"
    }

    if (selectedUserId != localStorage.id) {
      if (localStorage.userType == "intermediary" || (selectedUserObj && (selectedUserObj.userType == "intermediary" || selectedUserObj.userType == "seller") && localStorage.userType == "buyer")) {
        if (selectedUserId != undefined && selectedUserId != "") {
          albumquery = self.getCollection(collectionName, ref => ref
            .where(shareWithUserId, "==", localStorage.id)
            //.where("userId", "==", selectedUserId)
            .where("fieldId", "==", localStorage.currentFieldKeyId)
            .where("productObject.userId", "==", selectedUserId)
            .orderBy('timestamp', 'desc')
            .limit(12));
        } else if (categoryKeyId != undefined && categoryKeyId != "") {
          albumquery = self.getCollection(collectionName, ref => ref
            .where(shareWithUserId, "==", localStorage.id)
            .where("categoryId", "==", categoryKeyId)
            .where("fieldId", "==", localStorage.currentFieldKeyId)
            .orderBy('timestamp', 'desc')
            .limit(12));
        }
      } else {
        if (selectedUserId != undefined && selectedUserId != "") {
          albumquery = self.getCollection(collectionName, ref => ref
            .where(shareWithUserId, "==", localStorage.id)
            .where("userId", "==", self.brokerUserId)
            .where("productObject.userId", "==", selectedUserId)
            .where("fieldId", "==", localStorage.currentFieldKeyId)
            .orderBy('timestamp', 'desc')
            .limit(12));
        } else if (categoryKeyId != undefined && categoryKeyId != "") {
          albumquery = self.getCollection(collectionName, ref => ref
            .where(shareWithUserId, "==", localStorage.id)
            .where("userId", "==", self.brokerUserId)
            .where("categoryId", "==", categoryKeyId)
            .where("fieldId", "==", localStorage.currentFieldKeyId)
            .orderBy('timestamp', 'desc')
            .limit(12));
        }
      }
    } else {
      albumquery = self.getCollection('ProductsAlbumCollection', ref => ref
      .where("userId", "==", localStorage.id)
      .where("fieldId", "==", localStorage.currentFieldKeyId)
      .orderBy('timestamp', 'desc')
      .limit(12));
    }

    if (albumquery) {
      albumquery.subscribe(data => {
        var albumUserObj = [];
        if (data[data.length - 1]) {
          self.latestAlbum = data[data.length - 1].doc;
        }
        data.forEach(async (data1: "id") => {
          if (data1['productObject']) {
            dataProductId = data1['productObject'].productId;
          } else {
            dataProductId = data1['productId'];
          }
          //get images of productIds from productCollection
          const myPromise = self.fetchProductImageCollection((dataProductId));
          myPromise.then(imageList => {
            data1["albumProdImages"] = imageList;
            // get logedin user album
            if (self._albumData.value.findIndex(x => x["id"] == data1["id"]) == -1) {
              delete data1['doc'];
              albumUserObj.push(data1);
            }
            const currentValue = self._albumData.value;
            const updatedValue = [...albumUserObj];
            self._albumData.next(updatedValue);
          });
        });
      });
    } else {
      //self.navCtrl.navigateRoot('/home');
    }
  }

  //get album relation folders on home page
  async getAlbumRelation(doRefresh) {
    var self = this;
    if (doRefresh) {
      self.latestConnection = "";
    }
    if (self.latestConnection == "" || !self.latestConnection) {
      self._ConnectedData = new BehaviorSubject<ProductInterface[]>([]);
      self.ConnectedData = self._ConnectedData.asObservable();
    }

    let collectionName = "";
    let shareWithUserId = "";
    let shareWithCollection = "";
    if (localStorage.userType == "intermediary") {
      collectionName = "ReShareWithAlbumTimestampCollection";
      shareWithUserId = "reShareWithUserId",
        shareWithCollection = "ReShareWithAlbumCollection"
    } else {
      collectionName = "ShareWithAlbumTimestampCollection";
      shareWithUserId = "shareWithUserId",
        shareWithCollection = "ShareWithAlbumCollection"
    }
    if (self.latestConnection != "" && self.latestConnection != undefined) {
      var userRef = self.getCollection(collectionName, ref => ref
        .where(shareWithUserId, "==", localStorage.id)
        .where("logedInUserId", "==", self.brokerUserId)
        .where("fieldId", "==", localStorage.currentFieldKeyId)
        .orderBy('timestamp', 'desc')
        .startAfter(self.latestConnection)
        .limit(3))
    } else if (self.brokerUserId != localStorage.id) {
      var userRef = self.getCollection(collectionName, ref => ref
        .where(shareWithUserId, "==", localStorage.id)
        .where("logedInUserId", "==", self.brokerUserId)
        .where("fieldId", "==", localStorage.currentFieldKeyId)
        .orderBy('timestamp', 'desc')
        .limit(3))
    } else {
      var userRef = self.getCollection(collectionName, ref => ref
        .where(shareWithUserId, "==", localStorage.id)
        .where("fieldId", "==", localStorage.currentFieldKeyId)
        .orderBy('timestamp', 'desc')
        .limit(3))
    }

    userRef.subscribe(userData => {
      if (userData.length > 0) {
        if (userData[userData.length - 1]) {
          self.latestConnection = userData[userData.length - 1].doc;
        }
        var userObjectCheck = [];
        userData.forEach(function (data) {
          // And save it again for more queries

          var userObject = {};
          var query1 = self.afs.collection(collectionName).doc(data.id).collection("sellers").ref;
          query1.get().then(function (docArray) {
            if (!docArray.empty) {

              docArray.forEach(function (doc) {
                if (doc.exists) {
                  if (self._ConnectedData.value &&
                    self._ConnectedData.value.findIndex(x => x["userObj"].userId == doc.data().userId) == -1
                    && userObjectCheck.findIndex(x => x.userId == doc.data().userId) == -1) {
                    userObject = doc.data();
                    var userObjectCopy = userObject;
                    if (!userObjectCopy["selected"]) {
                      //userObjectCopy["selected"] = "";
                      userObjectCopy["selected"] = false;
                    }
                    var productsArray = [];
                    let connectionObject = {};
                    var productsUserObj = [];
                    userObjectCheck.push(userObject);
                    // var query2 = query1.doc(doc.data().userId).collection("products").limit(3)

                    if (localStorage.userType == "intermediary") {
                      var query2 = self.afs.collection(shareWithCollection).ref
                        .where(shareWithUserId, "==", localStorage.id)
                        //.where("userId", "==", selectedUserId)
                        .where("fieldId", "==", localStorage.currentFieldKeyId)
                        .where("productObject.userId", "==", doc.data().userId)
                        .orderBy('timestamp', 'desc')
                        .limit(3);

                    } else {
                      var query2 = self.afs.collection(shareWithCollection).ref
                        .where(shareWithUserId, "==", localStorage.id)
                        .where("userId", "==", self.brokerUserId)
                        .where("productObject.userId", "==", doc.data().userId)
                        .where("fieldId", "==", localStorage.currentFieldKeyId)
                        .orderBy('timestamp', 'desc')
                        .limit(3);
                    }
                    query2.get().then(function (productArray) {

                      if (!productArray.empty) {
                        // productArray.forEach(function (product) {
                        //   productsArray.push(product.data()["productObject"]);
                        // })

                        productArray.forEach(async (product) => {
                          let productData = product.data();
                          //get images of productIds from productCollection
                          const myPromise = self.fetchProductImageCollection((productData["productObject"]["productId"]));
                          myPromise.then(imageList => {
                            productData["productObject"]["albumProdImages"] = imageList;
                            // get logedin user album
                            if (self._ConnectedData.value.findIndex(x => x["id"] == productData["productObject"]["id"]) == -1) {
                              //delete data1['doc'];
                              productsArray.push(productData["productObject"]);
                            }
                            connectionObject['userObj'] = userObjectCopy;
                            connectionObject['folders'] = productsArray;
                          });
                        });
                        if (connectionObject) {
                          productsUserObj.push(connectionObject);
                          const currentValue = self._ConnectedData.value;
                          //const updatedValue = [ ...productsUserObj];
                          // ... concat two arrays into single array
                          const updatedValue = [...currentValue, ...productsUserObj];
                          self._ConnectedData.next(updatedValue);
                        }
                      }
                    })
                  }
                }
              })
            }
          })
        })
      } else {
        //callback(true, null);
      }
    })
  }

  //fetchProductImageCollection
  async fetchProductImageCollection(productIdList) {
    let self = this;
    var productImgList = [];
    var maxLength = 0;
    if (productIdList.length >= 4) {
      maxLength = 4;
    } else {
      maxLength = productIdList.length;
    }
    var index = 0;
    var myPromise = new Promise((resolve, reject) => {
      for (var i = 0; i < maxLength; i++) {
        if (productIdList[i] != undefined) {
          var docRef = this.afs.collection("ProductCollection").doc(productIdList[i]).ref;
          docRef.get().then(function (doc) {
            index++;
            if (doc.exists) {
              var product = doc.data();
              if (product.ImageCollection != undefined) {
                productImgList.push(product.ImageCollection[0].url);
                if (index == maxLength) {
                  // callback if productIdList contains 4
                  resolve(productImgList);
                }
              }
            } else {
              if (index == maxLength) {
                // callback if productIdList contains 4
                resolve(productImgList);
              }
              // doc.data() will be undefined in this case
            }
          }).catch(function (error) {
          });
        } else {
          // callback if productIdList < 4
          resolve(productImgList);
        }
      }
    });
    return myPromise;
  }

  getProductFirst(selectedUserId, brokerId, categoryKeyId, subCategoryKeyId, selectedUserObj) {
    var self = this;
    let collectionName = "";
    let shareWithUserId = "";


    self._productData = new BehaviorSubject<ProductInterface[]>([]);
    self.productData = self._productData.asObservable();


    var scoresRefConn: any;
    if (localStorage.userType == "intermediary") {
      collectionName = "ReShareWithCollection";
      shareWithUserId = "reShareWithUserId"
    } else {
      collectionName = "ShareWithCollection";
      shareWithUserId = "shareWithUserId"
    }

    if (selectedUserId != localStorage.id) {
      if (localStorage.userType == "intermediary" || (selectedUserObj && (selectedUserObj.userType == "intermediary" || selectedUserObj.userType == "seller") && localStorage.userType == "buyer")) {
        if (selectedUserId != undefined && selectedUserId != "") {
          scoresRefConn = self.getCollection(collectionName, ref => ref
            .where(shareWithUserId, "==", localStorage.id)
            //.where("userId", "==", selectedUserId)
            .where("fieldId", "==", localStorage.currentFieldKeyId)
            .where("productObject.userId", "==", selectedUserId)
            .orderBy('timestamp', 'desc')
            .limit(15));
        } else if (categoryKeyId != undefined && categoryKeyId != "") {
          scoresRefConn = self.getCollection(collectionName, ref => ref
            .where(shareWithUserId, "==", localStorage.id)
            .where("categoryId", "==", categoryKeyId)
            .where("fieldId", "==", localStorage.currentFieldKeyId)
            .orderBy('timestamp', 'desc')
            .limit(15));
        }
      } else {
        if (selectedUserId != undefined && selectedUserId != "") {
          scoresRefConn = self.getCollection(collectionName, ref => ref
            .where(shareWithUserId, "==", localStorage.id)
            .where("userId", "==", self.brokerUserId)
            .where("productObject.userId", "==", selectedUserId)
            .where("fieldId", "==", localStorage.currentFieldKeyId)
            .orderBy('timestamp', 'desc')
            .limit(15));
        } else if (categoryKeyId != undefined && categoryKeyId != "") {
          scoresRefConn = self.getCollection(collectionName, ref => ref
            .where(shareWithUserId, "==", localStorage.id)
            .where("userId", "==", self.brokerUserId)
            .where("categoryId", "==", categoryKeyId)
            .where("fieldId", "==", localStorage.currentFieldKeyId)
            .orderBy('timestamp', 'desc')
            .limit(15));
        }
      }
    } else {
      scoresRefConn = self.getCollection('ProductCollection', ref => ref
        .where("userId", "==", localStorage.id)
        .where("fieldId", "==", localStorage.currentFieldKeyId)
        .orderBy('updateDate', 'desc')
        .limit(15))
    }


    if (scoresRefConn) {
      scoresRefConn.subscribe(data => {
        var productsUserObj = [];
        if (data[data.length - 1]) {
          self.latestProduct = data[data.length - 1].doc;
        }
        data.forEach((data1: "id") => {
          if (data1["productId"] != undefined) {
            if (self._productData.value.findIndex(x => x["id"] == data1["productId"]) == -1) {
              data1["productObject"].shareByUserId = data1["userId"];
              data1["productObject"].shareByUserType = data1["userType"];
              data1["productObject"].shareByPersonName = data1["personName"];
              data1["productObject"].shareByFirmName = data1["firmName"];
              data1["productObject"].shareTimeStamp = data1['timestamp'];
              data1['productObject'].shareTimeUnit = data1['shareTimeUnit'] ? data1['shareTimeUnit'] : '';
              data1['productObject'].shareTimeValue = data1['shareTimeValue'] ? data1['shareTimeValue'] : '';

              productsUserObj.push(data1["productObject"]);
              // self._productData.next(productsUserObj);
            }
          } else {
            // get logedin user products
            if (self._productData.value.findIndex(x => x["id"] == data1["id"]) == -1) {
              productsUserObj.push(data1);
            }
          }
        });
        const currentValue = self._productData.value;
        const updatedValue = [...currentValue, ...productsUserObj];
        self._productData.next(updatedValue);
        // console.log('self._productData ', self._productData);
      });
    } else {
      self.navCtrl.navigateRoot('/home');
    }
  }

  getProductLoadMore(selectedUserId, brokerId, categoryKeyId, subCategoryKeyId, selectedUserObj) {

    var self = this;
    var scoresRefConn: any;
    let collectionName = "";
    let shareWithUserId = "";
    if (localStorage.userType == "intermediary") {
      collectionName = "ReShareWithCollection";
      shareWithUserId = "reShareWithUserId"
    } else {
      collectionName = "ShareWithCollection";
      shareWithUserId = "shareWithUserId"
    }
    if (selectedUserId != localStorage.id) {
      if (localStorage.userType == "intermediary" || ((selectedUserObj.userType == "intermediary" || selectedUserObj.userType == "seller") && localStorage.userType == "buyer")) {
        if (self.latestProduct == "" || !self.latestProduct) {
          if (selectedUserId != undefined && selectedUserId != "") {
            scoresRefConn = self.getCollection(collectionName, ref => ref
              .where(shareWithUserId, "==", localStorage.id)
              //.where("userId", "==", selectedUserId)
              .where("fieldId", "==", localStorage.currentFieldKeyId)
              .where("productObject.userId", "==", selectedUserId)
              .orderBy('timestamp', 'desc')
              .limit(10));
          } else if (categoryKeyId != undefined && categoryKeyId != "") {
            scoresRefConn = self.getCollection(collectionName, ref => ref
              .where(shareWithUserId, "==", localStorage.id)
              .where("categoryId", "==", categoryKeyId)
              .where("fieldId", "==", localStorage.currentFieldKeyId)
              .orderBy('timestamp', 'desc')
              .limit(10));
          }
        } else {
          if (selectedUserId != undefined && selectedUserId != "") {
            scoresRefConn = self.getCollection(collectionName, ref => ref
              .where(shareWithUserId, "==", localStorage.id)
              .where("userId", "==", self.brokerUserId)
              .where("productObject.userId", "==", selectedUserId)
              .where("fieldId", "==", localStorage.currentFieldKeyId)
              .orderBy('timestamp', 'desc')
              .startAfter(self.latestProduct)
              .limit(10));
          } else if (categoryKeyId != undefined && categoryKeyId != "") {
            scoresRefConn = self.getCollection(collectionName, ref => ref
              .where(shareWithUserId, "==", localStorage.id)
              .where("userId", "==", self.brokerUserId)
              .where("categoryId", "==", categoryKeyId)
              .where("fieldId", "==", localStorage.currentFieldKeyId)
              .orderBy('timestamp', 'desc')
              .startAfter(self.latestProduct)
              .limit(10));
          }
        }
      } else {
        if (self.latestProduct == "" || !self.latestProduct) {
          if (selectedUserId != undefined && selectedUserId != "") {
            scoresRefConn = self.getCollection(collectionName, ref => ref
              .where(shareWithUserId, "==", localStorage.id)
              .where("userId", "==", self.brokerUserId)
              .where("productObject.userId", "==", selectedUserId)
              .where("fieldId", "==", localStorage.currentFieldKeyId)
              .orderBy('timestamp', 'desc')
              .limit(10));
          } else if (categoryKeyId != undefined && categoryKeyId != "") {
            scoresRefConn = self.getCollection(collectionName, ref => ref
              .where(shareWithUserId, "==", localStorage.id)
              .where("categoryId", "==", categoryKeyId)
              .where("fieldId", "==", localStorage.currentFieldKeyId)
              .orderBy('timestamp', 'desc')
              .limit(10));
          }
        } else {
          if (selectedUserId != undefined && selectedUserId != "") {
            scoresRefConn = self.getCollection(collectionName, ref => ref
              .where(shareWithUserId, "==", localStorage.id)
              .where("userId", "==", self.brokerUserId)
              .where("productObject.userId", "==", selectedUserId)
              .where("fieldId", "==", localStorage.currentFieldKeyId)
              .orderBy('timestamp', 'desc')
              .startAfter(self.latestProduct)
              .limit(10));
          } else if (categoryKeyId != undefined && categoryKeyId != "") {
            scoresRefConn = self.getCollection(collectionName, ref => ref
              .where('shareWithUserId', "==", localStorage.id)
              .where("userId", "==", self.brokerUserId)
              .where("categoryId", "==", categoryKeyId)
              .where("fieldId", "==", localStorage.currentFieldKeyId)
              .orderBy('timestamp', 'desc')
              .startAfter(self.latestProduct)
              .limit(10));
          }
        }
      }
    } else {
      scoresRefConn = self.getCollection('ProductCollection', ref => ref
        .where("userId", "==", localStorage.id)
        .where("fieldId", "==", localStorage.currentFieldKeyId)
        .orderBy('updateDate', 'desc')
        .startAfter(self.latestProduct)
        .limit(15))
    }
    if (scoresRefConn) {
      scoresRefConn.subscribe(data => {
        var productsUserObj = [];
        if (data[data.length - 1]) {
          self.latestProduct = data[data.length - 1].doc;
        }
        data.forEach((data1: "id") => {
          if (data1["productId"] != undefined) {
            if (self._productData.value.findIndex(x => x["id"] == data1["productId"]) == -1) {
              productsUserObj.push(data1["productObject"]);
              // self._productData.next(productsUserObj);
            }
          } else {
            // get logedin user products
            if (self._productData.value.findIndex(x => x["id"] == data1["id"]) == -1) {
              productsUserObj.push(data1);
            }
          }
        });
        const currentValue = self._productData.value;
        //   // ... concat two arrays into single array
        const updatedValue = [...currentValue, ...productsUserObj];
        self._productData.next(updatedValue);
        console.log('self._productData ', self._productData);
      });
    } else {
      self.navCtrl.navigateRoot('/home');
    }
  }

  getAlbumLoadMore(selectedUserId, brokerId, categoryKeyId, subCategoryKeyId, selectedUserObj) {

    var self = this;
    var scoresRefConn: any;
    var dataProductId;
    let collectionName = "";
    let shareWithUserId = "";

    if (localStorage.userType == "intermediary") {
      collectionName = "ReShareWithAlbumCollection";
      shareWithUserId = "reShareWithUserId"
    } else {
      collectionName = "ShareWithAlbumCollection";
      shareWithUserId = "shareWithUserId"
    }
    if(selectedUserId  != localStorage.id) {
      if (localStorage.userType == "intermediary" || ((selectedUserObj.userType == "intermediary" || selectedUserObj.userType == "seller") && localStorage.userType == "buyer" )) {
        if (self.latestAlbum == "" || !self.latestAlbum) {
          if (selectedUserId != undefined && selectedUserId != "") {
            scoresRefConn = self.getCollection(collectionName, ref => ref
              .where(shareWithUserId, "==", localStorage.id)
              //.where("userId", "==", selectedUserId)
              .where("fieldId", "==", localStorage.currentFieldKeyId)
              .where("productObject.userId", "==", selectedUserId)
              .orderBy('timestamp', 'desc')
              .limit(10));
          } else if (categoryKeyId != undefined && categoryKeyId != "") {
            scoresRefConn = self.getCollection(collectionName, ref => ref
              .where(shareWithUserId, "==", localStorage.id)
              .where("categoryId", "==", categoryKeyId)
              .where("fieldId", "==", localStorage.currentFieldKeyId)
              .orderBy('timestamp', 'desc')
              .limit(10));
          }
        } else {
          if (selectedUserId != undefined && selectedUserId != "") {
            scoresRefConn = self.getCollection(collectionName, ref => ref
              .where(shareWithUserId, "==", localStorage.id)
              .where("userId", "==",  self.brokerUserId)
              .where("productObject.userId", "==", selectedUserId)
              .where("fieldId", "==", localStorage.currentFieldKeyId)
              .orderBy('timestamp', 'desc')
              .startAfter(self.latestAlbum)
              .limit(10));
          } else if (categoryKeyId != undefined && categoryKeyId != "") {
            scoresRefConn = self.getCollection(collectionName, ref => ref
              .where(shareWithUserId, "==", localStorage.id)
              .where("userId", "==",  self.brokerUserId)
              .where("categoryId", "==", categoryKeyId)
              .where("fieldId", "==", localStorage.currentFieldKeyId)
              .orderBy('timestamp', 'desc')
              .startAfter(self.latestAlbum)
              .limit(10));
          }
        }
      } else {
        if (self.latestAlbum == "" || !self.latestAlbum) {
          if (selectedUserId != undefined && selectedUserId != "") {
            scoresRefConn = self.getCollection(collectionName, ref => ref
              .where(shareWithUserId, "==", localStorage.id)
              .where("userId", "==",  self.brokerUserId)
              .where("productObject.userId", "==", selectedUserId)
              .where("fieldId", "==", localStorage.currentFieldKeyId)
              .orderBy('timestamp', 'desc')
              .limit(10));
          } else if (categoryKeyId != undefined && categoryKeyId != "") {
            scoresRefConn = self.getCollection(collectionName, ref => ref
              .where(shareWithUserId, "==", localStorage.id)
              .where("categoryId", "==", categoryKeyId)
              .where("fieldId", "==", localStorage.currentFieldKeyId)
              .orderBy('timestamp', 'desc')
              .limit(10));
          }
        } else {
          if (selectedUserId != undefined && selectedUserId != "") {
            scoresRefConn = self.getCollection(collectionName, ref => ref
              .where(shareWithUserId, "==", localStorage.id)
              .where("userId", "==",  self.brokerUserId)
              .where("productObject.userId", "==", selectedUserId)
              .where("fieldId", "==", localStorage.currentFieldKeyId)
              .orderBy('timestamp', 'desc')
              .startAfter(self.latestAlbum)
              .limit(10));
          } else if (categoryKeyId != undefined && categoryKeyId != "") {
            scoresRefConn = self.getCollection(collectionName, ref => ref
              .where('shareWithUserId', "==", localStorage.id)
              .where("userId", "==",  self.brokerUserId)
              .where("categoryId", "==", categoryKeyId)
              .where("fieldId", "==", localStorage.currentFieldKeyId)
              .orderBy('timestamp', 'desc')
              .startAfter(self.latestAlbum)
              .limit(10));
          }
        }
      }
    } else {
      scoresRefConn = self.getCollection('ProductsAlbumCollection', ref => ref
      .where("userId", "==", localStorage.id)
      .where("fieldId", "==", localStorage.currentFieldKeyId)
      .orderBy('timestamp', 'desc')
      .startAfter(self.latestAlbum)
      .limit(15))
    }
    if (scoresRefConn) {
      scoresRefConn.subscribe(data => {
        var albumUserObj = [];
        if (data[data.length - 1]) {
          self.latestAlbum = data[data.length - 1].doc;
        }
        data.forEach(async (data1: "id") => {
          if(data1['productObject']) {
            dataProductId = data1['productObject'].productId;
          } else {
            dataProductId = data1['productId'];
          }
          //get images of productIds from productCollection
          const myPromise = self.fetchProductImageCollection((dataProductId));
          myPromise.then(imageList => {
            data1["albumProdImages"] = imageList;
            albumUserObj = [];
            // get logedin user album
            if (self._albumData.value.findIndex(x => x["id"] == data1["id"]) == -1) {
              delete data1['doc'];
              albumUserObj.push(data1);
            }
            const currentValue = self._albumData.value;
            const updatedValue = [...currentValue, ...albumUserObj];
            self._albumData.next(updatedValue);
          });
        });
      });
    } else {
      self.navCtrl.navigateRoot('/home');
    }
  }

  getProductFilter(filter) {
    var self = this;
    self._productData = new BehaviorSubject<ProductInterface[]>([]);
    self.productData = self._productData.asObservable();
    var scoresRef;

    if (filter != null && filter != "" && filter != "all") {
      scoresRef = self.getCollection('ProductCollection', ref => ref
        .orderBy('updateDate', 'desc')
        .where("userId", "==", localStorage.id)
        .where("productType", "==", "public")
        .where('userCategoryId', '==', filter)
        .where("fieldId", "==", localStorage.currentFieldKeyId)
        //.startAfter(self.latestProduct)
        .limit(3))
    } else {
      scoresRef = self.getCollection('ProductCollection', ref => ref
        .orderBy('updateDate', 'desc')
        .where("userId", "==", localStorage.id)
        .where("productType", "==", "public")
        .where("fieldId", "==", localStorage.currentFieldKeyId)
        //.startAfter(self.latestProduct)
        .limit(3))
    }

    scoresRef.subscribe(data => {
      if (data[data.length - 1]) {
        self.latestProduct = data[data.length - 1].doc;
      }
      self._productData.next(data);
      console.log('this.productData ', this.productData);
    });
  }


  deleteProductFromGCP(callback: any, productkeyId: any, isOutOfStock: any) {
    var self = this;
    var url: any;
    //here we create the API URL and header for pass the data in the API 
    if (productkeyId) {

      if (isOutOfStock) {
        let query = self.afs.collection("ProductCollection").ref.doc(productkeyId)
          .collection("ShareWithCollection").get().then(function (querySnapshot) {
            if (!querySnapshot.empty) {
              querySnapshot.forEach(function (doc) {
                // doc.data() is never undefined for query doc snapshots
                self.afs.collection("ShareWithCollection").ref
                  //.where("userId"          ,"==",  localStorage.id)
                  .where("shareWithUserId", "==", doc.data().userId)
                  .where("fieldId", "==", localStorage.currentFieldKeyId)
                  .where("productId", "==", productkeyId)
                  .get().then(function (querySnapsort1) {
                    if (!querySnapsort1.empty) {
                      querySnapsort1.docs[0].ref.delete().then(function () {
                        // callback(true);
                        var query3 = self.afs.collection("ShareWithTimestampCollection").ref
                          .where("logedInUserId", "==", localStorage.id)
                          .where("fieldId", "==", localStorage.currentFieldKeyId)
                          .where("shareWithUserId", "==", doc.data().userId)
                          .get().then(function (querySnapshot) {
                            if (!querySnapshot.empty) {
                              querySnapshot.forEach(function (data) {
                                // And save it again for more queries
                                var userObject = {};
                                var query4 = self.afs.collection("ShareWithTimestampCollection").doc(data.id)
                                  .collection("sellers").doc(localStorage.id).collection("products").doc(productkeyId).ref
                                query4.get().then(function (docArray) {
                                  if (docArray.exists) {
                                    //deleted matched product
                                    docArray.ref.delete();
                                  }
                                })
                              })
                            }
                          }).catch(function (error) {
                            console.log("create an index", error);
                          });
                      }).catch(function (error) {
                        // callback(false);
                      });
                    }
                  }).catch(function (error) {
                    console.log("Error Documents :", error);
                  });
              });
            }
            if (localStorage.userType == "seller") {
              var query2 = self.afs.collection("ReShareWithCollection").ref
                .where("userId", "==", localStorage.id)
                .where("fieldId", "==", localStorage.currentFieldKeyId)
                // .where("reShareWithUserId", "==", userId)
                .where("productId", "==", productkeyId)
                .get().then(function (querySnapshot) {
                  if (!querySnapshot.empty) {
                    querySnapshot.docs[0].ref.delete().then(function () {
                      var query3 = self.afs.collection("ReShareWithTimestampCollection").ref
                        .where("logedInUserId", "==", localStorage.id)
                        .where("fieldId", "==", localStorage.currentFieldKeyId)
                        //.where("reShareWithUserId", "==", userId)
                        .get().then(function (querySnapshot) {
                          if (!querySnapshot.empty) {
                            querySnapshot.forEach(function (data) {
                              // And save it again for more queries
                              var userObject = {};
                              var query4 = self.afs.collection("ReShareWithTimestampCollection").doc(data.id)
                                .collection("sellers").doc(localStorage.id).collection("products").doc(productkeyId).ref
                              query4.get().then(function (docArray) {
                                if (docArray.exists) {
                                  //deleted matched product
                                  docArray.ref.delete();
                                }
                              })
                            })
                          }
                        }).catch(function (error) {
                          console.log("create an index", error);
                        });
                    })
                  }
                }).catch(function (error) {
                  console.log("create an index", error);
                });
            }
          }).catch(function (error) {
            console.log("Error Documnet", error);
          })


        // Delet prod
        self.afs.collection("ProductCollection").ref.doc(productkeyId).delete().then(function () {
        }).catch(function (error) {
          console.error("Error removing document: ", error);
        });

        callback(true);
      } else {
        self.afs.collection("ProductCollection").ref.doc(productkeyId).update({
          "isDeleted": true,
          "updateDate": new Date().getTime()
        })
          .then(function () {
          })
          .catch(function (error) {
            // The document probably doesn't exist.
            console.error("Error updating document: ", error);
          });
      }

      //delete product from ProductRefCollection
      var objectData = {};
      if (isOutOfStock) {
        var productRef: any;
        self.addUserActivity({
          fireFor: "DELETE_PRODUCT",
          object: objectData
        });
      } else {
        self.addUserActivity({
          fireFor: "OUT_OF_STOCK_PRODUCT",
          object: objectData
        });
      }
      callback(true, true);
    } else {
      callback(false, false);
    }
  }


  unshareProduct(productkeyId) {
    const self = this;
    let query = self.afs.collection("ProductCollection").ref.doc(productkeyId)
      .collection("ShareWithCollection").get().then(function (querySnapshot) {
        if (!querySnapshot.empty) {
          querySnapshot.forEach(function (doc) {
            // doc.data() is never undefined for query doc snapshots
            self.afs.collection("ShareWithCollection").ref
              //.where("userId"          ,"==",  localStorage.id)
              .where("shareWithUserId", "==", doc.data().userId)
              .where("fieldId", "==", localStorage.currentFieldKeyId)
              .where("productId", "==", productkeyId)
              .get().then(function (querySnapsort1) {
                if (!querySnapsort1.empty) {
                  querySnapsort1.docs[0].ref.delete().then(function () {

                    // Start remove product from cart if added
                    self.afs.collection("UserCollection").doc(doc.data().userId)
                      .collection("CartListCollection").ref
                      .where("productOrAlbumOrCatalogId", "==", productkeyId)
                      .get().then(function (querySnapshotCart) {
                        if (!querySnapshotCart.empty) {
                          querySnapshotCart.docs[0].ref.delete().then(function () {
                            localStorage.logendInUserCartCount--;

                          }).catch(function (error) {

                            console.log("create an index", error);
                          });
                        }
                      }).catch(function (error) {
                        console.log("create an index", error);
                      });
                    // callback(true);
                    var query3 = self.afs.collection("ShareWithTimestampCollection").ref
                      .where("logedInUserId", "==", localStorage.id)
                      .where("fieldId", "==", localStorage.currentFieldKeyId)
                      .where("shareWithUserId", "==", doc.data().userId)
                      .get().then(function (querySnapshot) {
                        if (!querySnapshot.empty) {
                          querySnapshot.forEach(function (data) {
                            // And save it again for more queries
                            var userObject = {};
                            var query4 = self.afs.collection("ShareWithTimestampCollection").doc(data.id)
                              .collection("sellers").doc(localStorage.id).collection("products").doc(productkeyId).ref
                            query4.get().then(function (docArray) {
                              if (docArray.exists) {
                                //deleted matched product
                                docArray.ref.delete();
                              }
                            })
                          })
                        }
                      }).catch(function (error) {
                        console.log("create an index", error);
                      });
                  }).catch(function (error) {
                    // callback(false);
                  });
                }
              }).catch(function (error) {
                console.log("Error Documents :", error);
              });
          });
        }
        var query2 = self.afs.collection("ReShareWithCollection").ref
          .where("userId", "==", localStorage.id)
          .where("fieldId", "==", localStorage.currentFieldKeyId)
          // .where("reShareWithUserId", "==", userId)
          .where("productId", "==", productkeyId)
          .get().then(function (querySnapshot) {
            if (!querySnapshot.empty) {
              querySnapshot.docs[0].ref.delete().then(function () {
                var query3 = self.afs.collection("ReShareWithTimestampCollection").ref
                  .where("logedInUserId", "==", localStorage.id)
                  .where("fieldId", "==", localStorage.currentFieldKeyId)
                  //.where("reShareWithUserId", "==", userId)
                  .get().then(function (querySnapshot) {
                    if (!querySnapshot.empty) {
                      querySnapshot.forEach(function (data) {
                        // And save it again for more queries
                        var userObject = {};
                        var query4 = self.afs.collection("ReShareWithTimestampCollection").doc(data.id)
                          .collection("sellers").doc(localStorage.id).collection("products").doc(productkeyId).ref
                        query4.get().then(function (docArray) {
                          if (docArray.exists) {
                            //deleted matched product
                            docArray.ref.delete();
                          }
                        })
                      })
                    }
                  }).catch(function (error) {
                    console.log("create an index", error);
                  });
              })
            }
          }).catch(function (error) {
            console.log("create an index", error);
          });
      }).catch(function (error) {
        console.log("Error Documnet", error);
      })
  }

  updateSharedProduct(productObj) {
    const self = this;
    this.afs.collection("ShareWithCollection").ref.where('productId', '==', productObj.id).get().then(function (querySnapshot) {
      if (!querySnapshot.empty) {
        querySnapshot.forEach(function (doc) {
          self.afs.collection("ShareWithCollection").doc(doc.id).update({
            'productObject': productObj
          });
        });
      }
    });
  }

  updateReShareProduct(productObj) {
    const self = this;
    this.afs.collection("ReShareWithCollection").ref.where('productId', '==', productObj.id).get().then(function (querySnapshot) {
      if (!querySnapshot.empty) {
        querySnapshot.forEach(function (doc) {
          self.afs.collection("ReShareWithCollection").doc(doc.id).update({
            'productObject': productObj
          });
        });
      }
    });
  }



  //fetch user relations 
  getBuyerUserRel(callback, callFor) {
    var self = this;
    self._ConnectedBuyerData = new BehaviorSubject<ProductInterface[]>([]);
    self.ConnectedBuyerData = self._ConnectedBuyerData.asObservable();
    switch (callFor) {
      case "send":
        let sendCollection = self.logedInUserData["RelationSendCollection-" + localStorage.currentFieldKeyId]
        if (sendCollection.length >= 0) {
          sendCollection.forEach(userId => {
            var userObj = [];
            self.afs.collection("UserCollection").ref
              .where("id", "==", userId)
              .where("userType", 'in', ['buyer', 'other'])
              .get().then(function (querySnapshot) {
                if (!querySnapshot.empty) {
                  userObj[userId].userObject = querySnapshot.docs[0].data();
                  callback(true, userObj, callFor);

                  // const currentValue = self._ConnectedBuyerData.value;
                  // // ... concat two arrays into single array
                  // const updatedValue = [...currentValue, ...userObj];
                  // self._ConnectedBuyerData.next(updatedValue);

                } else {
                  callback(true, null, callFor);
                }
              })
          })
        } else {
          callback(true, null, callFor);
        }
        break;
      case "received":
        let receivedCollection = self.logedInUserData["RelationReceivedCollection-" + localStorage.currentFieldKeyId]
        if (receivedCollection.length >= 0) {
          receivedCollection.forEach(userId => {
            var userObj = [];
            self.afs.collection("UserCollection").ref
              .where("id", "==", userId)
              .where("userType", 'in', ['buyer', 'other'])
              .get().then(function (querySnapshot) {
                if (!querySnapshot.empty) {
                  userObj[userId].userObject = querySnapshot.docs[0].data();
                  callback(true, userObj, callFor);

                  // const currentValue = self._ConnectedBuyerData.value;
                  // // ... concat two arrays into single array
                  // const updatedValue = [...currentValue, ...userObj];
                  // self._ConnectedBuyerData.next(updatedValue);
                } else {
                  callback(true, null, callFor);
                }
              })
          })
        } else {
          callback(true, null, callFor);
        }
        break;
      case "ignored":
        let ignoredCollection = self.logedInUserData["RelationIgnoredCollection-" + localStorage.currentFieldKeyId]
        if (ignoredCollection.length >= 0) {
          ignoredCollection.forEach(userId => {
            var userObj = [];
            self.afs.collection("UserCollection").ref
              .where("id", "==", userId)
              .where("userType", 'in', ['buyer', 'other'])
              .get().then(function (querySnapshot) {
                if (!querySnapshot.empty) {
                  userObj[userId].userObject = querySnapshot.docs[0].data();
                  callback(true, userObj, callFor);

                  // const currentValue = self._ConnectedBuyerData.value;
                  // // ... concat two arrays into single array
                  // const updatedValue = [...currentValue, ...userObj];
                  // self._ConnectedBuyerData.next(updatedValue);

                } else {
                  callback(true, null, callFor);
                }
              })
          })
        } else {
          callback(true, null, callFor);
        }
        break;
      case "connected":
        let connectedCollection = self.logedInUserData["RelationConnectedCollection-" + localStorage.currentFieldKeyId]
        if (connectedCollection && connectedCollection.length >= 0) {
          connectedCollection.forEach(userId => {
            var userObj = [];
            var productsUserObj = [];
            userObj[userId] = [];
            if (localStorage.userType == "intermediary") {
              self.afs.collection("UserCollection").ref
                .where("id", "==", userId)
                .where("userType", 'in', ['buyer', 'other'])
                .get().then(function (querySnapshot) {
                  if (!querySnapshot.empty) {
                    userObj[userId].userObject = querySnapshot.docs[0].data();

                    productsUserObj.push(querySnapshot.docs[0].data());

                    const currentValue = self._ConnectedBuyerData.value;
                    // ... concat two arrays into single array
                    const updatedValue = [...currentValue, ...productsUserObj];
                    self._ConnectedBuyerData.next(updatedValue);


                    callback(true, productsUserObj, callFor);

                  } else {
                    // callback(true, null, callFor);
                  }
                })
            } else if (localStorage.userType == "seller") {
              self.afs.collection("UserCollection").ref
                .where("id", "==", userId)
                // .where("userType", "==", 'intermediary')
                .where("userType", 'in', ['buyer', 'intermediary'])
                .get().then(function (querySnapshot) {
                  if (!querySnapshot.empty) {
                    userObj[userId].userObject = querySnapshot.docs[0].data();

                    productsUserObj.push(querySnapshot.docs[0].data());

                    const currentValue = self._ConnectedBuyerData.value;
                    // ... concat two arrays into single array
                    const updatedValue = [...currentValue, ...productsUserObj];
                    self._ConnectedBuyerData.next(updatedValue);


                    callback(true, productsUserObj, callFor);

                  } else {
                    // callback(true, null, callFor);
                  }
                })

            } else if (localStorage.userType == "buyer") {
              self.afs.collection("UserCollection").ref
                .where("id", "==", userId)
                // .where("userType", "==", 'intermediary')
                .where("userType", 'in', ['seller', 'intermediary'])
                .get().then(function (querySnapshot) {
                  if (!querySnapshot.empty) {
                    userObj[userId].userObject = querySnapshot.docs[0].data();

                    productsUserObj.push(querySnapshot.docs[0].data());

                    const currentValue = self._ConnectedBuyerData.value;
                    // ... concat two arrays into single array
                    const updatedValue = [...currentValue, ...productsUserObj];
                    self._ConnectedBuyerData.next(updatedValue);


                    callback(true, productsUserObj, callFor);

                  } else {
                    // callback(true, null, callFor);
                  }
                })

            }

          })
        } else {
          callback(true, null, callFor);
        }
        break;
      default: {



        let connectedCollection = {};
        let sendCollection = {};
        let receivedCollection = {};
        let ignoredCollection = {};


        let connectedCollectionCopy = {};
        let sendCollectionCopy = {};
        let receivedCollectionCopy = {};
        let ignoredCollectionCopy = {};
        // get logedin update user detail from UserCollection.
        self.getUserCollection(function (logedInUserData) {
          var connectionList = [];
          self._AllConnectionsData = new BehaviorSubject<ProductInterface[]>([]);
          self.AllConnectionsData = self._AllConnectionsData.asObservable();
          if (self.logedInUserData) {
            connectedCollectionCopy = self.logedInUserData["RelationConnectedCollection-" + localStorage.currentFieldKeyId]
            sendCollectionCopy = self.logedInUserData["RelationSendCollection-" + localStorage.currentFieldKeyId]
            receivedCollectionCopy = self.logedInUserData["RelationReceivedCollection-" + localStorage.currentFieldKeyId]
            ignoredCollectionCopy = self.logedInUserData["RelationIgnoredCollection-" + localStorage.currentFieldKeyId]


            connectedCollection["connected"] = self.logedInUserData["RelationConnectedCollection-" + localStorage.currentFieldKeyId]
            sendCollection["sendRequst"] = self.logedInUserData["RelationSendCollection-" + localStorage.currentFieldKeyId]
            receivedCollection["received"] = self.logedInUserData["RelationReceivedCollection-" + localStorage.currentFieldKeyId]
            ignoredCollection["ignored"] = self.logedInUserData["RelationIgnoredCollection-" + localStorage.currentFieldKeyId]

            connectionList = connectionList.concat(connectedCollectionCopy, sendCollectionCopy,
              receivedCollectionCopy, ignoredCollectionCopy)
            connectionList = connectionList.reverse();
            connectionList.forEach(userId => {
              if (userId) {
                var userObj = [];
                var productsUserObj = [];
                userObj[userId] = [];
                self.afs.collection("UserCollection").ref
                  .where("id", "==", userId)
                  //.where("userType", 'in', ['buyer', 'other'])
                  .get().then(function (querySnapshot) {
                    if (!querySnapshot.empty) {
                      userObj[userId].userObject = querySnapshot.docs[0].data();
                      let userConnectionObject = {};

                      if (connectedCollection["connected"] && connectedCollection["connected"].findIndex(x => x == userId) != -1) {
                        userConnectionObject = querySnapshot.docs[0].data();
                        userConnectionObject["connected"] = "connected";

                      } else if (sendCollection["sendRequst"] && sendCollection["sendRequst"].findIndex(x => x == userId) != -1) {
                        userConnectionObject = querySnapshot.docs[0].data();
                        userConnectionObject["sendRequst"] = "sendRequst";

                      } else if (receivedCollection["received"] && receivedCollection["received"].findIndex(x => x == userId) != -1) {
                        userConnectionObject = querySnapshot.docs[0].data();
                        userConnectionObject["received"] = "received";

                      } else if (ignoredCollection["ignored"] && ignoredCollection["ignored"].findIndex(x => x == userId) != -1) {
                        userConnectionObject = querySnapshot.docs[0].data();
                        userConnectionObject["ignored"] = "ignored";
                      }

                      var index = self._AllConnectionsData.value.findIndex(x => x["id"] == userConnectionObject["id"]);
                      if (index == -1) {
                        productsUserObj.push(userConnectionObject);
                      } else {
                        productsUserObj.splice(index, 1);
                      }

                      const currentValue = self._AllConnectionsData.value;
                      // ... concat two arrays into single array
                      const updatedValue = [...currentValue, ...productsUserObj];
                      self._AllConnectionsData.next(updatedValue);

                      callback(true, userObj, callFor);
                    } else {
                      callback(true, null, callFor);
                    }
                  })
              } else {
                callback(true, null, callFor);
              }
            })

          } else {
            self.navCtrl.navigateRoot('/home');
          }
        }, true);
        break;
      }
    }
  }


  getCategories = (callback: any) => {
    var self = this;

    self._CategoryWiseData = new BehaviorSubject<ProductInterface[]>([]);
    self.CategoryWiseData = self._CategoryWiseData.asObservable();
    var productsCategoryObj = [];
    self.userCategoriesViaFieldWise = self.logedInUserData["CategoryCollection"][localStorage.currentFieldKeyId];
    var loopIndexCount = 0;
    self.userCategoriesViaFieldWise.forEach((data: "id") => {
      console.log("data" + data);

      // let scoresRef = self.afs.collection("ShareWithTimestampCollection").ref
      //   .where("shareWithUserId", "==", localStorage.id)
      //   .orderBy('timestamp', 'desc').get()
      //   .then(function (querySnapshot) {
      var loopIndex = 0;
      var defaultCategIndex = 0;
      var loopArray = function (data) {
        if (!data.empty) {

          var object = data;
          self.getProductsByCategoryWise(function (isSuccess, connectionObject) {

            if (isSuccess) {

              productsCategoryObj.push(connectionObject);

              self._CategoryWiseData.next(productsCategoryObj);

              defaultCategIndex++;
              loopIndexCount++;
              if (loopIndexCount == self.userCategoriesViaFieldWise.length) {
                callback(true, productsCategoryObj);
              }
              //console.log(self.productsCategoryObj)
            }
            loopIndex++;

            // continue loop
            if (loopIndex < data.length) {
              loopArray(data);
            }
          }, object, defaultCategIndex);
        }
      }
      // initialize..
      loopArray(data);
      // }, function (error) {
      //   console.log("Error getting document:", error);
      // });
    });
  }



  getProductsByCategoryWise(callback, categoryObject, index) {
    var self = this;

    if (localStorage.userType == "intermediary") {
      var query = self.afs.collection("ReShareWithCollection").ref
        .where("reShareWithUserId", "==", localStorage.id)
        .where("categoryId", "==", categoryObject.id)
        .where("fieldId", "==", localStorage.currentFieldKeyId)
        .orderBy("timestamp", "desc")
        .limit(3)
    } else {
      query = self.afs.collection("ShareWithCollection").ref
        .where("shareWithUserId", "==", localStorage.id)
        .where("userId", "==", self.brokerUserId)
        .where("categoryId", "==", categoryObject.id)
        .where("fieldId", "==", localStorage.currentFieldKeyId)
        .orderBy("timestamp", "desc")
        .limit(3)
    }

    query.get().then(function (querySnapshot) {
      if (!querySnapshot.empty) {
        var snapshotArray = [];
        querySnapshot.forEach(function (doc) {
          let docObj = doc.data();
          // let productId = docObj.productId;
          // var productsRef = self.afs.collection('ProductCollection').ref
          //   .where("id", "==", productId);
          // productsRef.get().then(function (querySnapshotP) {
          //   if (!querySnapshotP.empty) {
          //     var object = querySnapshotP.docs[0].data();
          //     // set id in object

          //Working 
          // if (self.ConnectedData.source["_value"]) {
          //   var snapshotArray = [];
          //   var indexCount = 0;
          //   //querySnapshot.forEach(function (doc) {
          //     self.ConnectedData.source["_value"].forEach(function (doc) {
          //     let docObj = doc;

          //     doc.products.forEach(function (product) {
          //       if(product.userCategoryId == categoryObject.id) {
          //           var object =  product;
          //           object["sellerFirmName"] = docObj.userObj.firmNameLC;
          //           object['id'] = doc.userObj.userId;


          //         if(snapshotArray.length < 3) {
          //           indexCount++;
          //           snapshotArray.push(object);
          //           if (snapshotArray.length == indexCount) {
          //               categoryObject['products'] = snapshotArray;
          //               callback(true, categoryObject);
          //           }
          //         }
          //       }
          //     })
          //  }

          var object = docObj.productObject;
          object["sellerFirmName"] = docObj.firmName;
          // object['id'] = doc.id;

          // push in array of product objects
          snapshotArray.push(object);
          if (snapshotArray.length == querySnapshot.size) {
            categoryObject['products'] = snapshotArray;
            callback(true, categoryObject);
          }
          // } else {
          //   categoryObject['products'] = [];
          //   callback(true, categoryObject);
          // }
          // });
        });
      } else if (localStorage.userType != 'buyer') {
        self.afs.collection('ProductCollection').ref
          .where("userId", "==", localStorage.id)
          .where("userCategoryId", "==", categoryObject.id)
          .where("fieldId", "==", localStorage.currentFieldKeyId)
          .orderBy("createDate", "desc")
          .limit(3)
          .get().then(function (querySnapshot) {
            if (!querySnapshot.empty) {
              var snapshotArray = [];
              querySnapshot.forEach(function (doc) {
                let docObj = doc.data();
                var object = docObj;
                object["sellerFirmName"] = localStorage.firmName;
                object['id'] = localStorage.id;

                // push in array of product objects
                snapshotArray.push(object);
                if (snapshotArray.length == querySnapshot.size) {
                  categoryObject['products'] = snapshotArray;
                  callback(true, categoryObject);
                }
              });
            } else {
              categoryObject['products'] = [];
              callback(true, categoryObject);
            }
          })
      } else {
        categoryObject['products'] = [];
        callback(true, categoryObject);
      }
    })
  }

  getUserDataById(userId) {
    var self = this;
    var matched = self.ConnectedBuyerData[localStorage.currentFieldKeyId].find(x => x.id == userId);
    if (matched) {
      return matched;
    }
  }


  /*  
      @Copyright Notice:
      @Type: TS   
      @For:  auth-data-seller.
      @Description : getLoggedInUserFields For get user's fields
  */
  getLoggedInUserFields(callback, userId, userTypeId) {
    var self = this;
    // forceLoggedInUserFieldReload true means all the fields are forced to reload again from db
    if (self.forceLoggedInUserFieldReload) {
      // this self.loggedInUserFields has to be clear in this case
      self.loggedInUserFields = [];
    }

    if (!self.forceLoggedInUserFieldReload && self.loggedInUserFields &&
      self.loggedInUserFields.length > 0) {
      // forceLoggedInUserFieldReload should be false to return data from local storage
      // do callback from local storage service
      callback(true, self.loggedInUserFields);
    } else if (userId) {
      // 1. if forceLoggedInUserFieldReload is true means data needs to be loaded again
      // 2. usually we change it's value (self.forceLoggedInUserFieldReload = true) when any change made in categories from profile
      // fetching logged in user's fields
      self.afs.collection("UserCategoryCollection").ref
        .where("userId", "==", userId).onSnapshot(function (querySnapshot) {
          if (!querySnapshot.empty) {
            let loggedInUserFields = [];
            // update new data
            querySnapshot.forEach(function (doc) {
              loggedInUserFields.push(doc.data());
            });
            self.loggedInUserFields = loggedInUserFields;
            if (self.forceLoggedInUserFieldReload) {
              // new FieldReload fetched - mark this flag false
              self.forceLoggedInUserFieldReload = false;
              // do callback
              callback(true, self.loggedInUserFields);
            }
          } else {
            self.loggedInUserFields = self.logedInUserData["CategoryCollection"][localStorage.currentFieldKeyId];
            // do callback
            callback(true, self.loggedInUserFields);
          }
        });
    }
  }
  /*
		@Author : Kapil soni
		@(#)
		@Type: TS
		@For:  display-user-order-product-detail.html
		@Description :  updateOrderStatusInDB for update orderStatus 
	*/
  updateOrderStatusInDB(callback: any, order: any, orderStatus: any, orderTabStatus: any) {
    var self = this;
    var ref = self.afs.collection("OrderCollection").ref.doc(order.id);

    if (orderStatus) {
      if (localStorage.userType == 'buyer') {
        ref.update({ "orderByStatus": orderStatus }).then(function () {
          // do callback
          callback(true);
        });

      } else if (localStorage.userType == 'seller') {
        ref.update({ "sellerStatus": orderStatus }).then(function () {
          // do callback
          callback(true);
        });
      } else {

        if (orderTabStatus == "receivedOrder") {
          ref.update({ "sellerStatus": orderStatus }).then(function () {
            // do callback
            callback(true);
          });
        } else if (orderTabStatus == "sellerOrder") {
          ref.update({ "interStatus": orderStatus }).then(function () {
            // do callback
            callback(true);
          });
        } else {
          ref.update({ "orderByStatus": orderStatus }).then(function () {
            // do callback
            callback(true);
          });
        }
      }
    }
  }
  //updated OrderColletion InFirestore
  updatedOrderColletionInFirestore(callback, object: any, orderId) {
    //if currentFieldKeyId exist....
    var self = this;
    // order not found with given parameters - so, creating new WishlistPair.
    var docRef = self.afs.collection("OrderCollection").doc(orderId);
    var object1 = {
    }
    object1["productList"] = object;
    object1["reOrdered"] = true;
    docRef.update(object1).then(function () {
      //set the callback
      callback(true, object);
    }).catch(function (error) {
      callback(false, null);
    });
  }


  /*
  @Copyright Notice:
  Author : kapil soni
  @Type: Ts
  @For:  seller-order-section.html
  @Description : getSelectedUserOrderFromFirestore For show get user order'S
*/
  getSelectedUserOrderFromFirestore(callback, user: any, selectedUserId, selectedTab: any) {
    var list = [];
    var self = this;
    //var query : any;

    if (selectedUserId != "" && selectedUserId != undefined) {

      //if order is received via seller and click sellOrderTab 
      if (selectedTab == 'sellerOrder') {
        //set the path if get oprder with intemediary
        var query = self.afs.collection("OrderCollection").ref.where('orderByUserId', '==', selectedUserId).where('interUserId', '==', localStorage.id);
        //}
      } else if (selectedTab == 'orderByMe') {
        //if type is other and intermediary
        if (user.userObject.userType == 'intermediary' || user.userObject.userType == 'other'
          || user.userType == 'intermediary' || user.userType == 'other') {
          var query = self.afs.collection("OrderCollection").ref.where('orderByUserId', '==', localStorage.id).where('sellerUserId', '==', selectedUserId);
        }
      } else if (selectedTab == 'receivedOrder') {
        //
        var query = self.afs.collection("OrderCollection").ref.where('orderByUserId', '==', selectedUserId).where('sellerUserId', '==', localStorage.id);
      } else if (selectedTab == 'PlacedOrder') {
        //get the fire-store query for get product via categoryId wise.....
        if (localStorage.userType == 'intermediary' || localStorage.userType == 'other') {
          var query = self.afs.collection("OrderCollection").ref
            .where('orderByUserId', '==', localStorage.id)
            .where('sellerUserId', '==', selectedUserId);
        } else {
          var query = self.afs.collection("OrderCollection").ref
            .where('orderByUserId', '==', localStorage.id)
            .where('directOrderToId', '==', self.brokerUserId)
            .where('sellerUserId', '==', selectedUserId);
        }
      }

      //get data from firestore and iterate one by one.....
      query.get().then(function (querySnapshot) {
        querySnapshot.forEach(function (doc) {
          var object = doc.data();
          list.push(object);
        });
        callback(true, list);
      }).catch(function (error) {
        callback(false, null);
      });
    }
  }

  // fetch order by order id
  getSelectedUserById(callback, orderId: any) {
    var self = this;

    //create the fire-store query for get product via categoryId wise.....
    var query = self.afs.collection("OrderCollection").ref.where('orderId', '==', orderId)

    //get data from firestore and iterate one by one.....
    query.get().then(function (querySnapshot) {
      querySnapshot.forEach(function (doc) {
        var object = doc.data();
        callback(true, object);
      });
    }).catch(function (error) {
      callback(false, null);
    });
  }

  // fetch all login user order
  getAllLoginUserOrder(callback, selectedTab, next, userOrderlastVisible) {
    var self = this;
    var list = [];
    var query: any;
    //create the fire-store query for get product via categoryId wise.....
    if (localStorage.userType == "seller") {
      query = self.afs.collection("OrderCollection").ref
        .where('sellerUserId', '==', localStorage.id)
        .orderBy("timestamp", "desc");
    } else if (localStorage.userType == "buyer") {
      query = self.afs.collection("OrderCollection").ref.where('orderByUserId', '==', localStorage.id)
        .orderBy("timestamp", "desc");
    } else if (localStorage.userType == "intermediary" || localStorage.userType == "other") {
      if (selectedTab == 'orderByMe') {
        query = self.afs.collection("OrderCollection").ref.where('orderByUserId', '==', localStorage.id)
          .orderBy("timestamp", "desc");
      } else if (selectedTab == 'directOrder' && localStorage.userType == "intermediary") {
        query = self.afs.collection("OrderCollection").ref.where('interUserId', '==', localStorage.id)
          .orderBy("timestamp", "desc");
      } else if (selectedTab == 'buyerOrder') {
        query = self.afs.collection("OrderCollection").ref.where('sellerUserId', '==', localStorage.id)
          .orderBy("timestamp", "desc");
      }
    }
    if (!next) {
      //get data from firestore and iterate one by one.....
      query.limit(25).get().then(function (querySnapshot) {
        userOrderlastVisible = querySnapshot.docs[querySnapshot.docs.length - 1];
        querySnapshot.forEach(function (doc) {
          var object = doc.data();
          list.push(object);
        });
        callback(true, list, userOrderlastVisible);
      }).catch(function (error) {
        console.log(error);
        callback(false, null, userOrderlastVisible);
      });
    } else if (next) {
      //get data from firestore and iterate one by one.....
      query.startAfter(userOrderlastVisible).limit(25).get().then(function (querySnapshot) {
        userOrderlastVisible = querySnapshot.docs[querySnapshot.docs.length - 1];
        querySnapshot.forEach(function (doc) {
          var object = doc.data();
          list.push(object);
        });
        callback(true, list, userOrderlastVisible);
      }).catch(function (error) {
        console.log(error);
        callback(false, null, userOrderlastVisible);
      });
    }
  }

  /*
      @Copyright Notice:
      @(#)
      @Type: TS	
      @For:  create-accont.html.
        @Description : For validate number validation. 	
    */
  getStateFromFB(callback) {
    //Her we will get the state from the fire-store CDN
    var self = this;
    var fbStateArray = [];
    this.afs.collection('cdn').ref.doc('location').collection('country').doc('india').collection('state').get().then(function (querySnapshot) {
      if (!querySnapshot.empty) {
        querySnapshot.forEach(function (doc) {
          var data = doc.data();
          if (fbStateArray.findIndex(x => x.name == data.name) == -1) {
            fbStateArray.push(data);
          }
        });
        callback(true, fbStateArray);
      } else {
        callback(false, null);
      }
    }).catch(function (error) {
    });
  }



  //_remove User function
  removeUser(callback, object) {
    var self = this;
    var firstTrue = false;
    var secondTrue = false;
    var query1 = self.afs.collection("RelationConnectedCollection").ref
      .where('userId', '==', localStorage.id)
      //.where('userTypeId', '==', localStorage.userTypeId)
      .where('fieldId', '==', localStorage.currentFieldKeyId)
      .where('connectedUserId', '==', object.userId);
    query1.get().then(function (querySnapshot) {
      if (!querySnapshot.empty) {
        var docId = querySnapshot.docs[0].id;
        //self.afs.collection("RelationConnectedCollection").doc(docId).delete().then(function() {
        querySnapshot.docs[0].ref.delete().then(function () {

          // update UserCollection with RelationConnectedCollection - store object.reqToId id.
          var toUpdate1 = {};
          toUpdate1["RelationConnectedCollection-" + localStorage.currentFieldKeyId]
            = firebase.firestore.FieldValue.arrayRemove(object.userId);
          var docRef = self.afs.collection('UserCollection').ref.doc(localStorage.id);

          // Atomically add a new region to the "regions" array field.
          docRef.update(toUpdate1);

          firstTrue = true;
          if (secondTrue) {
            callback(true);
          }
        }).catch(function (error) {
        });
      } else {
        firstTrue = true;
        if (secondTrue) {
          callback(true);
        }
      }
    }).catch(function (error) {
      console.log("error documents", error);
    });
    var query2 = self.afs.collection("RelationConnectedCollection").ref
      .where('userId', '==', object.userId)
      .where('fieldId', '==', localStorage.currentFieldKeyId)
      .where('connectedUserId', '==', localStorage.id);
    query2.get().then(function (querySnapshot2) {
      if (!querySnapshot2.empty) {
        var docId2 = querySnapshot2.docs[0].id;
        //self.afs.collection("RelationConnectedCollection").doc(docId2).delete().then(function() {
        querySnapshot2.docs[0].ref.delete().then(function () {

          var toUpdate2 = {};
          toUpdate2["RelationConnectedCollection-" + localStorage.currentFieldKeyId]
            = firebase.firestore.FieldValue.arrayRemove(localStorage.id)

          // update UserCollection with RelationConnectedCollection - store object.reqToId id.
          var docRef = self.afs.collection('UserCollection').ref.doc(object.userId);

          // Atomically add a new region to the "regions" array field.
          docRef.update(toUpdate2);

          secondTrue = true;
          if (firstTrue) {
            callback(true);
          }
        }).catch(function (error) {

        });
      } else {
        firstTrue = true;
        if (secondTrue) {
          callback(true);
        }
      }
    }).catch(function (error) {
      console.log("error documents", error);
    });
  }

  //cancel Request function
  cancelRequest(callback, object) {
    var self = this;
    //Pass the data into the API and create the user
    var db = this.afs;
    var query = db.collection("RelationSendCollection").ref
      .where("userId", "==", localStorage.id)
      .where("reqFromId", "==", object.reqFromId)
      .where("reqToId", "==", object.reqToId)
      .where("fieldId", "==", localStorage.currentFieldKeyId)
      .get().then(function (doc) {
        var docId = doc.docs[0].id;
        db.collection("RelationSendCollection").doc(docId).delete().then(function () {

          var query1 = db.collection("RelationReceivedCollection").ref
            .where("userId", "==", object.reqToId)
            .where("reqFromId", "==", object.reqFromId)
            .where("reqToId", "==", object.reqToId)
            .where("fieldId", "==", localStorage.currentFieldKeyId)
            .get().then(function (doc1) {
              if (doc1.docs[0] != undefined) {
                var docId1 = doc1.docs[0].id;
                db.collection("RelationReceivedCollection").doc(docId1).delete().then(function () {

                  // update UserCollection with RelationSendCollection - store object.reqToId id.
                  var toUpdate1 = {};
                  toUpdate1["RelationSendCollection-" + localStorage.currentFieldKeyId]
                    = firebase.firestore.FieldValue.arrayRemove(object.reqToId);
                  var docRef = db.collection('UserCollection').doc(localStorage.id);

                  // Atomically add a new region to the "regions" array field.
                  docRef.update(toUpdate1);

                  var toUpdate2 = {};
                  toUpdate2["RelationReceivedCollection-" + localStorage.currentFieldKeyId]
                    = firebase.firestore.FieldValue.arrayRemove(localStorage.id)

                  // update UserCollection with RelationReceivedCollection - store object.reqToId id.
                  var docRef = db.collection('UserCollection').doc(object.reqToId);

                  // Atomically add a new region to the "regions" array field.
                  docRef.update(toUpdate2);


                  // self.addUserActivity({
                  // 		fireFor                  : "CANCEL_REQUEST",
                  // 	});

                  // For usage Update connection
                  // self.updateUsage(function(isSuccess) {

                  // }, 
                  // "connections",
                  // localStorage.id,null,null,null);

                  // self.updateUsage(function(isSuccess) {

                  // }, 
                  // "connections",
                  // object.reqToId,null,null,null);
                  callback(true, "isRequestSend");
                })
                  .catch(function (error) {
                    console.log("RelationReceivedCollection not found" + error)
                  });
              } else {
                var query1 = db.collection("RelationIgnoredCollection").ref
                  .where("userId", "==", object.reqToId)
                  .where("reqFromId", "==", object.reqFromId)
                  .where("reqToId", "==", object.reqToId)
                  .where("fieldId", "==", localStorage.currentFieldKeyId)
                  .get().then(function (doc1) {
                    if (doc1.docs[0] != undefined) {
                      var docId1 = doc1.docs[0].id;
                      db.collection("RelationIgnoredCollection").doc(docId1).delete().then(function () {
                        self.addUserActivity({
                          fireFor: "CANCEL_REQUEST",
                        });

                        // For usage Update connection
                        // self.updateUsage(function(isSuccess) {

                        // }, 
                        // "connections",
                        // localStorage.id,null,null,null);

                        // self.updateUsage(function(isSuccess) {

                        // }, 
                        // "connections",
                        // object.reqToId,null,null,null);
                        callback(true, "isRequestSend");
                      })
                        .catch(function (error) {
                          console.log("RelationReceivedCollection not found")
                        });
                    }
                    callback(true, "isRequestSend");
                  });
              }
              callback(true, "isRequestSend");
            });
        });
      });
  }

  //_rejectRequest function
  rejectRequest(callback, object) {
    var self = this;
    var db = this.afs;
    var query = db.collection("RelationReceivedCollection").ref
      .where("userId", "==", object.reqToId)
      .where("reqFromId", "==", object.reqFromId)
      .where("reqToId", "==", object.reqToId)
      .where("fieldId", "==", localStorage.currentFieldKeyId)
      .get().then(function (doc) {
        if (doc.docs[0].id != undefined) {
          var objectRec = doc.docs[0].data();
          var docId = doc.docs[0].id;
          db.collection("RelationReceivedCollection").doc(docId).delete().then(function () {

            objectRec["updateDate"] = firebase.firestore.FieldValue.serverTimestamp();
            var query1 = db.collection("RelationIgnoredCollection");
            query1.add(objectRec).then(function () {
              // 	self.addUserActivity({
              // 		fireFor      : "IGNORE_REQUEST"
              // });

              // update UserCollection with RelationReceivedCollection - store object.reqToId id.
              var toUpdate1 = {};
              toUpdate1["RelationReceivedCollection-" + localStorage.currentFieldKeyId]
                = firebase.firestore.FieldValue.arrayRemove(object.reqFromId);
              var docRef = db.collection('UserCollection').doc(localStorage.id);

              // Atomically add a new region to the "regions" array field.
              docRef.update(toUpdate1);

              var toUpdate2 = {};
              toUpdate2["RelationIgnoredCollection-" + localStorage.currentFieldKeyId]
                = firebase.firestore.FieldValue.arrayUnion(object.reqFromId)

              // update UserCollection with RelationIgnoredCollection - store object.reqToId id.
              var docRef = db.collection('UserCollection').doc(localStorage.id);

              // Atomically add a new region to the "regions" array field.
              docRef.update(toUpdate2);

              callback(true, "isIgnoredReq");
              // For usage Update connection
              // self.updateUsage(function(isSuccess) {

              // }, 
              // "connections",
              // localStorage.id,null,null,null);

              // self.updateUsage(function(isSuccess) {

              // }, 
              // "connections",
              // object.reqToId,null,null,null);
              callback(true, "isRequestSend");
            })
              .catch(function (error) {
                console.log("RelationReceivedCollection not found : ", error)
              });
          });
        } else {
          callback(true, "isRequestSend");
        }
      });
  }

  getProductFromFirestoreWithType(callback, categoryId, isOuOfStock, productType, withConnection, limit) {
    // here we are calling function for fetch all product details..
    this.getProductFromFirestore(function (isSuccess, list, lastVisible) {
      callback(isSuccess, list, lastVisible);
    }, categoryId, isOuOfStock, productType, withConnection, limit);
  }



  /*
		@Copyright Notice:
		@(#)
		@Type: TS   
		@For:  create-account-next.html.
		@Description : checkDesingNoExistInFBfunction for check the design number
	 */
  checkDesingNoExistInFB(callback, designNumber) {
    var self = this;
    //var userId       = firebase.auth().currentUser.uid;
    //var userProductList = [];

    // fetching logged in user's fields
    self.afs.collection("ProductCollection").ref
      .where("userId", "==", localStorage.id)
      .where("fieldId", "==", localStorage.currentFieldKeyId)
      .where("designNumber", "==", designNumber).get()
      .then(function (querySnapshot) {
        if (!querySnapshot.empty) {
          // GST no. found in user
          callback(true);
        } else {
          // GST no. not found in user
          callback(false);
        }
      }).catch(function (error) {
      });
  }


  //addShortURL
  addShortURL(callback, product, selectedType) {
    var self = this;
    var type: any;
    if (selectedType == "Product") {
      type = "s";
    } else {
      type = "catalog";
    }
    // if(this.API_HOST !== 'https://risingbee-b2b-m.appspot.com' ){
    //       var longURL = window.location.origin + "/" + localStorage.webURLName + "/" + type + "/" + localStorage.id + "/" +localStorage.currentFieldKeyId + "/"+ product.id;
    //       var obj = {
    //               "shortURL": longURL,
    //               "urlName" : ""
    //           };
    //       callback(true, obj);
    //   }else{
    //var url = self.API_HOST + "/api/product/brand/create";
    var url = "https://riselink-gcp.appspot.com/api/create/shorturl";
    var paramData = {
      "longURL": self.ownerUrl + localStorage.webURLName + "/" + type + "/" + localStorage.id + "/" + localStorage.currentFieldKeyId + "/" + product.id,
      "SECRET_KEY": "TOM6cJMjvDYxWYAVpNEaPszF9za2",
      "title": product.designNumber,
      "type": selectedType,
      "API_KEY": "dcYjLl1jtDBMbEngfDxz",
      "appName": "risingbee"
    };

    //create the header 
    var headers = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    };
    if (url != "" && url != undefined) {
      //Pass the data into the API for check email is exist in the API or not
      self.http.post(url, paramData, headers).subscribe((response) => {
        callback(true, response);
      });
    } else {
      callback(false, null);
    }
    //}
  }

  /*

		@Copyright Notice:
		 @(#)
		@Type: TS
		@For:  add-new-user.html.
		@Description : getProductViaSubCategoryFromFirestore For show get public products.
	*/
  getProductViaSubCategoryFromFirestore(callback, selectedUserId, categoryId, subCategoryId, isOuOfStock, productType, withConnection) {
    var list = [];
    var self = this;

    //create the firs-tore query for get the data via category wise and subCategoryWise from the firestore .....
    var query = self.afs.collection("ProductCollection").ref
      .where("userId", "==", selectedUserId)
      .where("fieldId", "==", localStorage.currentFieldKeyId)
      .orderBy("createDate", 'desc');
    if (subCategoryId) {
      query = query.where("userSubCategoryId", "==", subCategoryId);
    }
    if (categoryId) {
      query = query.where("userCategoryId", "==", categoryId);
    }
    if (productType) {
      query = query.where("productType", "==", productType);
    }
    if (withConnection) {
      query = query.where("withConnection", "==", withConnection);
    }
    if (isOuOfStock) {
      query = query.where('isDeleted', '==', true).limit(10);
      //get data from firestore and iterate one by one.....
      query.get().then(function (querySnapshot) {
        //hold the last visible if the product.....
        self.lastVisible = querySnapshot.docs[querySnapshot.docs.length - 1];

        querySnapshot.forEach(function (doc) {
          // doc.data() is never undefined for query doc snapshots
          var object = doc.data();
          list.push(object);
        });
        callback(true, list, self.lastVisible);
      }).catch(function (error) {
        callback(false, null, null);
      });
    } else {
      query = query.where('isDeleted', '==', false).limit(10);
      //get data from firestore and iterate one by one.....
      query.get().then(function (querySnapshot) {
        //hold the last visible if the product.....
        self.lastVisible = querySnapshot.docs[querySnapshot.docs.length - 1];

        querySnapshot.forEach(function (doc) {
          // doc.data() is never undefined for query doc snapshots
          var object = doc.data();
          list.push(object);
        });
        callback(true, list, self.lastVisible);
      }).catch(function (error) {
        callback(false, null, null);
      });
    }
  }

  //fetchUserSubCategoriesObject
  fetchUserSubCategoriesObject(callback, userId, fieldId, categoryId, userTypeId) {
    // fetching logged in user's fields
    var categoryList = [];
    this.afs.collection("UserCategoryCollection").ref
      .where("userId", "==", userId)
      .where("fieldId", "==", fieldId)
      //.where("categoryId", "==", categoryId)
      .get().then(function (querySnapshot) {
        if (!querySnapshot.empty) {
          var object = querySnapshot.docs[0].data();
          callback(true, object);
        }
      });
  }

  // get product details by id
  getProductById(callback, productId) {
    var self = this;
    if (productId) {
      // fetching logged in user's fields
      self.afs.collection("ProductCollection").doc(productId).ref
        .get().then(function (doc) {
          if (doc.exists) {
            callback(true, doc.data());
          } else {
            callback(false, null);
          }
        }).catch(function (error) {
          callback(false, null);
          console.log("error documents", error);
        });
    } else {
      callback(false, null);
    }
  }

  checkSharedOrNotProduct(callback, productId) {
    var self = this;
    if (productId) {
      let collectionName = "";
      let shareWithUserId = "";
      if (localStorage.userType == "intermediary") {
        collectionName = "ReShareWithCollection";
        shareWithUserId = "reShareWithUserId"
      } else {
        collectionName = "ShareWithCollection";
        shareWithUserId = "shareWithUserId"
      }
      self.afs.collection(collectionName).ref
        .where('shareWithUserId', "==", localStorage.id)
        .where("productId", "==", productId)
        .get().then(function (querySnapshot) {
          if (!querySnapshot.empty) {
            var object = querySnapshot.docs[0].data();
            callback(true, object);
          }
        }).catch(function (error) {
          callback(false, null);
          console.log("error documents", error);
        });
    } else {
      callback(false, null);
    }
  }


  /*
  @Copyright Notice:
  @(#)
  @Type: TS   
  @For:  product-share.html.
  @Description : productShareWithAny function for share the product with group
 */
  async productShareWithAny(callback, userId, userTypeId, productId, object) {
    var self = this;
    var relConnectedId = firebase.auth().currentUser.uid;
    // set productId
    object["productId"] = productId;
    object["timestamp"] = firebase.firestore.FieldValue.serverTimestamp();
    // var query = self.afs.collection("RelationConnectedCollection")
    // .where("userId"          , "==", userId)
    // .where("fieldId"         , "==", localStorage.currentFieldKeyId)
    // .where("connectedUserId" , "==", relConnectedId);
    // query.get().then(function(querySnapshort) {
    // 	if(!querySnapshort.empty){
    //var relationId = querySnapshort.docs[0].id;
    //self.afs.collection("RelationConnectedCollection").doc(relationId)
    //querySnapshort.docs[0].ref
    await new Promise((innerResolve, innerReject) => {
      self.afs.collection("ShareWithCollection").ref
        .where("userId", "==", relConnectedId).where("shareWithUserId", "==", userId)
        .where("productId", "==", productId).where("fieldId", "==", localStorage.currentFieldKeyId)
        .get().then(function (querySnapshort) {
          if (querySnapshort.empty) {
            //get product data by id and set in an object to share with
            self.getProductById(function (isSuccess, productData) {
              if (isSuccess) {
                object["productObject"] = productData;
                let query1 = self.afs.collection("ShareWithCollection").ref.doc();
                object["id"] = query1.id;
                object["shareWithUserId"] = userId;
                console.log("object>" + object);
                query1.set(object)

                  .then(function (docRef) {
                    innerResolve();
                    let object3 = {
                      logedInUserId: relConnectedId,
                      shareWithUserId: userId,
                      timestamp: firebase.firestore.FieldValue.serverTimestamp(),
                      fieldId: localStorage.currentFieldKeyId
                    };
                    let query3 = self.afs.collection("ShareWithTimestampCollection").ref
                    let query4 = query3.where("logedInUserId", "==", relConnectedId)
                      .where("fieldId", "==", localStorage.currentFieldKeyId)
                      .where("shareWithUserId", "==", userId);
                    query4.get().then(function (querySnapshortTS) {
                      if (querySnapshortTS.empty) {
                        query3.doc().set(object3).then(function (docRef) {
                        }).catch(function (error) {
                          console.log("Error adding document: ", error);
                        });
                      } else {
                        var ShareWithTimestampCollectionId = querySnapshortTS.docs[0].id;
                        query3.doc(ShareWithTimestampCollectionId).update(
                          { timestamp: firebase.firestore.FieldValue.serverTimestamp() }
                        );
                      }
                      callback(true);
                    }).catch(function (error) {
                      console.log("Error adding document: ", error);
                      callback(false);
                    });
                    // End : Add product count in Sub-category
                  }).catch(function (error) {
                    console.log("Error adding document: ", error);
                    callback(false);
                  });

              } else {
                callback(false);
              }
            }, productId)
          } else {
            innerResolve();
            callback(true);

          }
        }).catch(function (error) {
          console.log("Error adding document: ", error);
          callback(false);
        });
    });
    // 	}else{
    // 		callback(false);
    // 	}
    // })
  }

  /*
      Author (s): Kapil soni
      @Copyright Notice:
      @Type: TS   
      @Description : shareWithInProduct for remove the userCategory from the FB
     */
  shareWithInProduct(callback, productId, shareWithUserId, object) {
    var self = this;
    object["productId"] = productId;
    self.afs.collection("ProductCollection").doc(productId)
      .collection("ShareWithCollection").doc(shareWithUserId)
      .set(object)
      .then(function (docRef) {
        callback(true);
      })
      .catch(function (error) {
        callback(false);
      });
  }


  //sendRequest
  sendRequest(callback, object) {
    let self = this;
    let url = "";
    var addNotificationAndActivity = () => {
      self.addFireNotification(object.reqToId, {
        toUserId: object.reqToId,
        fromSendUserTypeKeyId: localStorage.id,
        fromPersonName: localStorage.personName,
        fromFirmName: localStorage.firmName,
        fromPersonNameLC: localStorage.personName.toLowerCase(),
        fromFirmNameLC: localStorage.firmName.toLowerCase(),
        fireFor: "SENT_REQUEST",
        fireFieldName: localStorage.currentFieldName,
        timestamp: firebase.database.ServerValue.TIMESTAMP,
        isRead: false
      });
      // self.addUserActivity({
      // 	toUserId                 : object.reqToId,
      // 	logedInUserTypeKeyId     : localStorage.id,
      // 	logedInPersonName        : localStorage.personName,
      // 	logedInFirmName          : localStorage.firmName,
      // 	logedInPersonNameLC      : localStorage.personName.toLowerCase(),
      // 	logedInFirmNameLC        : localStorage.firmName.toLowerCase(),
      // 	fireFor                  : "LOGEDIN_SENT_REQUEST",
      // 	timestamp                : firebase.database.ServerValue.TIMESTAMP,
      // 	sendTo                   : object.firmName ? object.firmName : "",
      // 	isRead                   : false
      // });
    }

    object["fieldId"] = localStorage.currentFieldKeyId;
    object["reqFromId"] = localStorage.id;
    object["reqFromUserType"] = localStorage.userType;
    object["createDate"] = firebase.firestore.FieldValue.serverTimestamp();
    object["updateDate"] = firebase.firestore.FieldValue.serverTimestamp();
    object["isDeleted"] = false;
    object["isSent"] = true;
    object["isByInvitation"] = null;
    object["userAccessType"] = null;
    object["fieldId"] = localStorage.currentFieldKeyId;
    object["userId"] = localStorage.id;
    var db = self.afs;
    var query = db.collection("RelationSendCollection").ref
      .where("fieldId", "==", localStorage.currentFieldKeyId)
      .where("userId", "==", localStorage.id)
      .where("reqToId", "==", object.reqToId)
    query.get().then(function (querySnapsort) {
      if (querySnapsort.empty) {
        db.collection("RelationSendCollection").add(object)
          .then(function () {
            var query1 = db.collection("RelationReceivedCollection").ref
              .where("fieldId", "==", localStorage.currentFieldKeyId)
              .where("userId", "==", object.reqToId)
              .where("reqFromId", "==", localStorage.id);
            query1.get().then(function (querySnapsort) {
              if (querySnapsort.empty) {
                object["fieldId"] = localStorage.currentFieldKeyId;
                object["userId"] = object.reqToId;
                db.collection("RelationReceivedCollection").add(object).then(function () {

                  // update UserCollection with RelationSendCollection - store object.reqToId id.
                  var toUpdate1 = {};
                  toUpdate1["RelationSendCollection-" + localStorage.currentFieldKeyId]
                    = firebase.firestore.FieldValue.arrayUnion(object.reqToId);
                  var docRef = db.collection('UserCollection').doc(localStorage.id);

                  // Atomically add a new region to the "regions" array field.
                  docRef.update(toUpdate1);

                  var toUpdate2 = {};
                  toUpdate2["RelationReceivedCollection-" + localStorage.currentFieldKeyId]
                    = firebase.firestore.FieldValue.arrayUnion(localStorage.id)

                  // update UserCollection with RelationReceivedCollection - store object.reqToId id.
                  var docRef = db.collection('UserCollection').doc(object.reqToId);

                  // Atomically add a new region to the "regions" array field.
                  docRef.update(toUpdate2);

                  addNotificationAndActivity();
                  callback(true, "isReqestSend");
                })
                  .catch(function (error) {
                    console.log("Error Document", error);
                  });
              } else {
                alert("Request already send");
              }
            })
          })
          .catch(function (error) {
            console.log("Error Document", error);
            callback(false, "");
          });
      } else {
        callback(true, "reqestAlreadySend");
      }
    })
      .catch(function (error) {
        console.log("Error Document", error);
        callback(false, "");
      });
  }

  //acceptRequest function
  acceptRequest(callback, object) {
    var db = this.afs;
    var queryS = db.collection("RelationSendCollection").ref
      .where('userId', '==', object.id)
      .where('reqFromId', '==', object.id)
      .where('reqToId', '==', localStorage.id)
      .where('fieldId', '==', localStorage.currentFieldKeyId);
    queryS.get().then(function (querySnapshot) {
      if (!querySnapshot.empty) {
        var userObject = querySnapshot.docs[0].data();
        var userObjectId = querySnapshot.docs[0].id;

        //var query1 = query.collection("RelationConnectedCollection").doc(object.reqToId)
        //query1.set(userObject).then(function() {
        // MY OWN USER AND USERTYPE ID
        userObject["userId"] = localStorage.id;
        // CONNECTED USER AND USERTYPE ID
        userObject["connectedUserId"] = object.id;
        userObject["fieldId"] = localStorage.currentFieldKeyId;
        var query1 = db.collection("RelationConnectedCollection");
        query1.add(userObject).then(function () {
          db.collection("RelationSendCollection").doc(userObjectId).delete().then(function () {

            // update UserCollection with RelationSendCollection - store object.reqToId id.
            var toUpdate1 = {};
            toUpdate1["RelationSendCollection-" + localStorage.currentFieldKeyId]
              = firebase.firestore.FieldValue.arrayRemove(localStorage.id);
            var docRef = db.collection('UserCollection').doc(object.id);

            // Atomically add a new region to the "regions" array field.
            docRef.update(toUpdate1);

            var toUpdate2 = {};
            toUpdate2["RelationConnectedCollection-" + localStorage.currentFieldKeyId]
              = firebase.firestore.FieldValue.arrayUnion(localStorage.id)

            // update UserCollection with RelationReceivedCollection - store object.reqToId id.
            var docRef = db.collection('UserCollection').doc(object.id);

            // Atomically add a new region to the "regions" array field.
            docRef.update(toUpdate2);


            if (object.callFrom == "received") {
              //	var queryC = query2.collection("RelationReceivedCollection").doc(object.reqFromId);

              var queryC = db.collection("RelationReceivedCollection").ref
                .where('userId', '==', localStorage.id)
                .where('reqFromId', '==', object.id)
                .where('reqToId', '==', localStorage.id)
                .where('fieldId', '==', localStorage.currentFieldKeyId);
              queryC.get().then(function (querySnapshot2) {
                if (!querySnapshot2.empty) {
                  var userObject = querySnapshot2.docs[0].data();
                  var userObjectId = querySnapshot2.docs[0].id;
                  //var query1 = query2.collection("RelationConnectedCollection").doc(object.reqFromId);
                  //query1.set(userObject).then(function() {
                  // MY OWN USER AND USERTYPE ID
                  userObject["userId"] = object.id;
                  // CONNECTED USER AND USERTYPE ID
                  userObject["connectedUserId"] = localStorage.id;
                  userObject["fieldId"] = localStorage.currentFieldKeyId;
                  var query1 = db.collection("RelationConnectedCollection");
                  query1.add(userObject).then(function () {
                    db.collection("RelationReceivedCollection").doc(userObjectId).delete().then(function () {

                      // update UserCollection with RelationSendCollection - store object.reqToId id.
                      var toUpdate3 = {};
                      toUpdate3["RelationReceivedCollection-" + localStorage.currentFieldKeyId]
                        = firebase.firestore.FieldValue.arrayRemove(object.id);
                      var docRef = db.collection('UserCollection').doc(localStorage.id);

                      // Atomically add a new region to the "regions" array field.
                      docRef.update(toUpdate3);

                      var toUpdate4 = {};
                      toUpdate4["RelationConnectedCollection-" + localStorage.currentFieldKeyId]
                        = firebase.firestore.FieldValue.arrayUnion(object.id)

                      // update UserCollection with RelationReceivedCollection - store object.reqToId id.
                      var docRef = db.collection('UserCollection').doc(localStorage.id);

                      // Atomically add a new region to the "regions" array field.
                      docRef.update(toUpdate4);
                      // Case 1
                      callback(true, userObject);
                    }).catch(function (error) {
                    });
                  })
                    .catch(function (error) {
                    });
                }
              }).catch(function (error) {
              });
            } else if (object.callFrom == "ignored") {
              var queryI = db.collection("RelationIgnoredCollection").ref
                .where('userId', '==', localStorage.id)
                .where('reqFromId', '==', object.id)
                .where('reqToId', '==', localStorage.id)
                .where('fieldId', '==', localStorage.currentFieldKeyId);
              queryI.get().then(function (querySnapshot3) {
                if (!querySnapshot3.empty) {
                  var userObject = querySnapshot3.docs[0].data();
                  var userObjectId = querySnapshot3.docs[0].id;
                  //var query1 = query2.collection("RelationConnectedCollection").doc(object.reqFromId);
                  //query1.set(userObject).then(function() {
                  // MY OWN USER AND USERTYPE ID
                  userObject["userId"] = object.id;
                  // CONNECTED USER AND USERTYPE ID
                  userObject["connectedUserId"] = localStorage.id;
                  userObject["fieldId"] = localStorage.currentFieldKeyId;
                  var query1 = db.collection("RelationConnectedCollection");
                  query1.add(userObject).then(function () {
                    db.collection("RelationIgnoredCollection").doc(userObjectId).delete().then(function () {
                      // update UserCollection with RelationSendCollection - store object.reqToId id.
                      var toUpdate5 = {};
                      toUpdate5["RelationIgnoredCollection-" + localStorage.currentFieldKeyId]
                        = firebase.firestore.FieldValue.arrayRemove(object.id);
                      var docRef = db.collection('UserCollection').doc(localStorage.id);

                      // Atomically add a new region to the "regions" array field.
                      docRef.update(toUpdate5);

                      var toUpdate6 = {};
                      toUpdate6["RelationConnectedCollection-" + localStorage.currentFieldKeyId]
                        = firebase.firestore.FieldValue.arrayUnion(object.id)

                      // update UserCollection with RelationReceivedCollection - store object.reqToId id.
                      var docRef = db.collection('UserCollection').doc(localStorage.id);

                      // Atomically add a new region to the "regions" array field.
                      docRef.update(toUpdate6);

                      // Case 2
                      callback(true, userObject);
                    }).catch(function (error) {
                    });
                  })
                    .catch(function (error) {
                    });
                }
              }).catch(function (error) {
              });
            }
          }).catch(function (error) {
          });
        })
          .catch(function (error) {
          });
      }

    });
  }



  //create account function
  async createUserAccount({ firmName = "", personName, email = "", phoneNumber, isByInvitation = false, inviteduserType, messageType = "" }: any) {
    //Display loader
    var self = this;
    phoneNumber = phoneNumber.replace(/[^0-9]/g, '');
    phoneNumber.substring(phoneNumber.length - 12, phoneNumber.length)
    if (phoneNumber.length >= 12) {
      phoneNumber = phoneNumber.substring(phoneNumber.length - 10, phoneNumber.length)
    }
    //Get the input value assign into object format and pass in the API
    const object = {
      "firmName": firmName ? firmName : personName.trim(),
      "personName": firmName ? firmName : personName.trim(),
      "email": email.trim(),
      "phoneNumber": "+91" + Number(phoneNumber),
      "userType": inviteduserType == "Retailer" ? "buyer" : 'intermediary',
      "userTypeRole": inviteduserType == "Retailer" ? "Retailer" : 'Broker',
      "password": "123456a",
      isByInvitation,
      "profileAccessType": ""
    }
    //Call the signupUserGCP function 
    const data = await self.signupUserGCP(object);
    if (data && data["isAdded"]) {
      var userId = data["userTypeKeyId"];

      //set login page
      // self.isPageType = 'login';
      //if user invited - byInvitation
      if (userId && userId != null && isByInvitation) {
        var objectForInvitation = {
          id: userId,
          callFrom: "received",
          firmName: data["firmName"],
          isByInvitation
        }

        await new Promise((innerResolve, innerReject) => {
          self.inviteUserConnect(function (isSuccessSendRequest, param) {
            innerResolve();
          }, objectForInvitation)
        });
      }
      //  else if(userId && !isByInvitation) {
      //     var object3 = {
      //       id: userId,
      //       reqToId : userId,
      //       callFrom: "received",
      //       firmName: data["firmName"]
      //     }
      //     await new Promise((innerResolve, innerReject) => {
      //       self.sendRequest(function (isSuccessSendRequest, param) {
      //         innerResolve();
      //       }, object3)
      //     });
      // }

      //self.showModalSuccess('Account created successfully', "Click 'Continue' to Login..", loading);
      let object2 = {};
      if (messageType == 'requestAccess') {

      } else if (inviteduserType == 'Retailer') {
        object2 = {
          'countryCode': "+91",
          'mobileNo': Number(phoneNumber),
          'msg': 'Hello ' + firmName.trim() + ', welcome to ' + self.ownerName + ' ! ' +
            'your account has been created successfully. Please using login via ' + Number(phoneNumber) +
            'Thank you.. ' +
            'please click on link to login ' + self.ownerUrl
        }
      } else {
        object2 = {
          'countryCode': "+91",
          'mobileNo': Number(phoneNumber),
          'msg': 'Hello ' + firmName.trim() + ', welcome to ' + self.ownerName + ' ! ' +
            'your account has been created successfully. Please using login via ' + Number(phoneNumber) +
            'Thank you.. '
        }
      }

      await new Promise((innerResolve, innerReject) => {
        self.sendLinkTextMsg(function (isSuccess) {
          innerResolve();
        }, object2);
      });
    } else if (data && data["existUserId"] && isByInvitation) {
      var userId = data["existUserId"].slice(11);
      if (userId != undefined) {
        var object3 = {
          id: userId,
          reqToId: userId,
          callFrom: "received",
          firmName: data["firmName"]
        }
        await new Promise((innerResolve, innerReject) => {
          self.inviteUserConnect(function (isSuccessSendRequest, param) {
            innerResolve();
          }, object3)
        });
      }

      var object4 = {};
      if (messageType == 'requestAccess') {

      } else if (inviteduserType == 'Retailer') {
        object4 = {
          'countryCode': "+91",
          'mobileNo': Number(phoneNumber),
          'msg': 'Hello ' + firmName.trim() + ', welcome to ' + self.ownerName + ' ! ' +
            'your account has been created successfully. Please using login via ' + Number(phoneNumber) +
            'Thank you.. ' +
            'please click on link to login ' + self.ownerUrl
        }
      } else {
        object4 = {
          'countryCode': "+91",
          'mobileNo': Number(phoneNumber),
          'msg': 'Hello ' + firmName.trim() + ', welcome to ' + self.ownerName + ' ! ' +
            'your account has been created successfully. Please using login via ' + Number(phoneNumber) +
            'Thank you.. '
        }
      }

      await new Promise((innerResolve, innerReject) => {
        self.sendLinkTextMsg(function (isSuccess) {
          innerResolve();
        }, object4);
      });
    }
  }


  //Description : getMaterialFromGCP function for get the list of the material 
  getMaterialFromGCP(callback) {
    //this.showSpinner = true;
    var self = this;
    var url = "";
    var paramData = "";

    //here we create the API URL and header for pass the data in the API 
    if (localStorage.currentFieldKeyId) {
      //pass the parameter in the API
      url = self.API_HOST + "/api/productMaterials/list1";
      paramData = "fieldKeyId=" + localStorage.currentFieldKeyId;

      //Here we will pass the header in the API
      let headers = {
        headers: new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' })
      };
      if (url) {
        if (environment.APK) {
          var paramBody = {
            "fieldKeyId": localStorage.currentFieldKeyId
          }
          //Pass the data into the API and create the user
          self.nativeHttp.post(url, paramBody, { 'Content-Type': 'application/x-www-form-urlencoded' })
            .then(res => {
              var data1 = JSON.parse(res.data);
              callback(true, data1);
            })
            .catch(error => {
            });
        } else {
          self.http.post(url, paramData, headers).subscribe(data => {
            callback(true, data);
          });
        }
      }
    }
  }

  //Description : getProductSizeFromGCP function for get the list of the sizes 
  getProductSizeFromGCP(callback, object) {
    //this.showSpinner = true;
    var self = this;
    var url = self.API_HOST + "/api/productSize/list";
    var paramData = "";

    //here we create the API URL and header for pass the data in the API 
    firebase.auth().currentUser.getIdToken(true).then(function (idToken) {
      if (idToken && url && object) {
        //pass the parameter in the API
        paramData = "categoryKeyId=" + object.categoryKeyId + "&subCategoryKeyId=" + object.subCategoryKeyId + "&idToken=" + idToken;

        //Here we will pass the header in the API
        let headers = {
          headers: new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' })
        };
        //for mobile and desktop
        if (environment.APK) {
          var paramBody = {
            "categoryKeyId": object.categoryKeyId,
            "subCategoryKeyId": object.subCategoryKeyId,
            "idToken": idToken
          }
          //Pass the data into the API and create the user
          self.nativeHttp.post(url, paramBody, { 'Content-Type': 'application/x-www-form-urlencoded' })
            .then(res => {
              var data1 = JSON.parse(res.data);
              callback(true, data1);
            })
            .catch(error => {
            });
        } else {
          self.http.post(url, paramData, headers).subscribe(data => {
            callback(true, data);
          });
        }
      } else {
      }
    }).catch(function (error) {
      // Handle error
    });
  }


  getUserProfileDetailsGCP(callback) {
    var self = this;
    var url = "";
    var docArray = {};
    var ref = self.afs.collection("UserCollection").ref.where("id", "==", localStorage.id)
      .get().then(function (querySnapshot) {
        if (!querySnapshot.empty) {
          var user = querySnapshot.docs[0].data();
          var ref2 = self.afs.collection("UserCollection").ref.doc(localStorage.id)
            .collection("UserTypeCollection")
            .get().then(function (querySnapshotType) {
              if (!querySnapshotType.empty) {
                var userType = querySnapshotType.docs[0].data();
                //docArray.userType = userType;
                docArray = {
                  'user': user,
                  'userType': userType
                }
              }
              callback(true, docArray);
            });
        } else {
          callback(true, docArray);
        }
      });
  }

  /*
		Author (s): Kapil soni
		@Copyright Notice:
		@Type: TS   
		@Description : createProductBrandInFB for create the userBrand in the Fb
	 */
  createProductBrandInFB(callback, userTypeId, fieldId, collectionList) {
    var self = this;
    //var userId = firebase.auth().currentUser.uid;
    self.afs.collection("BrandMaterialCollection").ref
      .where("userId", "==", localStorage.id)
      .where("fieldId", "==", localStorage.currentFieldKeyId)
      .get().then(function (querySnapshot) {
        if (!querySnapshot.empty) {
          var object = {};
          object["BrandCollection"] = collectionList;
          object["updateDate"] = firebase.firestore.FieldValue.serverTimestamp();
          var queryB = self.afs.collection("BrandMaterialCollection").ref.doc(querySnapshot.docs[0].id);
          // Atomically add a new field to the array.
          queryB.update(object).then(function () {
            callback(true);
          }).catch(function (error) {
            // The document probably doesn't exist.
            console.error("Error updating document: ", error);
            callback(false);
          });
        } else {
          var object = {};
          object["userId"] = localStorage.id;
          object["fieldId"] = fieldId;
          object["BrandCollection"] = collectionList;
          object["createDate"] = firebase.firestore.FieldValue.serverTimestamp();
          object["updateDate"] = firebase.firestore.FieldValue.serverTimestamp();
          self.afs.collection("BrandMaterialCollection").ref.doc().set(object).then(function () {
            callback(true);
          })
            .catch(function (error) {
              callback(false);
            });

        }
      })
  }
  /*
      @Copyright Notice:
       @(#)
      @Type: Ts
      @For:  add-new-user.html.
      @Description : addCustomMaterialInFieldDocument For create the custom material in firestore
    */
  addCustomMaterialInFieldDocument(callback, userTypeId, fieldId, collectionList) {
    var self = this;
    self.afs.collection("BrandMaterialCollection").ref
      .where("userId", "==", localStorage.id)
      .where("fieldId", "==", localStorage.currentFieldKeyId)
      .get().then(function (querySnapshot) {
        if (!querySnapshot.empty) {
          var object = {};
          object["MaterialCollection"] = collectionList;
          object["updateDate"] = firebase.firestore.FieldValue.serverTimestamp();
          var queryB = self.afs.collection("BrandMaterialCollection").ref.doc(querySnapshot.docs[0].id);
          // Atomically add a new field to the array.
          queryB.update(object).then(function () {
            callback(true);
          }).catch(function (error) {
            // The document probably doesn't exist.
            console.error("Error updating document: ", error);
            callback(false);
          });
        } else {
          var object = {};
          object["userId"] = localStorage.id;
          object["fieldId"] = fieldId;
          object["MaterialCollection"] = collectionList;
          object["createDate"] = firebase.firestore.FieldValue.serverTimestamp();
          object["updateDate"] = firebase.firestore.FieldValue.serverTimestamp();
          self.afs.collection("BrandMaterialCollection").ref.doc().set(object).then(function () {
            callback(true);
          })
            .catch(function (error) {
              callback(false);
            });

        }
      })
  }

  /*
     @Copyright Notice:
     @(#)
     @Type: TS   
     @For:  create-account-next.html.
     @Description : updateUserProfileDetails function for update the user address
   */
  updateSelectedDetail(callback, object) {
    var self = this;
    var url = "";
    //pass the parameter in the API
    switch (localStorage.userType) {
      case "seller":
        url = self.API_HOST + "/api/seller/f/update";
        break;
      case "buyer":
        url = self.API_HOST + "/api/buyer/f/update";
        break;
      case "intermediary":
        url = self.API_HOST + "/api/intermediary/f/update";
        break;
      case "other":
        url = self.API_HOST + "/api/intermediary/f/update/other";
        break;
    }

    //
    var paramData = "id=" + localStorage.id + "&email=" + object.emailLC + "&phoneNumber=" + object.phoneNumber;

    //create the header 
    var headers = {
      headers: new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' })
    };

    //Pass the data into the API and create the user
    if (url) {
      if (environment.APK) {
        var paramBody = {
          "id": localStorage.id,
          "email": object.emailLC,
          "phoneNumber": object.phoneNumber
        }
        self.nativeHttp.post(url, paramBody, { 'Content-Type': 'application/x-www-form-urlencoded' })
          .then(res => {
            var data = JSON.parse(res.data);
            if (data.isSuccess) {
              callback(true, data);
            } else {
              callback(false, data);
            }
          })
          .catch(error => {
          });
      } else {
        self.http.post(url, paramData, headers).subscribe(data => {
          if (data["isSuccess"]) {
            callback(true, data);
          } else {
            callback(false, data);
          }
        });
      }
    }
  }


	/*
		@Copyright Notice:
		@(#)
		@Type: TS   
		@For:  create-account-next.html.
		@Description : updateUserAddressDetails function for update the userAddressCollection
	*/
  updateUserAddressDetails(callback, userTypeObject) {
    var self = this;
    var url = "";
    if (userTypeObject.addressKeyId != undefined) {
      url = self.API_HOST + "/api/userTypeAdd/f/update";
    } else {
      url = self.API_HOST + "/api/userTypeAdd/f/create";
    }

    //create the header for the API
    var headers = {
      headers: new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' })
    };

    //check if idToken is Exist or not
    firebase.auth().currentUser.getIdToken(/* forceRefresh */ true).then(function (idToken) {
      var paramData: any;
      var paramBody: any = {};
      if (userTypeObject.addressKeyId != undefined) {
        paramData = "addressId=" + userTypeObject.addressKeyId + "&userId=" + localStorage.id
          + "&state=" + userTypeObject.state + "&city=" + userTypeObject.city
          + "&pincode=" + userTypeObject.pinCode + "&addressTitle=" + userTypeObject.firmAddress
          + "&streetAddress=" + userTypeObject.streetAddress + "&landmark=" + userTypeObject.landMark;
        paramBody = {
          "addressId": userTypeObject.addressKeyId, "userId": localStorage.id,
          "state": userTypeObject.state, "city": userTypeObject.city,
          "pincode": userTypeObject.pinCode, "addressTitle": userTypeObject.firmAddress,
          "streetAddress": userTypeObject.streetAddress, "landmark": userTypeObject.landMark
        }
      } else {
        paramData = "userId=" + localStorage.id +
          "&state=" + userTypeObject.state + "&city=" + userTypeObject.city + "&pincode=" + userTypeObject.pinCode
          + "&addressTitle=" + userTypeObject.firmAddress + "&streetAddress=" + userTypeObject.streetAddress +
          "&landmark=" + userTypeObject.landMark;
        paramBody = {
          "userId": localStorage.id, "state": userTypeObject.state, "city": userTypeObject.city,
          "pincode": userTypeObject.pinCode, "addressTitle": userTypeObject.firmAddress,
          "streetAddress": userTypeObject.streetAddress, "landmark": userTypeObject.landMark
        }
      }

      //Pass the data into the API and count the product
      if (url) {
        if (environment.APK) {
          //Pass the data into the API and create the user
          if (url && paramBody) {
            self.nativeHttp.post(url, paramBody, { 'Content-Type': 'application/x-www-form-urlencoded' })
              .then(res => {
                var data1 = JSON.parse(res.data);
                callback(true, data1);
              })
              .catch(error => {
              });
          }
        } else {
          self.http.post(url, paramData, headers).subscribe(data => {
            callback(true, data);
          });
        }
      }
    }).catch(function (error) {
      // Handle error
      console.log(" update Address ", error);
    });
  }
  //createUserAddress
  createUserAddress(callback, object) {
    var self = this;
    var url = "";

    url = self.API_HOST + "/api/userTypeAdd/f/create";
    var headers = {
      headers: new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' })
    };
    var body = "userId=" + object.userTypeKeyId +
      '&state=' + object.state + '&city=' + object.city +
      '&pincode=' + object.pincode + '&addressTitle=' + object.addressTitle +
      '&streetAddress=' + object.streetAddress + '&landmark=' + object.landmark;

    //Pass the data into the API and create the user
    if (url) {
      if (environment.APK) {
        var paramBody = {
          "userId": object.userTypeKeyId,
          'state': object.state,
          'city': object.city,
          'pincode': object.pincode,
          'addressTitle': object.addressTitle,
          'streetAddress': object.streetAddress,
          'landmark': object.landmark
        }
        //Pass the data into the API and create the user
        if (paramBody) {
          self.nativeHttp.post(url, paramBody, { 'Content-Type': 'application/x-www-form-urlencoded' })
            .then(res => {
              var data1 = JSON.parse(res.data);
              callback(true, data1);
            })
            .catch(error => {
            });
        }
      } else {
        self.http.post(url, body, headers).subscribe(data => {
          callback(true, data);
        });
      }
    } else {
      callback(false, null);
    }
  }

  //create User Address
  updateUserAddress(callback, object) {
    //this.showSpinner = true;
    var self = this;
    var url = "";

    //pass the parameter in the API
    url = self.API_HOST + "/api/userTypeAdd/update";
    var headers = {
      headers: new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' })
    };
    var body =
      'state=' + object.state + '&city=' + object.city +
      '&pincode=' + object.pincode + '&addressTitle=' + object.addressTitle +
      '&streetAddress=' + object.streetAddress + '&landmark=' + object.landmark +
      '&userTypeKeyId=' + object.userTypeKeyId;
    //Pass the data into the API and create the user
    if (url) {
      if (environment.APK) {
        var paramBody = {
          'state=': object.state, 'city=': object.city,
          'pincode': object.pincode, 'addressTitle': object.addressTitle,
          'streetAddress': object.streetAddress, 'landmark': object.landmark,
          'userTypeKeyId': object.userTypeKeyId
        }
        //Pass the data into the API and create the user
        if (paramBody) {
          self.nativeHttp.post(url, paramBody, { 'Content-Type': 'application/x-www-form-urlencoded' })
            .then(res => {
              var data1 = JSON.parse(res.data);
              callback(true, data1);
            })
            .catch(error => {
            });
        }
      } else {
        self.http.post(url, body, headers).subscribe(data => {
          callback(true, data);
        });
      }
    } else {
      callback(false, null);
    }
  }

  /*
		@Copyright Notice:
		@(#)
		@Type: TS   
		@For:  create-account-next.html.
		@Description : checkDesingNoExistInFBfunction for check the design number
	 */
  checkGSTNoExistInAnyUser(callback, gstNo) {
    var self = this;
    //var userProductList = [];

    // fetching logged in user's fields
    self.afs.collection("UserCollection").ref
      .where("gstNo", "==", gstNo)
      .get()
      .then(function (querySnapshot) {
        if (!querySnapshot.empty) {
          // GST no. found in user
          callback(true);
        } else {
          // GST no. not found in user
          callback(false);
        }
      }).catch(function (error) {
      });
  }

  /*  
        @Copyright Notice:
        @Type: TS   
        @For:  select-field.html.
        @Description : getAdminSubcatgoryFromGCP For get subCategory via category wise
    */
  getAdminSubcatgoryFromGCP(callback, categId) {
    var self = this;

    if (!this.adminSubCategoryList[categId]) {
      if (categId != undefined && categId != "") {
        //here we will pass the API url as well as paramData that is pass in the API
        var url = self.API_HOST + "/api/subCategories/list/each";
        if (environment.APK) {

          var data = {
            "categoryKeyId": categId
          }

          self.nativeHttp.post(url, data, { 'Content-Type': 'application/x-www-form-urlencoded' })
            .then(res => {
              var data = JSON.parse(res.data);
              // assign in local storage service
              self.adminSubCategoryList[categId] = data;
              // do callback
              callback(true, self.adminSubCategoryList[categId]);
            })
            .catch(error => {
              console.log("error : " + error);
              console.log(error.status);
              console.log(error.error); // error message as string
              console.log(error.headers);
            });
        } else {

          var paramData = "categoryKeyId=" + categId;

          //pass the parameter in the API
          var headers = {
            headers: new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' })
          };

          //Pass the data into the API for check email is exist in the API or not
          self.http.post(url, paramData, headers).subscribe((data: any) => {
            // assign in local storage service
            self.adminSubCategoryList[categId] = data;
            // do callback
            callback(true, self.adminSubCategoryList[categId]);
          })
        }
      } else {
        console.log("Object is undefined or null");
      }
    } else {
      // do callback from local storage service
      callback(true, this.adminSubCategoryList[categId]);
    }
  }

  ///api/userTypeAdd/list
  getUserAddress(callback: any, userKeyId: string) {
    var self = this;
    var userId = '';
    //get UserAddress via UserId wise
    if (userKeyId != undefined && userKeyId != null) {
      userId = String(userKeyId);
    } else {
      userId = String(localStorage.id);
    }
    var ref2 = self.afs.collection("UserCollection").ref.doc(userId)
      .collection("AddressCollection")
      .get().then(function (querySnapshot) {
        if (!querySnapshot.empty) {
          var data1 = {
            "userTypeAddressList": querySnapshot.docs[0].data()
          }
          callback(true, data1);
        } else {
          callback(true, null);
        }
      });
  }

  //Description : getAdminSubCategoryFromFB function for update the user address
  getAdminSubCategoryFromFB(callback: any, categoryId: any) {
    var self = this;
    firebase.auth().currentUser.getIdToken(/* forceRefresh */ true).then(function (idToken) {
      //here we will call the API 
      var url = self.API_HOST + "/api/categories/single/each/" + categoryId;
      var parmaData = "idToken=" + idToken + "&userTypeKeyId=" + localStorage.id;

      //pass the parameter in the API
      var headers = {
        headers: new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' })
      };
      if (url) {
        if (environment.APK) {
          //Pass the data into the API and create the user
          var paramBody = { "idToken": idToken, "userTypeKeyId": localStorage.id }
          if (paramBody) {
            self.nativeHttp.post(url, paramBody, { 'Content-Type': 'application/x-www-form-urlencoded' })
              .then(res => {
                var data = JSON.parse(res.data);
                callback(true, data);
              })
              .catch(error => {
              });
          }
        } else {
          self.http.post(url, parmaData, headers).subscribe(data => {
            callback(true, data);
          });
        }
      }
    }).catch(function (error) {
      // Handle error
    });
  }

  /*
      @Copyright Notice:
      @(#)
      @Type: TS   
      @For:  create-account-next.html.
      @Description : getAdminCategoryFromFB function for adminCategory
  */
  getAdminCategoryFromFB(callback: any, fieldId: any) {
    var self = this;

    if (!this.adminCategoryList[fieldId]) {
      firebase.auth().currentUser.getIdToken(/* forceRefresh */ true).then(function (idToken) {
        //here we will call the API 
        var url = self.API_HOST + "/api/fields/single/each/onlyCat/" + fieldId;

        if (environment.APK) {
          self.nativeHttp.get(url, {}, { 'Content-Type': 'application/x-www-form-urlencoded' })
            .then(res => {
              var data1 = JSON.parse(res.data);
              // assign in local storage service
              self.adminCategoryList[fieldId] = data1;
              // do callback
              callback(true, self.adminCategoryList[fieldId]);
            })
            .catch(error => {
              console.log("error : " + error);
              console.log(error.status);
              console.log(error.error); // error message as string
              console.log(error.headers);
            });
        } else {
          //pass the parameter in the API
          var headers = {
            headers: new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' })
          };

          //Pass the data into the API for check email is exist in the API or not
          self.http.get(url, headers).subscribe((data: any) => {
            // assign in local storage service
            self.adminCategoryList[fieldId] = data;
            callback(true, self.adminCategoryList[fieldId]);
          })
        }
      }).catch(function (error) {
        // Handle error
        console.log("error : " + error);
      });
    } else {
      // do callback from local storage service
      callback(true, this.adminCategoryList[fieldId]);
    }
  }

  /*  
       @Copyright Notice:
       @Type: TS   
       @For:  select-field.html.
       @Description : getAdminFieldsFromGCP For get admin fields
   */
  getAdminFieldsListEachFromGCP(callback) {
    var self = this;
    if (self.adminFieldsListEach && self.adminFieldsListEach.fieldsList && Object.keys(self.adminFieldsListEach.fieldsList).length > 0) {
      // do callback from local storage service
      callback(true, self.adminFieldsListEach);
    } else {
      var url = "";

      //here we will pass the API url as well as paramData that is pass in the API
      url = self.API_HOST + '/api/fields/list/each';
      //var pramData = "userTypeKeyId=" + Number(localStorage.userTypeKeyId);

      //if url is exist call the aPI
      if (url != "" && url != undefined) {
        if (environment.APK) {
          self.nativeHttp.get(url, {}, { 'Content-Type': 'application/x-www-form-urlencoded' })
            .then(res => {
              var data1 = JSON.parse(res.data);
              // assign in local storage service
              self.adminFieldsListEach = data1;
              // do callback
              callback(true, self.adminFieldsListEach);
            });
        } else {
          //pass the parameter in the API
          var headers = {
            headers: new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' })
          };

          //Pass the data into the API for check email is exist in the API or not
          self.http.get(url, headers).subscribe((data: any) => {
            self.adminFieldsListEach = data;
            callback(true, self.adminFieldsListEach);
          })
        }
      } else {
        callback(false, null);
      }
    }
  }
	/*
		@Copyright Notice:
		 @(#)
		@Type: Ts
		@For:  add-new-user.html.
		@Description : updateUserDetail For show get public products.
	*/
  updateUserDetail(callback, userId, userObject) {
    var self = this;
    var userRef = self.afs.collection("UserCollection").ref.doc(userId);

    // Set update given information object in userDocument
    return userRef.update(userObject).then(function () {

      var toUpdate4 = {};
      toUpdate4["brand"]
        = firebase.firestore.FieldValue.arrayUnion(userObject)

      // Atomically add a new region to the "regions" array field.
      userRef.update(toUpdate4);


      callback(true);
    }).catch(function (error) {
      callback(false);
    });


  }

  addImageFromCamera(callback: Function, imageString: any, imageForInput: string): any {
    var self = this;
    //Uplaod file
    var image = imageString;
    if (!imageString.startsWith("data:image")) {
      image = `data:image/jpeg;base64,${imageString}`;
    }
    var PRODUCT_STORAGE_REF = self.STORAGE_REF.ref('datastore/products');
    var rn = new Date().getTime().toString();
    rn = 'NEWTHUMB' + rn;
    var task = PRODUCT_STORAGE_REF.child(rn).putString(image, 'data_url');

    //update progress bar
    task.on('state_changed',
      function progress(snapshot) {
      },
      function error(err) {
        callback(false, null);
      },
      function complete() {
        task.snapshot.ref.getDownloadURL().then(function (downloadURL) {
          // Upload completed successfully, now we can get the download URL
          callback(true, downloadURL);
        });
      }
    )
  }


  //Description : checkDesingNumberInGCP function for create the product set
  checkDesingNumberInGCP(callback, desingNumber) {
    var self = this;
    var userProductList = [];
    var designNumber2 = desingNumber.trim().toLowerCase();
    //here we create the API URL and header for pass the data in the API 
    if (desingNumber.trim() != "" && desingNumber.trim() != undefined) {
      self.afs.collection("ProductCollection").ref
        .where('userId', '==', localStorage.id)
        .where('designNumber', '==', designNumber2)
        .get().then(function (querySnapshot) {
          if (!querySnapshot.empty) {
            querySnapshot.forEach(function (doc) {
              userProductList.push(doc.data());
            });
            callback(true, userProductList);
          } else {
            callback(true, null);
          }
        }).catch(function () {
          console.log("design number not found");
          callback(false, userProductList);
        })
    } else {
      callback(false, userProductList);
    }
  }


  //updatePersistedUserFieldObjectViaFieldId
  updatePersistedUserFieldObjectViaFieldId(fieldId, collectionList) {
    var self = this;
    if (self.userBrandObjectViaFieldWise[fieldId]) {
      self.userBrandObjectViaFieldWise[fieldId][0]["BrandCollection"] = collectionList;
    }
  }
  //uploadedProductsOrImages
  uploadedProductsOrImages(productObject, type, index) {
    var self = this;
    if (self.uploadedProductImagelist[localStorage.currentFieldKeyId] == undefined) {
      self.uploadedProductImagelist[localStorage.currentFieldKeyId] = [];
    }
    if (self.recentlyCreatedProductsList[localStorage.currentFieldKeyId] == undefined) {
      self.recentlyCreatedProductsList[localStorage.currentFieldKeyId] = [];
    }
    switch (type) {
      case "push":
        var index1 = self.uploadedProductImagelist[localStorage.currentFieldKeyId].findIndex(x => x.url == productObject.url);
        if (index1 == -1) {
          self.uploadedProductImagelist[localStorage.currentFieldKeyId].push(productObject);
        }
        break;
      case "remove":
        if (index != -1) {
          self.uploadedProductImagelist[localStorage.currentFieldKeyId].splice(index, 1);
        }
        break;
      case "removed":
        self.uploadedProductImagelist[localStorage.currentFieldKeyId] = self.uploadedProductImagelist[localStorage.currentFieldKeyId].filter(function (data) {
          return data.selected == false;
        });
        break;
      case "recentProduct":
        var index2 = self.recentlyCreatedProductsList[localStorage.currentFieldKeyId].findIndex(x => x.id == productObject.id);
        if (index2 == -1) {
          if (self.recentlyCreatedProductsList[localStorage.currentFieldKeyId].length < 5) {
            self.recentlyCreatedProductsList[localStorage.currentFieldKeyId].push(productObject);
          } else {
            self.recentlyCreatedProductsList[localStorage.currentFieldKeyId].splice(0, 1, productObject);
          }
        }
        break;
    }

  }
  //getUploadedProductImages
  getUploadedProductImages(callback) {
    var self = this;
    if (self.uploadedProductImagelist[localStorage.currentFieldKeyId] == undefined) {
      self.uploadedProductImagelist[localStorage.currentFieldKeyId] = [];
    }
    if (self.uploadedProductImagelist[localStorage.currentFieldKeyId] && self.uploadedProductImagelist[localStorage.currentFieldKeyId].length > 0) {
      callback(self.uploadedProductImagelist[localStorage.currentFieldKeyId]);
    }
  }

  //getUploadedRecentProduct
  getUploadedRecentProduct(callback) {
    var self = this;
    if (self.recentlyCreatedProductsList[localStorage.currentFieldKeyId] == undefined) {
      self.recentlyCreatedProductsList[localStorage.currentFieldKeyId] = [];
    }
    if (self.recentlyCreatedProductsList[localStorage.currentFieldKeyId] && self.recentlyCreatedProductsList[localStorage.currentFieldKeyId].length > 0) {
      callback(self.recentlyCreatedProductsList[localStorage.currentFieldKeyId]);
    }
  }

  //get CategoriesViaField
  getPersistedUserBrandObjectViaFieldId(callback: any, fieldId: any, userTypeId: any) {
    var self = this;
    if (self.userBrandObjectViaFieldWise[fieldId] != undefined &&
      self.userBrandObjectViaFieldWise[fieldId].length > 0) {
      //return only if persistedCategoriesViaField is not undefined 
      //that is either empty array of filled array
      callback(true, self.userBrandObjectViaFieldWise[fieldId]);
    } else {
      //if(self.userBrandObjectViaFieldWise[fieldId] == undefined) {
      ///function call category  function by filed
      // self.getNewFieldObjectViaFieldId(function() {
      self.userBrandObjectViaFieldWise[fieldId] = [];
      //self.userBrandObjectViaFieldWise[fieldId] = true;
      // fetching logged in user's field
      /*
      self.afs.collection("UserCollection").doc(userId).collection("UserTypeCollection")
      .doc(userTypeId).collection("FieldCollection").doc(fieldId)*/

      self.afs.collection("BrandMaterialCollection").ref
        .where("userId", "==", localStorage.id)
        .where("fieldId", "==", fieldId)
        .get().then(function (querySnapshot) {
          if (!querySnapshot.empty) {
            querySnapshot.forEach(function (doc) {
              self.userBrandObjectViaFieldWise[fieldId].push(doc.data());

              callback(true, self.userBrandObjectViaFieldWise[fieldId]);
              //	self.events.publish('userFieldObjectViaFieldWiseEvent');
            });
          } else {
            callback(true, self.userBrandObjectViaFieldWise[fieldId]);
          }
        });
      //}, fieldId, userTypeId);
      // }

      // self.events.subscribe("userFieldObjectViaFieldWiseEvent", () => {
      //     if(self.userBrandObjectViaFieldWise[fieldId] != undefined && self.userBrandObjectViaFieldWise[fieldId].length > 0) {
      //         //return only if persistedCategoriesViaField is not undefined 
      //         //that is either empty array of filled array
      //         callback(true, self.userBrandObjectViaFieldWise[fieldId]);
      //     }
      // });
    }
  }
  //acceptRequest function
  inviteUserConnect(callback, object) {
    var self = this;
    var db = self.afs;

    // var queryS = db.collection("RelationSendCollection").ref
    //   .where('userId', '==', object.id)
    //   .where('reqFromId', '==', object.id)
    //   .where('reqToId', '==', localStorage.id)
    //   .where('fieldId', '==', localStorage.currentFieldKeyId);

    let userObject = {

      reqFromId: object.id,
      userId: object.id,

      reqToId: localStorage.id,
      connectedUserId: localStorage.id,

      fieldId: localStorage.currentFieldKeyId,
      isByInvitation: true,
      isDeleted: false,
      reqFromUserType: "buyer",
      reqToUserType: localStorage.userType,
      createDate: firebase.firestore.FieldValue.serverTimestamp(),
      updateDate: firebase.firestore.FieldValue.serverTimestamp()

    }

    // queryS.get().then(function (querySnapshot) {
    //   if (!querySnapshot.empty) {
    // var userObject = querySnapshot.docs[0].data();
    //  var userObjectId = querySnapshot.docs[0].id;

    //var query1 = query.collection("RelationConnectedCollection").doc(object.reqToId)
    //query1.set(userObject).then(function() {
    // MY OWN USER AND USERTYPE ID
    // userObject["userId"] = localStorage.id;
    // // CONNECTED USER AND USERTYPE ID
    // userObject["connectedUserId"] = object.id;
    // userObject["fieldId"] = localStorage.currentFieldKeyId;
    var query1 = db.collection("RelationConnectedCollection");
    query1.add(userObject).then(function () {
      // db.collection("RelationSendCollection").doc(userObjectId).delete().then(function () {

      // update UserCollection with RelationSendCollection - store object.reqToId id.
      // var toUpdate1 = {};
      // toUpdate1["RelationSendCollection-" + localStorage.currentFieldKeyId]
      //   = firebase.firestore.FieldValue.arrayRemove(localStorage.id);
      // var docRef = db.collection('UserCollection').doc(object.id);

      // // Atomically add a new region to the "regions" array field.
      // docRef.update(toUpdate1);

      var toUpdate2 = {};
      // invited user CategoryCollection create same as logedIn user
      // if (self.logedInUserData && object.isByInvitation) {
      toUpdate2["CategoryCollection"] = self.logedInUserData["CategoryCollection"];

      if (self.logedInUserData["fieldIdArray"] && self.logedInUserData["fieldNameArray"]) {
        toUpdate2["fieldIdArray"] = self.logedInUserData["fieldIdArray"];
        toUpdate2["fieldNameArray"] = self.logedInUserData["fieldNameArray"];
      }

      // }

      toUpdate2["RelationConnectedCollection-" + localStorage.currentFieldKeyId]
        = firebase.firestore.FieldValue.arrayUnion(localStorage.id);


      // update UserCollection with RelationReceivedCollection - store object.reqToId id.
      var docRef = db.collection('UserCollection').doc(object.id);

      // Atomically add a new region to the "regions" array field.
      docRef.update(toUpdate2);


      //if (object.callFrom == "received") {
      //	var queryC = query2.collection("RelationReceivedCollection").doc(object.reqFromId);

      // var queryC = db.collection("RelationReceivedCollection").ref
      //   .where('userId', '==', localStorage.id)
      //   .where('reqFromId', '==', object.id)
      //   .where('reqToId', '==', localStorage.id)
      //   .where('fieldId', '==', localStorage.currentFieldKeyId);
      // queryC.get().then(function (querySnapshot2) {
      //   if (!querySnapshot2.empty) {
      let userObject2 = {

        userId: localStorage.id,
        reqToId: localStorage.id,

        reqFromId: object.id,
        connectedUserId: object.id,

        fieldId: localStorage.currentFieldKeyId,
        isByInvitation: true,
        isDeleted: false,
        reqFromUserType: "buyer",
        reqToUserType: localStorage.userType,
        createDate: firebase.firestore.FieldValue.serverTimestamp(),
        updateDate: firebase.firestore.FieldValue.serverTimestamp()

      }


      // var userObject = querySnapshot2.docs[0].data();
      // var userObjectId = querySnapshot2.docs[0].id;
      //var query1 = query2.collection("RelationConnectedCollection").doc(object.reqFromId);
      //query1.set(userObject).then(function() {
      // MY OWN USER AND USERTYPE ID
      // userObject["userId"] = object.id;
      // // CONNECTED USER AND USERTYPE ID
      // userObject["connectedUserId"] = localStorage.id;
      // userObject["fieldId"] = localStorage.currentFieldKeyId;
      var query1 = db.collection("RelationConnectedCollection");
      query1.add(userObject2).then(function () {
        // db.collection("RelationReceivedCollection").doc(userObjectId).delete().then(function () {

        // update UserCollection with RelationSendCollection - store object.reqToId id.
        // var toUpdate3 = {};
        // toUpdate3["RelationReceivedCollection-" + localStorage.currentFieldKeyId]
        //   = firebase.firestore.FieldValue.arrayRemove(object.id);
        // var docRef = db.collection('UserCollection').doc(localStorage.id);

        // // Atomically add a new region to the "regions" array field.
        // docRef.update(toUpdate3);

        var toUpdate4 = {};
        toUpdate4["RelationConnectedCollection-" + localStorage.currentFieldKeyId]
          = firebase.firestore.FieldValue.arrayUnion(object.id)

        // update UserCollection with RelationReceivedCollection - store object.reqToId id.
        var docRef = db.collection('UserCollection').doc(localStorage.id);

        // Atomically add a new region to the "regions" array field.
        docRef.update(toUpdate4);
        // Case 1
        callback(true, userObject);
      }).catch(function (error) {
        callback(false, null);
      });
    })
  }

  //provide reshare pernmission by seller 
  setPermissionForReShare(callback, userId, userTypeId, connectionUserObj, object) {
    var db = this.afs;
    //provide reshare permission by seller to intermediary or other user
    var query = db.collection("RelationConnectedCollection").ref
      .where("userId", "==", userId)
      .where("fieldId", "==", localStorage.currentFieldKeyId)
      .where("connectedUserId", "==", connectionUserObj.userObject.id)
    query.get().then(function (querySnapshot) {
      //updated permission value in login user relation
      //db.collection("RelationConnectedCollection").doc(querySnapshot.docs[0].id).update(object)
      querySnapshot.docs[0].ref.update(object)
      var query1 = db.collection("RelationConnectedCollection").ref
        .where("userId", "==", connectionUserObj.userObject.id)
        .where("fieldId", "==", localStorage.currentFieldKeyId)
        .where("connectedUserId", "==", userId)
      query1.get().then(function (querySnapsort1) {
        //updated permission value in connected user relation
        //db.collection("RelationConnectedCollection").doc(querySnapsort1.docs[0].id).update(object)
        querySnapsort1.docs[0].ref.update(object)
        callback(true);
      }).catch(function (error) {
        callback(false);
        console.log("Error adding document: ", error);
      });
    }).catch(function (error) {
      callback(false);
      console.log("Error adding document: ", error);
    });
  }

  checkDynamicLinkProduct(callback, linkNameLC) {
    var self = this;
    let scoresRef;
    //Check DeviceToken Exist or not
    scoresRef = this.getCollection('DynamicLinkCollection', ref => ref
      .where('userId', '==', localStorage.id)
      .where('nameLC', '==', linkNameLC));
    scoresRef.subscribe(data => {
      if (!data.empty) {
        callback(true);
      } else {
        callback(false);
      }
    });
  }

  //check checkWebURl
  checkWebURl(callback, url) {
    var db = this.afs;
    var query: any;
    query = db.collection("UserCollection");
    query = query.where("webURLName", "==", url);
    query.get().then(function (querySnapShot) {
      if (querySnapShot.size > 0) {
        callback(true);
      } else {
        callback(false);
      }
    })
  }

  /*
		@Copyright Notice:
		@(#)
		@Type: TS   
		@For:  create-account-next.html.
		@Description : updateUserProfileDetails function for update the user address
	*/
  updateUserProfileDetails(callback, userId, userObject) {
    var self = this;
    var userRef = self.afs.collection("UserCollection").doc(userId);

    // Set update given information object in userDocument
    userRef.update(userObject).then(function () {

      callback(true);
    }).catch(function (error) {
      // The document probably doesn't exist.
      callback(false);
    });
  }

  getLinkFN(callback, object) {
    let self = this;
    var docRefId = self.afs.collection('DynamicLinkCollection').ref.doc();
    object["id"] = docRefId["id"];
    object["url"] = self.ownerUrl + self.userInfo.webURLName + "/m/" + docRefId["id"];
    self.addShortURLForMultiple(function (isSuccess, data) {
      if (isSuccess) {
        object["shortURL"] = data.shortURL;
        docRefId.set(object)
          .then(function (productObjectRef) {
            self.createdLink = object["shortURL"];
            //reset link name
            //push data in recent created links
            !self.dynamicProductsList[self.productType] ? self.dynamicProductsList[self.productType] = [] : self.dynamicProductsList[self.productType];
            self.createdLinkObject = object;
            if (self.createdLinkObject && self.dynamicProductsList[self.productType] && event) {
              if (self.dynamicProductsList[self.productType].findIndex(x => x.id == self.createdLinkObject.id) == -1) {
                self.dynamicProductsList[self.productType].unshift(self.createdLinkObject);
              }
            }
            callback ? callback(self.createdLink) : "";
          });
      } else {
      }
    }, object["url"]);
  }



  //addShortURL for multiple products
  addShortURLForMultiple(callback, longURL) {
    var self = this;
    //var url = self.API_HOST + "/api/product/brand/create";
    var url = "https://riselink-gcp.appspot.com/api/create/shorturl";
    var paramData = {
      "longURL": longURL,
      "SECRET_KEY": "TOM6cJMjvDYxWYAVpNEaPszF9za2",
      "title": "",
      "type": "Product",
      "API_KEY": "dcYjLl1jtDBMbEngfDxz",
      "appName": "risingbee"
    };

    //create the header 
    var headers = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    };
    if (url != "" && url != undefined) {
      //Pass the data into the API for check email is exist in the API or not
      self.http.post(url, paramData, headers).subscribe((response) => {
        callback(true, response);
      });
    } else {
      callback(false, null);
    }
  }



  addDeviceToken(userId, deviceToken) {
    //start create & set DeviceCollection
    var self = this;
    var deviceTokenObj = {};
    deviceTokenObj["uId"] = userId;
    deviceTokenObj["token"] = deviceToken;
    deviceTokenObj["timeStamp"] = firebase.firestore.FieldValue.serverTimestamp();

    let scoresRef;
    //Check DeviceToken Exist or not
    scoresRef = self.afs.collection('DeviceCollection').ref
      .where('uId', '==', userId);
    scoresRef.get().then(function (querySnapshot) {
      // update count
      if (!querySnapshot.empty) {

        self.afs.collection('DeviceCollection').ref.doc(querySnapshot.docs[0].id).update(deviceTokenObj)
          .then(function (docRef) {
            console.log("deviceTokenObj" + deviceTokenObj);
          })
          .catch(function (error) {
            console.error("Error adding document: ", error);
          });
      } else {
        self.afs.collection("DeviceCollection").ref.doc().set(deviceTokenObj)
          .then(function (docRef) {
            console.log("deviceTokenObj" + deviceTokenObj);
          })
          .catch(function (error) {
            console.error("Error adding document: ", error);
          });
      }
    });
    // scoresRef.get().then(data => {
    //   if (data.length <= 0) {
    //     // add devicecollection
    //     this.afs.collection("DeviceCollection").add(deviceTokenObj)
    //       .then(function (docRef2) {
    //       })
    //       .catch(function (error) {
    //         console.error("Error writing document3: ", error);
    //       });
    //   }
    // });
  }

  addFireNotification(userObject, object) {
    var self = this;
    var url = "https://fcm.googleapis.com/fcm/send";
    let msg = "";
    switch (object.fireFor) {
      case "PLACE_ORDER": {
        msg = 'Hello, ' + localStorage.firmName + ' has created an order ' + object.orderId;
        break;
      }
      case "CANCEL_ORDER": {
        msg = 'Hello, ' + localStorage.firmName + ' has canceled an order ' + object.orderId;
        break;
      }
      case "SENT_REQUEST": {
        msg = 'Hello, ' + localStorage.firmName + ' has sent you request for ' + object.fireFieldName;
        break;
      }
      case "REQUEST_ACCEPTED": {
        msg = 'Hello, Your Request has been accepted by ' + localStorage.firmName + ' in ' + object.fireFieldName;
        break;
      }
      case "SHARED_PRODUCT": {
        msg = 'Hello, ' + localStorage.firmName + ' has shared ' + object.count + ' product ';
        break;
      }
      case "SHARED_FOLDER": {
        msg = 'Hello, ' + localStorage.firmName + ' has shared ' + object.count + ' folder ';
        break;
      }
      case "ORDER_STATUS_UPDATE": {
        msg = 'Hello, ' + localStorage.firmName + ' has ' + object.status + ' an order' + object.orderId;
        break;
      }
      case "UPDATE_ALBUM": {
        msg = 'Hello, ' + localStorage.firmName + ' has updated album';
        break;
      }
      case "ADD_TO_CART": {
        msg = 'Hello, ' + localStorage.firmName + ' has added a product in cart';
        break;
      }
      default: {
        msg = 'Hello, ' + self.ownerName;
        break;
      }
    }
    var clickAction;
    let scoresRef;
    scoresRef = self.afs.collection('DeviceCollection').ref
      .where('uId', '==', userObject);
    scoresRef.get().then(function (querySnapshot) {
      if (!querySnapshot.empty) {
        let deviceToken = querySnapshot.docs[0].data().token;

        if (self.apk) {
          clickAction = "FCM_PLUGIN_ACTIVITY";


          var body = {
            "to": deviceToken,
            "notification": {
              "title": self.ownerName,
              "body": msg,
              "mutable_content": true,
              "click_action": clickAction,
              "icon": "resources/android/icon/drawable-ldpi-icon.png",
              "sound": "default"
            },
            "data": {
              "url": "assets/imgs/bee.png",
              objectData: object,
              "dl": "<deeplink action on tap of notification>"
            }
          };

          var headers = {
            headers: new HttpHeaders({
              "Authorization":

                //"key=AAAAD-7S79s:APA91bF3q8cwnKsvKpvNCPlfkDjTd4ap8Ibkk6uTQdIJ4lz66vuYvmlgGX3Rt7IU2Aqw83l0VDmQ4xvnX-XMEiIllbf5JwgkiIgubYgB5WIt6qSNrNTKVJBFxGXMz5XrDc_8n2PJlhz4", 'Content-Type': 'application/json'

                "key=" + self.serverkey, 'Content-Type': 'application/json'
              // "key=AAAAD-7S79s:APA91bF3q8cwnKsvKpvNCPlfkDjTd4ap8Ibkk6uTQdIJ4lz66vuYvmlgGX3Rt7IU2Aqw83l0VDmQ4xvnX-XMEiIllbf5JwgkiIgubYgB5WIt6qSNrNTKVJBFxGXMz5XrDc_8n2PJlhz4", 'Content-Type': 'application/json'
            })
          };

          //Pass the data into the API and create the user
          if (url != "" && url != undefined) {
            // console.log('body', body);
            self.http.post(url, body, headers).subscribe(function (data) {
            });
          }

        } else if (object.toUser.userType == "intermediary" || object.toUser.userType == "seller") {
          // check if notification receiver intermediary or seller then send clickAction = receiver Url, if ownerURL exist.
          let userRef;
          userRef = self.afs.collection('UserCollection').ref
            .where('id', '==', userObject);
          userRef.get().then(function (querySnapshot) {
            if (!querySnapshot.empty) {
              if (querySnapshot.docs[0].data() && querySnapshot.docs[0].data().ownerUrl != undefined) {
                let ownerUrl = querySnapshot.docs[0].data().ownerUrl;
                clickAction = ownerUrl;
              } else {
                clickAction = self.ownerUrl;
              }
            } else {
              clickAction = self.ownerUrl;
            }


            var body = {
              "to": deviceToken,
              "notification": {
                "title": self.ownerName,
                "body": msg,
                "mutable_content": true,
                "click_action": clickAction,
                "icon": "resources/android/icon/drawable-ldpi-icon.png",
                "sound": "default"
              },
              "data": {
                "url": "assets/imgs/bee.png",
                objectData: object,
                "dl": "<deeplink action on tap of notification>"
              }
            };

            var headers = {
              headers: new HttpHeaders({
                "Authorization":

                  //"key=AAAAD-7S79s:APA91bF3q8cwnKsvKpvNCPlfkDjTd4ap8Ibkk6uTQdIJ4lz66vuYvmlgGX3Rt7IU2Aqw83l0VDmQ4xvnX-XMEiIllbf5JwgkiIgubYgB5WIt6qSNrNTKVJBFxGXMz5XrDc_8n2PJlhz4", 'Content-Type': 'application/json'

                  "key=" + self.serverkey, 'Content-Type': 'application/json'
                // "key=AAAAD-7S79s:APA91bF3q8cwnKsvKpvNCPlfkDjTd4ap8Ibkk6uTQdIJ4lz66vuYvmlgGX3Rt7IU2Aqw83l0VDmQ4xvnX-XMEiIllbf5JwgkiIgubYgB5WIt6qSNrNTKVJBFxGXMz5XrDc_8n2PJlhz4", 'Content-Type': 'application/json'
              })
            };

            //Pass the data into the API and create the user
            if (url != "" && url != undefined) {
              // console.log('body', body);
              self.http.post(url, body, headers).subscribe(function (data) {
              });
            }

          });
        } else {
          clickAction = self.ownerUrl;
        
        var body = {
          "to": deviceToken,
          "notification": {
            "title": self.ownerName,
            "body": msg,
            "mutable_content": true,
            "click_action": clickAction,
            "icon": "resources/android/icon/drawable-ldpi-icon.png",
            "sound": "default"
          },
          "data": {
            "url": "assets/imgs/bee.png",
            objectData: object,
            "dl": "<deeplink action on tap of notification>"
          }
        };

        var headers = {
          headers: new HttpHeaders({
            "Authorization":

              //"key=AAAAD-7S79s:APA91bF3q8cwnKsvKpvNCPlfkDjTd4ap8Ibkk6uTQdIJ4lz66vuYvmlgGX3Rt7IU2Aqw83l0VDmQ4xvnX-XMEiIllbf5JwgkiIgubYgB5WIt6qSNrNTKVJBFxGXMz5XrDc_8n2PJlhz4", 'Content-Type': 'application/json'

              "key=" + self.serverkey, 'Content-Type': 'application/json'
            // "key=AAAAD-7S79s:APA91bF3q8cwnKsvKpvNCPlfkDjTd4ap8Ibkk6uTQdIJ4lz66vuYvmlgGX3Rt7IU2Aqw83l0VDmQ4xvnX-XMEiIllbf5JwgkiIgubYgB5WIt6qSNrNTKVJBFxGXMz5XrDc_8n2PJlhz4", 'Content-Type': 'application/json'
          })
        };

        //Pass the data into the API and create the user
        if (url != "" && url != undefined) {
          // console.log('body', body);
          self.http.post(url, body, headers).subscribe(function (data) {
          });
        }

        }
        // console.log('this.dailyProductData ', this.da  ilyProductData);
      }
    });
  }


  userLoggedInSuccess(callback, userObject, loading: any) {
    //Enable the loader after call the FB function
    var self = this;
    //Declare the local variable
    var userId = "";
    var data = {};

    //Passs the data in the below give URL 
    var usersRef = firebase.firestore().collection('UserCollection').doc(userObject.user.uid)
    usersRef.get().then(function (doc) {
      if (doc.exists) {
        //for updating state and city array in userCollection
        var addressRef = doc.ref.collection('AddressCollection')
        addressRef.get().then(function (querySnapsort) {
          if (!querySnapsort.empty) {
            var addressObject = querySnapsort.docs[0].data();
            var object = {
              stateArray: [addressObject.state],
              cityArray: [addressObject.city]
            }
            localStorage.setItem("state", addressObject.state ? addressObject.state : "");
            usersRef.update(object).then(function () {
            }).catch(function (error) {
              console.log("Error Document", error);
            })
          }
        })
        data["user"] = doc.data();
        var userRef1 = usersRef.collection('UserTypeCollection');
        userRef1.get().then(function (querySnapshot) {
          if (!querySnapshot.empty) {
            data["userType"] = querySnapshot.docs[0].data();
            callback(true);
            localStorage.setItem("email", data["user"].email);
            localStorage.setItem("phoneNumber", data["user"].phoneNumber);
            //Here we will set the user Detail into the local-storage
            if (data["user"].userType == 'seller') {
              localStorage.setItem("defaultLanguage", data["user"].defaultLanguage);
              localStorage.setItem("id", data["user"].id);
              localStorage.setItem("userTypeId", data["userType"].id);
              //localStorage.setItem("state",              data["user"].stateArray ? data["user"].stateArray[0]: "");
              localStorage.setItem("isLoggedIn", "true");
              localStorage.setItem("gstNo", data["userType"].gstNo);
              localStorage.setItem("userTypeRole", data["userType"].userTypeRole);
              localStorage.setItem("userType", data["user"].userType);
              localStorage.setItem("userAccessType", data["user"].userAccessType);
              localStorage.setItem("firmName", data["user"].firmName);
              localStorage.setItem("personName", data["user"].personName);
              localStorage.setItem("noGst", data["user"].noGst);
              localStorage.setItem("isGstAvailable", data["user"].isGstAvailable);
              localStorage.setItem("ImageCollection", data["user"].ImageCollection);
              localStorage.setItem("brandName", data["userType"].brandName);
              localStorage.setItem("webURLName", data["user"].webURLName ? data["user"].webURLName : "");
            } else if (data["user"].userType == 'buyer') {
              localStorage.setItem("defaultLanguage", data["user"].defaultLanguage);
              localStorage.setItem("id", data["user"].id);
              //localStorage.setItem("state",              data["user"].stateArray ? data["user"].stateArray[0] : "");
              localStorage.setItem("userTypeId", data["userType"].id);
              localStorage.setItem("isLoggedIn", "true");
              localStorage.setItem("gstNo", data["userType"].gstNo);
              localStorage.setItem("userTypeRole", data["userType"].userTypeRole);
              localStorage.setItem("userType", data["user"].userType);
              localStorage.setItem("userAccessType", data["user"].userAccessType);
              localStorage.setItem("firmName", data["user"].firmName);
              localStorage.setItem("personName", data["user"].personName);
              localStorage.setItem("noGst", data["user"].noGst);
              localStorage.setItem("isGstAvailable", data["user"].isGstAvailable);
              localStorage.setItem("ImageCollection", data["user"].ImageCollection);
              //if(data["userType"].userTypeRole == "Retailer"){
              localStorage.setItem("webURLName", data["user"].webURLName ? data["user"].webURLName : "");
              //}

            } else {
              localStorage.setItem('defaultLanguage', data["user"].defaultLanguage);
              localStorage.setItem("id", data["user"].id);
              //localStorage.setItem("state",              data["user"].stateArray ? data["user"].stateArray[0]:"");
              localStorage.setItem("userTypeId", data["userType"].id);
              localStorage.setItem("isLoggedIn", "true");
              localStorage.setItem('gstNo', data["userType"].gstNo);
              localStorage.setItem('userTypeRole', data["userType"].userTypeRole);
              localStorage.setItem("userType", data["user"].userType);
              localStorage.setItem("userAccessType", data["user"].userAccessType);
              localStorage.setItem("firmName", data["user"].firmName);
              localStorage.setItem("personName", data["user"].personName);
              localStorage.setItem("noGst", data["user"].noGst);
              localStorage.setItem("isGstAvailable", data["user"].isGstAvailable);
              localStorage.setItem("ImageCollection", data["user"].ImageCollection);
              localStorage.setItem("brandName", data["userType"].brandName);
              localStorage.setItem("webURLName", data["user"].webURLName ? data["user"].webURLName : "");
            }

            //Here we wil set the currentFieldKeyId and fieldName int tjhe localStorage....
            // localStorage.setItem("currentFieldKeyId", localStorage.currentFieldKeyId);
            // if(data["user"]["CategoryCollection"] && data["user"]["CategoryCollection"][localStorage.currentFieldKeyId]) {


            //   localStorage.setItem("currentFieldKeyId", "5629499534213120");
            // var fieldName = "clothing";
            // localStorage.setItem("currentFieldName", "clothing");


            if (data["user"] && data["user"].fieldIdArray && data["user"].fieldIdArray.length > 0) {
              localStorage.setItem("currentFieldKeyId", data["user"].fieldIdArray[0]);
              var fieldName = data["user"].fieldNameArray[0].trim();
              localStorage.setItem("currentFieldName", fieldName);
            }

            //redirect after login success
            self.navCtrl.navigateRoot('/home');
            //create the object of the userDetails..
            if (loading) {
              //disable the loder
              loading.dismiss();
            }
            // } else {
            //   self.navCtrl.navigateRoot('/select-field');
            //   //create the object of the userDetails..
            //   if (loading) {
            //     //disable the loder
            //     loading.dismiss();
            //   }
            // }

            if (data["user"]['deviceType'] == self.ownerName && data["user"]['isByInvitation']) {
              let object = {
                reqToId: self.brokerUserId
              }
              // SEND REQUEST FROM self created user to New Welcom agency
              self.sendRequest(function (isSuccessSendRequest, param) {

              }, object)
            }
            // requesting permission for creating token id 
            if (!self.apk) {
              self.requestPushNotificationsPermission(localStorage.id);
            }
          } else {
            //dismiss loader
            if (loading) {
              //disable the loder
              loading.dismiss();
            }
          }
        });
      } else {
        //dismiss loader
        if (loading) {
          //disable the loder
          loading.dismiss();
        }
      }
    });
  }

  /*
    Author (s): Kapil soni
    @Copyright Notice:
    @Type: TS   
    @Description : folderRemoveShareWithAny for remove the userFrom collection
   */
  folderRemoveShareWithAny(callback, userId, userTypeId, productId, selectedUserIdForUnshare) {
    var self = this;
    let query = self.afs.collection("ShareWithAlbumCollection").ref
      .where("userId", "==", localStorage.id)
      .where("shareWithUserId", "==", userId)
      .where("productId", "==", productId)
    query.get().then(function (querySnapshot) {
      if (!querySnapshot.empty) {
        querySnapshot.docs[0].ref.delete().then(function () {
          // Start remove product from ShareWithTimestampCollection      
          self.afs.collection("ShareWithAlbumTimestampCollection").ref
            .where("logedInUserId", "==", localStorage.id)
            .where("fieldId", "==", localStorage.currentFieldKeyId)
            .where("shareWithUserId", "==", userId)
            .get().then(function (querySnapshot) {
              if (!querySnapshot.empty) {
                querySnapshot.forEach(function (data) {
                  // And save it again for more queries
                  var userObject = {};
                  var query1 = self.afs.collection("ShareWithAlbumTimestampCollection").doc(data.id).collection("sellers").doc(localStorage.id).collection("folders").doc(productId).ref
                  query1.get().then(function (docArray) {
                    if (docArray.exists) {
                      //deleted matched product
                      docArray.ref.delete();
                    } else {
                      var query2 = self.afs.collection("ShareWithAlbumTimestampCollection").doc(data.id).collection("sellers").doc(selectedUserIdForUnshare).collection("folders").doc(productId).ref
                      query2.get().then(function (docArray) {
                        if (docArray.exists) {
                          //deleted matched product
                          docArray.ref.delete();
                        }
                      })
                    }
                  })
                })
              }
              callback(true);
            }).catch(function (error) {
              callback(true);
              console.log("create an index", error);
            });
          // End remove product from ShareWithAlbumTimestampCollection   
          callback(true);
        }).catch(function (error) {
          callback(false);
        });
      } else {
        callback(true);
      }
    }).catch(function (error) {
      console.log("Error Documnet", error);
    })
  }


  /*
    Author (s): Kapil soni
    @Copyright Notice:
    @Type: TS   
    @Description : productRemoveShareWithAny for remove the userFrom collection
   */
  productRemoveShareWithAny(callback, userId, userTypeId, productId, selectedUserIdForUnshare) {
    var self = this;
    let query = self.afs.collection("ShareWithCollection").ref
      .where("userId", "==", localStorage.id)
      .where("shareWithUserId", "==", userId)
      .where("productId", "==", productId)
    query.get().then(function (querySnapshot) {
      if (!querySnapshot.empty) {
        querySnapshot.docs[0].ref.delete().then(function () {

          // Start remove product from cart if added
          self.afs.collection("UserCollection").doc(userId)
            .collection("CartListCollection").ref
            .where("productOrAlbumOrCatalogId", "==", productId)
            .get().then(function (querySnapshotCart) {
              if (!querySnapshotCart.empty) {
                querySnapshotCart.docs[0].ref.delete().then(function () {
                  localStorage.logendInUserCartCount--;

                }).catch(function (error) {

                  console.log("create an index", error);
                });
              }
            }).catch(function (error) {
              console.log("create an index", error);
            });
          // End remove product from cart if added
          // Start remove product from ShareWithTimestampCollection      
          self.afs.collection("ShareWithTimestampCollection").ref
            .where("logedInUserId", "==", localStorage.id)
            .where("fieldId", "==", localStorage.currentFieldKeyId)
            .where("shareWithUserId", "==", userId)
            .get().then(function (querySnapshot) {
              if (!querySnapshot.empty) {
                querySnapshot.forEach(function (data) {
                  // And save it again for more queries
                  var userObject = {};
                  var query1 = self.afs.collection("ShareWithTimestampCollection").doc(data.id).collection("sellers").doc(localStorage.id).collection("products").doc(productId).ref
                  query1.get().then(function (docArray) {
                    if (docArray.exists) {
                      //deleted matched product
                      docArray.ref.delete();
                    } else {
                      var query2 = self.afs.collection("ShareWithTimestampCollection").doc(data.id).collection("sellers").doc(selectedUserIdForUnshare).collection("products").doc(productId).ref
                      query2.get().then(function (docArray) {
                        if (docArray.exists) {
                          //deleted matched product
                          docArray.ref.delete();
                        }
                      })
                    }
                  })
                })
              }
              callback(true);
            }).catch(function (error) {
              callback(true);
              console.log("create an index", error);
            });
          // End remove product from ShareWithTimestampCollection   
          callback(true);
        }).catch(function (error) {
          callback(false);
        });
      } else {
        callback(true);
      }
    }).catch(function (error) {
      console.log("Error Documnet", error);
    })
    // 	}
    // });
  }



  //removeReShareWithInProduct for unshare 
  removeReShareWithInProduct(callback, productId, shareWithUserId) {
    var self = this;
    self.afs.collection("ProductCollection").ref.doc(productId)
      .collection("ReShareWithCollection").doc(shareWithUserId)
      .delete().then(function () {
        callback(true);
      }).catch(function (error) {
        callback(false);
      });
  }

  //removeReShareWithInFolder for unshare 
  removeReShareWithInFolder(callback, productId, shareWithUserId) {
    var self = this;
    self.afs.collection("ProductsAlbumCollection").ref.doc(productId)
      .collection("ReShareWithAlbumCollection").doc(shareWithUserId)
      .delete().then(function () {
        callback(true);
      }).catch(function (error) {
        callback(false);
      });
  }

  deleteFromRequestAccessList(callback, phoneNumber) {
    var query1 = this.afs.collection("RequestAccessCollection").ref;
    query1.where('phoneNumber', '==', phoneNumber).get().then(function (docArray) {
      if (docArray.empty) {

      } else {
        query1.doc(docArray.docs[0].id).delete().then(function () {
          callback(true);
        }).catch(function (error) {
          callback(false);
        });
      }
    })
  }

  //productRemoveReShareWithAny for unshare 
  productRemoveReShareWithAny(callback, userId, userTypeId, productId) {
    var self = this;
    var relConnectedId = firebase.auth().currentUser.uid;
    const timeStampProducts = [];
    self.afs.collection("ReShareWithCollection").ref
      .where("userId", "==", localStorage.id)
      .where("fieldId", "==", localStorage.currentFieldKeyId)
      .where("reShareWithUserId", "==", userId)
      .where("productId", "==", productId)
      .get().then(function (querySnapshot) {
        if (!querySnapshot.empty) {
          querySnapshot.docs[0].ref.delete().then(function () {
            self.afs.collection("ReShareWithTimestampCollection").ref
              .where("logedInUserId", "==", localStorage.id)
              .where("fieldId", "==", localStorage.currentFieldKeyId)
              .where("reShareWithUserId", "==", userId)
              .get().then(function (querySnapshot) {
                if (!querySnapshot.empty) {
                  querySnapshot.forEach(function (data) {
                    // And save it again for more queries
                    var userObject = {};
                    var query1 = self.afs.collection("ReShareWithTimestampCollection").doc(data.id).collection("sellers").doc(localStorage.id).collection("products").doc(productId).ref
                    query1.get().then(function (docArray) {
                      if (docArray.exists) {
                        //deleted matched product
                        docArray.ref.delete();
                      }
                    })
                  })
                }
                callback(true);
              }).catch(function (error) {
                callback(true);
                console.log("create an index", error);
              });
          })
        }
      }).catch(function (error) {
        callback(false);
        console.log("create an index", error);
      });
  }

  //folderRemoveReShareWithAny for unshare 
  folderRemoveReShareWithAny(callback, userId, userTypeId, productId) {
    var self = this;
    var relConnectedId = firebase.auth().currentUser.uid;
    const timeStampProducts = [];
    self.afs.collection("ReShareWithAlbumCollection").ref
      .where("userId", "==", localStorage.id)
      .where("fieldId", "==", localStorage.currentFieldKeyId)
      .where("reShareWithUserId", "==", userId)
      .where("productId", "==", productId)
      .get().then(function (querySnapshot) {
        if (!querySnapshot.empty) {
          querySnapshot.docs[0].ref.delete().then(function () {
            self.afs.collection("ReShareWithAlbumTimestampCollection").ref
              .where("logedInUserId", "==", localStorage.id)
              .where("fieldId", "==", localStorage.currentFieldKeyId)
              .where("reShareWithUserId", "==", userId)
              .get().then(function (querySnapshot) {
                if (!querySnapshot.empty) {
                  querySnapshot.forEach(function (data) {
                    // And save it again for more queries
                    var userObject = {};
                    var query1 = self.afs.collection("ReShareWithAlbumTimestampCollection").doc(data.id).collection("sellers").doc(localStorage.id).collection("folders").doc(productId).ref
                    query1.get().then(function (docArray) {
                      if (docArray.exists) {
                        //deleted matched product
                        docArray.ref.delete();
                      }
                    })
                  })
                }
                callback(true);
              }).catch(function (error) {
                callback(true);
                console.log("create an index", error);
              });
          })
        }
      }).catch(function (error) {
        callback(false);
        console.log("create an index", error);
      });
  }

  //removeShareWithInProductForOther function for remove share product with other user.  
  removeShareWithInProductForOther(callback, productId, userObject) {
    var self = this;
    var query: any;
    // Add a new document
    query = self.afs.collection("ProductCollection").ref.doc(productId)
      .collection("ShareWithCollection").get().then(function (querySnapshot) {
        if (!querySnapshot.empty) {
          querySnapshot.forEach(function (doc) {
            // doc.data() is never undefined for query doc snapshots
            doc.ref.collection("ShareWithCollection").doc(doc.data().userId)
              .delete().then(function () {

                self.afs.collection("ShareWithCollection").ref
                  .where("userId", "==", localStorage.id)
                  .where("shareWithUserId", "==", doc.data().userId)
                  .where("fieldId", "==", localStorage.currentFieldKeyId)
                  .where("productId", "==", productId)
                  .get().then(function (querySnapsort1) {
                    if (!querySnapsort1.empty) {
                      querySnapsort1.docs[0].ref.delete().then(function () {
                        // callback(true);
                      }).catch(function (error) {
                        // callback(false);
                      });
                    }
                  }).catch(function (error) {
                    console.log("Error Documents :", error);
                  });
              }).catch(function (error) {
                //callback(false);
                console.log("Error documents", error);
              });
          });
        }
        callback(true);
      })
      .catch(function (error) {
      });
  }

  //removeShareWithInFolderForOther function for remove share folder with other user.  
  removeShareWithInFolderForOther(callback, productId, userObject) {
    var self = this;
    var query: any;
    // Add a new document
    query = self.afs.collection("ProductsAlbumCollection").ref.doc(productId)
      .collection("ShareWithAlbumCollection").get().then(function (querySnapshot) {
        if (!querySnapshot.empty) {
          querySnapshot.forEach(function (doc) {
            // doc.data() is never undefined for query doc snapshots
            doc.ref.collection("ShareWithAlbumCollection").doc(doc.data().userId)
              .delete().then(function () {

                self.afs.collection("ShareWithAlbumCollection").ref
                  .where("userId", "==", localStorage.id)
                  .where("shareWithUserId", "==", doc.data().userId)
                  .where("fieldId", "==", localStorage.currentFieldKeyId)
                  .where("productId", "==", productId)
                  .get().then(function (querySnapsort1) {
                    if (!querySnapsort1.empty) {
                      querySnapsort1.docs[0].ref.delete().then(function () {
                        // callback(true);
                      }).catch(function (error) {
                        console.log("Error Documents :", error);
                      });
                    }
                  }).catch(function (error) {
                    console.log("Error Documents :", error);
                  });
              }).catch(function (error) {
                //callback(false);
                console.log("Error documents", error);
              });
          });
        }
        callback(true);
      })
      .catch(function (error) {
        console.log("error: ", error);
      });
  }

  /*
    Author (s): Kapil soni
    @Copyright Notice:
    @Type: TS   
    @Description : removeShareWithInProduct for remove the userFrom collection
   */
  removeShareWithInProduct(callback, productId, shareWithUserId) {
    var self = this;
    // Add a new document
    self.afs.collection("ProductCollection").doc(productId)
      .collection("ShareWithCollection").doc(shareWithUserId)
      .delete().then(function () {
        callback(true);
      }).catch(function (error) {
        callback(false);
      });
  }

  //removeShareWithInFolder for remove the userFrom collection
  removeShareWithInFolder(callback, productId, shareWithUserId) {
    var self = this;
    // Add a new document
    self.afs.collection("ProductsAlbumCollection").doc(productId)
      .collection("ShareWithAlbumCollection").doc(shareWithUserId)
      .delete().then(function () {
        callback(true);
      }).catch(function (error) {
        callback(false);
      });
  }

  /*
	 	@Author : kapil soni 
		@Copyright Notice:
	 	@Type: TS
		@For :  share-multiple product.html.
		@Description : removeShareWithInProductForGroup for unshare product fromt the group  
	 */
  removeShareWithInProductForGroup(callback, shareWithGrpId, productId) {
    var self = this;
    self.afs.collection("ProductCollection").doc(productId)
      .collection("ShareWithGroupCollection").doc(shareWithGrpId)
      .delete().then(function () {
        callback(true);
      }).catch(function (error) {
        callback(false);
      });
  }

  /*
 		@Author : kapil soni 
		@Copyright Notice:
 		@Type: TS
		@For :  share-multiple product.html.
		@Description : removeShareWithInGroupForProduct for un-share product in group  
	 */
  removeShareWithInGroupForProduct(callback, shareWithGrpId, productId) {
    var self = this;
    self.afs.collection("UserCollection").doc(localStorage.id)
      .collection("GroupCollection").doc(shareWithGrpId)
      .collection("ProductCollection").doc(productId)
      .delete().then(function () {
        callback(true);
      }).catch(function (error) {
        callback(false);
      });
  }

  // //request for notification token
  requestPushNotificationsPermission(userId) {
    this.afMessaging.requestToken // getting tokens
      .subscribe(
        (token) => { // USER-REQUESTED-TOKEN
          console.log('Permission granted! Save to the server!', token);
          if (token && userId) {
            this.addDeviceToken(userId, token);
          }
        },
        (error) => {
          // console.error(error);
          console.log(error);
        }
      );
  }

  /*
    @Author : Neha Gupta
    @Copyright Notice:
    @(#)
    @Type: TS   
    @For:  
    @Description : addInWishList() function for add product in wishlist.
  */
  addToCartProductInFirestore(callback, object, userTypeId) {
    var self = this;
    // update timestamp and navigator
    object["timestamp"] = firebase.firestore.FieldValue.serverTimestamp();
    object["createDate"] = firebase.firestore.FieldValue.serverTimestamp();

    //fetchCartListOneOrMany for check if already exist any object
    self.fetchCartListOneOrMany(function (isSuccess, docArray) {
      if (isSuccess) {
        if (docArray != null && docArray.length > 0) {
          // found wish list - with given parameters.
          // third param true - when product is already in cart
          callback(false, null, true);
        } else {
          // wish list not found with given parameters - so, creating new wish list.
          var userId = localStorage.id; // self.fireAuth.currentUser.uid;
          var docRef = self.afs.collection("UserCollection").doc(localStorage.id).ref
            .collection("CartListCollection").doc()

          // get key from doc and set in object - so that the doc unique key will stored in object. 
          object["id"] = docRef.id;
          object["userId"] = userId;
          object["fieldId"] = localStorage.currentFieldKeyId;
          // set new object in doc ref
          docRef.set(object).then(function () {

            localStorage.logendInUserCartCount++;

            self.addUserActivity({
              fromSendUserId: localStorage.id,
              fromPersonName: localStorage.personName,
              fromFirmName: localStorage.firmName,
              fromPersonNameLC: localStorage.personName.toLowerCase(),
              fromFirmNameLC: localStorage.firmName.toLowerCase(),
              fireForDesignNumber: object.productDesign ? object.productDesign : object.catalogDesign,
              fireFor: "ADD_TO_CART",
              fireCategoryKeyId: object.categoryId,
              fireFieldKeyId: localStorage.currentFieldKeyId,
              fireFieldName: localStorage.currentFieldName,
              firebaseCategoryName: localStorage.selCategName ? localStorage.selCategName.toLowerCase() : "",
              count: 1
            });
            //Fire notification - to share product.
            self.addFireNotification(object.sellerUserId, {
              fromSendUserId: localStorage.id,
              fromPersonName: localStorage.personName,
              fromFirmName: localStorage.firmName,
              fromPersonNameLC: localStorage.personName.toLowerCase(),
              fromFirmNameLC: localStorage.firmName.toLowerCase(),
              fireForDesignNumber: object.productDesign ? object.productDesign : object.catalogDesign,
              productsId: object.productOrAlbumOrCatalogId,
              toUserId: object.sellerUserId,
              fireFor: "ADD_TO_CART",
              fireCategoryKeyId: object.categoryId,
              fireFieldKeyId: localStorage.currentFieldKeyId,
              fireFieldName: localStorage.currentFieldName,
              firebaseCategoryName: localStorage.selCategName ? localStorage.selCategName.toLowerCase() : "",
              count: 1
            });
            // third param false - when product is not in cart
            callback(true, object, false);
          }).catch(function (error) {
            console.log("document error", error);
            // third param false - when product is not in cart
            callback(false, null, false);
          });
        }
      }
    }, null, object, "");
  }

  /*
    @Author : Kapil soni
    @Copyright Notice:
    @Type: TS   
    @Description : getCartListOfCatalog function for get cartList....
  */
  getCartListOfCatalog(callback: any, catalogObject: any, limit) {
    var self = this;
    var list = [];
    var lastVisible: any;
    if (limit != "") {
      //create the firs-tore query for get the data via category wise and subCategoryWise from the firestore .....
      var query = self.afs.collection("UserCollection").doc(localStorage.id).ref
        .collection("CartListCollection")
        .where("sellerUserId", "==", catalogObject.sellerUserId)
        .limit(limit);
      query.get().then(function (querySnapshot) {
        //hold the last visible if the product.....
        lastVisible = querySnapshot.docs[querySnapshot.docs.length - 1];

        querySnapshot.forEach(function (doc) {
          // doc.data() is never undefined for query doc snapshots
          var object = doc.data();
          object['productId'] = object.productObject.id;
          list.push(object);
        });
        callback(true, list, catalogObject.categoryId);
      }).catch(function (error) {
        callback(false, list, catalogObject.categoryId);
      });
    } else {
      //create the firs-tore query for get the data via category wise and subCategoryWise from the firestore .....
      var query = self.afs.collection("UserCollection").doc(localStorage.id).ref
        .collection("CartListCollection")
        .where("sellerUserId", "==", catalogObject.sellerUserId);

      query.get().then(function (querySnapshot) {
        //hold the last visible if the product.....
        lastVisible = querySnapshot.docs[querySnapshot.docs.length - 1];

        querySnapshot.forEach(function (doc) {
          // doc.data() is never undefined for query doc snapshots
          var object = doc.data();
          object['productId'] = object.productObject.id;
          list.push(object);
        });
        callback(true, list, catalogObject.categoryId);
      }).catch(function (error) {
        callback(false, list, catalogObject.categoryId);
      });
    }
  }

  //getProductShareWithAnyById
  getProductShareWithAnyById(callback, userId, userTypeId, productId, relConnectedId, returnData) {

    var db = this.afs;
    var query = db.collection("ShareWithCollection").ref
      .where("userId", "==", relConnectedId)
      .where("fieldId", "==", localStorage.currentFieldKeyId)
      .where("shareWithUserId", "==", userId)
      .where("productId", "==", productId);
    query.get().then(function (querySnapsort) {
      if (!querySnapsort.empty) {
        let docData = querySnapsort.docs[0].data();
        callback(true, docData, returnData);
      } else {
        callback(true, null, returnData);
      }
    })
      .catch(function (error) {
        console.log("Error adding document: ", error);
        callback(true, null, returnData);
      });
  }


  //return products detail with some other data in callback 
  fetchProductDocumentWithData(callback, objectData, sharedDate) {
    //create the path of the firestore..
    var db = this.afs;
    var docRef: any;
    if (objectData.sharedSellerUserId) {
      docRef = db.collection("ProductCollection").doc(objectData.productOrAlbumOrCatalogId).ref;
    } else {
      docRef = db.collection("ProductCollection").doc(objectData.productOrAlbumOrCatalogId).ref;
    }
    docRef.get().then(function (doc) {
      if (doc.exists) {
        callback(true, doc.data(), objectData, sharedDate);
      } else {
        callback(false, null, objectData, sharedDate);
      }
    }).catch(function (error) {
    });
  }

  /*
  @Author : Kapil soni
  @Copyright Notice:
  @Type: TS   
  @Description : fetchCartListOneOrMany() function for fetch CartListCollection product....
  */
  fetchCartListOneOrMany(callback, next, object, userTypeId) {
    var self = this;
    //var userId = firebase.auth().currentUser.uid;
    var query: any;
    query = this.afs.collection("UserCollection").doc(localStorage.id).ref
      .collection("CartListCollection");

    if (object.productOrAlbumOrCatalog) {
      query = query.where("productOrAlbumOrCatalog", "==", String(object.productOrAlbumOrCatalog));
    }
    if (object.productOrAlbumOrCatalogId) {
      query = query.where("productOrAlbumOrCatalogId", "==", String(object.productOrAlbumOrCatalogId));
    }
    // if (object.categoryId) {
    //   query = query.where("categoryId", "==", String(object.categoryId));
    // }
    // if (object.subCategoryId) {
    //   query = query.where("subCategoryId", "==", String(object.subCategoryId));
    // }
    // get doc - doc of fire notification by giving different param in different cases.
    query.orderBy("timestamp", "desc");

    if (!next && next != null) {
      // using pagination - calling first time
      self.fetchWishListOneOrManyFN = query.limit(10);

      self.fetchWishListOneOrManyFN.get().then(function (querySnapshot) {
        if (!querySnapshot.empty) {
          var docArray = [];
          querySnapshot.forEach(function (doc) {
            docArray.push(doc.data());
          });
          callback(true, docArray);
        } else {
          callback(true, null);
        }
      }).catch(function (error) {
        callback(false, null);
      });
    }
    else if (next && next != null) {
      self.fetchWishListOneOrManyFN = query;
      // using pagination - calling from show more button
      return self.fetchWishListOneOrManyFN.get().then(function (documentSnapshots) {
        // Get the last visible document
        var lastVisible = documentSnapshots.docs[documentSnapshots.docs.length - 1];

        // Construct a new query starting at this document,
        // get the next 5.
        if (lastVisible != undefined) {
          self.fetchWishListOneOrManyFN = query.startAfter(lastVisible).limit(10);
          self.fetchWishListOneOrManyFN.get().then(function (querySnapshot) {
            if (!querySnapshot.empty) {
              var docArray = [];
              querySnapshot.forEach(function (doc) {
                docArray.push(doc.data());
              });
              callback(true, docArray);
            } else {
              callback(true, null);
            }
          }).catch(function (error) {
            callback(false, null);
          });
        } else {
          callback(true, null);
        }
      });
    }
    else {
      query.get().then(function (querySnapshot) {
        if (!querySnapshot.empty) {
          var docArray = [];
          querySnapshot.forEach(function (doc) {
            docArray.push(doc.data());
          });
          callback(true, docArray);
        } else {
          callback(true, null);
        }
      }).catch(function (error) {
        callback(false, null);
      });
    }
  }

  /*
    @Author : Kapil soni
    @Copyright Notice:
    @Type: TS   
    @Description : productRemoveFromCartCollection function for remove product from cart 
  */
  productRemoveFromCartCollection(callback, key, userTypeId) {
    var self = this;
    //var userId = firebase.auth().currentUser.uid;
    //if id exist
    if (localStorage.id) {
      self.afs.collection("UserCollection").doc(localStorage.id)
        .collection("CartListCollection").doc(key)
        .delete().then(function () {
          // add user activity - because WishList is deleted.
          // self.addUserActivity({
          //   fireFor: "REMOVE_FROM_WISHLIST",
          //   objectKey: key
          // });
          // do callback
          // decrease cart Count in localStorage
          localStorage.logendInUserCartCount--;
          callback(true);
        }).catch(function (error) {
          // do callback
          callback(false);
        });
    }
  }

  /*
  @Author : Neha Gupta
  @Copyright Notice:
  @(#)
  @Type: TS   
  @For:  
  @Description : removeFromWishList() function for remove product from wishlist. 
  */
  productRemoveFromCart(callback, object, userTypeId) {
    var self = this;

    //productRemoveFromCart for remove product from cart
    self.fetchCartListOneOrMany(function (isSuccess, docArray) {
      if (isSuccess) {
        if (docArray != null && docArray.length) {
          // found WishList - with given parameters.
          self.productRemoveFromCartCollection(function (isSuccess) {
            callback(isSuccess);
          }, docArray[0].id, "");
        }
      }
    }, null, object, "");
  }


  /*
  @Author : Kapil soni
  @Copyright Notice:
  @(#)
  @Type: TS   
  @Description : createOrderColletionInFirestore() function for create Order in firestore
  */
  createOrderColletionInFirestore(callback, object: any) {
    //if currentFieldKeyId exist....
    var self = this;
    if (localStorage.currentFieldKeyId != "" && localStorage.currentFieldKeyId != undefined) {

      // update timestamp and navigator
      object["timestamp"] = firebase.firestore.FieldValue.serverTimestamp();
      object["createDate"] = firebase.firestore.FieldValue.serverTimestamp();

      // order not found with given parameters - so, creating new WishlistPair.
      var docRef = self.afs.collection("OrderCollection").ref.doc();
      if (object["orderId"] == "" || object["orderId"] == undefined) {
        //generate the order Id
        var autoOrderId = Math.floor(100000 + Math.random() * 900000);
        object["orderId"] = "RB" + autoOrderId;
      }

      // get key from doc and set in object - so that the doc unique key will stored in object. 
      object["id"] = docRef.id;
      // set new object in doc ref....
      if (object.id) {
        docRef.set(object).then(function () {
          //set tje callback
          callback(true);
        }).catch(function (error) {
          callback(false);
        });
      }
    }
  }


  logOut = () => {
    var self = this;
    firebase.auth().signOut().then(function () {
      // Sign-out successful.
      localStorage.clear();
      self.navCtrl.navigateForward('/login');

    }).catch(function (error) {
      console.log('Sign Out Error' + error);
    });
  }

  getImageThumb(url) {
    if (url.indexOf("NEWTHUMB") != -1 && url.indexOf("products%2F") != -1) {
      // replacing current image to 128KB version of image - by opening thumb_128_ version
      //url = url.replace('products%2F', 'products%2Fthumb%4064_');
      //url = url.replace('products%2F', 'products%2Fthumb%40128_');//128x128px
      url = url.replace('products%2F', 'products%2Fthumb%40256_');//256x256px
    } else if (url.indexOf("NEWTHUMB") != -1 && url.indexOf("users%2F") != -1) {
      //url = url.replace('users%2F', 'users%2Fthumb%4064_');
      //url = url.replace('users%2F', 'users%2Fthumb%40128_');//128x128px
      url = url.replace('users%2F', 'users%2Fthumb%40256_');//256x256px
    }
    return url;
  }


  //add user activity - this will call when anything action taken by user - to record its activity.
  addUserActivity(object): any {
    var self = this;
    // update timestamp and navigator
    object["timestamp"] = firebase.firestore.FieldValue.serverTimestamp();
    object["createDate"] = firebase.firestore.FieldValue.serverTimestamp();
    object["userTypeKeyId"] = localStorage.id;
    object["isRead"] = false;

    object["logedInUserTypeKeyId"] = localStorage.id;
    object["logedInPersonName"] = localStorage.personName;
    object["logedInPersonNameLC"] = localStorage.personName.toLowerCase();
    object["logedInFirmName"] = localStorage.firmName;
    object["logedInFirmNameLC"] = localStorage.firmName.toLowerCase();
    if (localStorage.currentFieldKeyId != undefined) {
      object["fieldKeyId"] = localStorage.currentFieldKeyId;
    }

    // object - productId, userId, userType, categoryId, subCategoryId, firmName, personName
    if (localStorage.currentFieldKeyId != undefined && localStorage.currentFieldKeyId != null) {
      // Add a new document
      self.afs.collection("ActivityCollection").ref.doc()
        .set(object)
        .then(function (docRef) {
        })
        .catch(function (error) {
        });
    }
  }

  //sendLinkTextMsg
  sendLinkTextMsg(callback, object) {
    var self = this;
    var url = "";
    url = "https://api-alerts.kaleyra.com/v4/?api_key=Acef34d3fdc64a3be52612c6753951f9e&method=sms&message=" + object.msg
      + "&sender=RISING&to=" + object.mobileNo;

    var headers = {
      headers: new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' })
    };
    //Pass the data into the API and create the user

    const promise = self.http.get(url, headers).toPromise();
    promise
      .then(data => callback(true))
      .catch(e => callback(false));
  }

  //sign up user
  async signupUserGCP(object: any) {
    var self = this;
    var url = "";
    var body = "";
    var paramBody = {};
    //Here we will call the API selected userType
    if (object.userType != "" && object.userType != undefined) {
      if (environment.APK) {
        switch (object.userType) {
          case 'buyer':
            url = environment.API_HOST + "/api/buyer/f/create";
            paramBody = {
              'personName': object.personName, "userTypeDto.personName": object.personName,
              'firmName': object.firmName, "userTypeDto.firmName": object.firmName,
              'email': object.email, "userTypeDto.email": object.email,
              'phoneNumber': object.phoneNumber, "userTypeDto.phoneNumber": object.phoneNumber,
              'userType': object.userType, "password": object.password,
              "userTypeDto.password": object.password, "gstNo": '', "noGst": true,
              "userTypeRole": object.userTypeRole, "userAccessType": object.profileAccessType,
              "emailAM": "connected", "isByInvitation": object.isByInvitation,
              "userTypeDto.isByInvitation": object.isByInvitation,
              "deviceType": self.ownerName, "phoneVerified": false, "userCreatedBy": self.ownerName
            }
            break;
          case 'seller':
            url = environment.API_HOST + "/api/seller/f/create";
            paramBody = {
              'personName': object.personName, "userTypeDto.personName": object.personName,
              'firmName': object.firmName, "userTypeDto.firmName": object.firmName,
              'email': object.email, "userTypeDto.email": object.email,
              'phoneNumber': object.phoneNumber, "userTypeDto.phoneNumber": object.phoneNumber,
              'userType': object.userType, "password": object.password,
              "userTypeDto.password": object.password, "gstNo": '', "noGst": true,
              "userTypeRole": object.userTypeRole, "userAccessType": object.profileAccessType,
              "emailAM": "connected", "isByInvitation": false, "deviceType": "app", "phoneVerified": false
            }
            break;
          case 'intermediary':
            url = environment.API_HOST + "/api/intermediary/f/create";
            paramBody = {
              'personName': object.personName, "userTypeDto.personName": object.personName,
              'firmName': object.firmName, "userTypeDto.firmName": object.firmName,
              'email': object.email, "userTypeDto.email": object.email,
              'phoneNumber': object.phoneNumber, "userTypeDto.phoneNumber": object.phoneNumber,
              'userType': object.userType, "password": object.password,
              "userTypeDto.password": object.password, "gstNo": '', "noGst": true,
              "userTypeRole": object.userTypeRole, "userAccessType": object.profileAccessType,
              "emailAM": "connected", "isByInvitation": object.isByInvitation,
              "userTypeDto.isByInvitation": object.isByInvitation,
              "deviceType": self.ownerName, "phoneVerified": false, "userCreatedBy": self.ownerName

            }
            break;
          case 'other':
            url = environment.API_HOST + "/api/intermediary/f/create/other";
            paramBody = {
              'personName': object.personName, "userTypeDto.personName": object.personName,
              'firmName': object.firmName, "userTypeDto.firmName": object.firmName,
              'email': object.email, "userTypeDto.email": object.email,
              'phoneNumber': object.phoneNumber, "userTypeDto.phoneNumber": object.phoneNumber,
              'userType': object.userType, "password": object.password,
              "userTypeDto.password": object.password, "gstNo": '', "noGst": true,
              "userTypeRole": object.userTypeRole, "userAccessType": object.profileAccessType,
              "emailAM": "connected", "isByInvitation": false, "deviceType": "app", "phoneVerified": false
            }
            break;
        }
        //Pass the data into the API and create the user
        if (url && paramBody) {
          return self.nativeHttp.post(url, paramBody, { 'Content-Type': 'application/x-www-form-urlencoded' })
            .then(res => {
              let data = JSON.parse(res.data);
              // return data1;
              return data;
            })
            .catch(error => {
              console.log(error)
            });
        }



      } else {

        switch (object.userType) {
          case 'buyer':
            url = self.API_HOST + "/api/buyer/f/create";
            body = 'personName=' + object.personName + "&userTypeDto.personName=" + object.personName +
              '&firmName=' + object.firmName + "&userTypeDto.firmName=" + object.firmName +
              '&email=' + object.email + "&userTypeDto.email=" + object.email +
              '&phoneNumber=' + object.phoneNumber + "&userTypeDto.phoneNumber=" + object.phoneNumber +
              '&userType=' + object.userType + "&password=" + object.password +
              "&userTypeDto.password=" + object.password + "&gstNo=" + '' + "&noGst=" + true +
              "&userTypeRole=" + object.userTypeRole + "&userAccessType=" + object.profileAccessType +
              "&emailAM=connected&isByInvitation=" + object.isByInvitation + "&userTypeDto.isByInvitation=" + object.isByInvitation +
              "&deviceType=" + self.ownerName + "&phoneVerified=" + false + "&userCreatedBy=" + self.ownerName;
            break;
          case 'seller':
            url = self.API_HOST + "/api/seller/f/create";
            body = 'personName=' + object.personName + "&userTypeDto.personName=" + object.personName +
              '&firmName=' + object.firmName + "&userTypeDto.firmName=" + object.firmName +
              '&email=' + object.email + "&userTypeDto.email=" + object.email +
              '&phoneNumber=' + object.phoneNumber + "&userTypeDto.phoneNumber=" + object.phoneNumber +
              '&userType=' + object.userType + "&password=" + object.password +
              "&userTypeDto.password=" + object.password + "&gstNo=" + '' + "&noGst=" + true +
              "&userTypeRole=" + object.userTypeRole + "&userAccessType=" + object.profileAccessType +
              "&emailAM=connected&isByInvitation=" + object.isByInvitation + "&deviceType=" + self.ownerName + "&phoneVerified=" + false + "&userCreatedBy" + self.ownerName;
            break;
          case 'intermediary':
            url = self.API_HOST + "/api/intermediary/f/create";
            body = 'personName=' + object.personName + "&userTypeDto.personName=" + object.personName +
              '&firmName=' + object.firmName + "&userTypeDto.firmName=" + object.firmName +
              '&email=' + object.email + "&userTypeDto.email=" + object.email +
              '&phoneNumber=' + object.phoneNumber + "&userTypeDto.phoneNumber=" + object.phoneNumber +
              '&userType=' + object.userType + "&password=" + object.password +
              "&userTypeDto.password=" + object.password + "&gstNo=" + '' + "&noGst=" + true +
              "&userTypeRole=" + object.userTypeRole + "&userAccessType=" + object.profileAccessType +
              "&emailAM=connected&isByInvitation=" + object.isByInvitation + "&userTypeDto.isByInvitation=" + object.isByInvitation +
              "&deviceType=" + self.ownerName + "&phoneVerified=" + false + "&userCreatedBy=" + self.ownerName;
            break;
          case 'other':
            url = self.API_HOST + "/api/intermediary/f/create/other";
            body = 'personName=' + object.personName + "&userTypeDto.personName=" + object.personName +
              '&firmName=' + object.firmName + "&userTypeDto.firmName=" + object.firmName +
              '&email=' + object.email + "&userTypeDto.email=" + object.email +
              '&phoneNumber=' + object.phoneNumber + "&userTypeDto.phoneNumber=" + object.phoneNumber +
              '&userType=' + object.userType + "&password=" + object.password +
              "&userTypeDto.password=" + object.password + "&gstNo=" + '' + "&noGst=" + true +
              "&userTypeRole=" + object.userTypeRole + "&userAccessType=" + object.profileAccessType +
              "&emailAM=connected&isByInvitation" + object.isByInvitation + "&deviceType=" + self.ownerName + "&phoneVerified=" + false + "&userCreatedBy=" + self.ownerName;
            break;
        }
        var headers = {
          headers: new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' })
        };
        //Pass the data into the API and create the user
        if (url && body) {
          const observable = self.http.post(url, body, headers);
          return observable.toPromise();

        } else {
          return Promise.reject('Invalid url or body');
        }
      }
    } else {
      return Promise.reject("userType is not selected or blank");
    }
  }

  // fetching UsersGroup (by seller) - group of buyers/others based on given parameter.
  fetchUsersGroup(callback, groupNameLC) {
    var docRef: any;
    docRef = this.afs.collection("UserCollection").ref.doc(localStorage.id)
      .collection("GroupCollection");

    if (groupNameLC) {
      docRef = docRef.where("groupNameLC", "==", groupNameLC);
      docRef = docRef.where("fieldId", "==", localStorage.currentFieldKeyId).orderBy("timestamp", "desc");
      docRef.get().then(function (querySnapshot) {
        if (!querySnapshot.empty) {
          var docArray = [];
          querySnapshot.forEach(function (doc) {
            var groupData = doc.data();
            // fetch UserCollection of GroupCollection
            // docRef.doc(doc.id).collection("UserCollection")
            // .get().then(function(querySnapshotUC) {
            // 	if (!querySnapshotUC.empty) {
            // 		var docUserArray = [];
            // 		querySnapshotUC.forEach(function(docUC) {
            // 			docUserArray.push(docUC.data());
            // 		});
            // set userCollection users in groupData
            //groupData["UserCollection"] = docUserArray; 
            // add groupData in array.
            docArray.push(groupData);
            callback(true, docArray);

            //	});
          });
        } else {
          callback(true, null);
        }
      });
    } else {
      docRef.get().then(function (querySnapshot) {
        if (!querySnapshot.empty) {
          var docArray = [];
          var groupSize = querySnapshot.size;
          //
          querySnapshot.forEach(function (doc) {
            var groupData = doc.data();
            // fetch UserCollection of GroupCollection
            docRef.doc(doc.id).collection("UserCollection").get().then(function (querySnapshotUC) {
              if (!querySnapshotUC.empty) {
                var docUserArray = [];
                querySnapshotUC.forEach(function (docUC) {
                  docUserArray.push(docUC.data());
                });
                // set userCollection users in groupData
                groupData["UserCollection"] = docUserArray;
                // add groupData in array.
                docArray.push(groupData);
                if (groupSize == docArray.length) {
                  callback(true, docArray);
                }
              }
            });
          });
        } else {
          callback(true, null);
        }
      });
    }
  }

  // create new UsersGroup - by seller only.
  createUsersGroup(callback, object) {
    var self = this;
    // update timestamp and navigator
    object["timestamp"] = firebase.firestore.FieldValue.serverTimestamp();
    object["createDate"] = firebase.firestore.FieldValue.serverTimestamp();

    self.fetchUsersGroup(function (isSuccess, docArray) {
      if (isSuccess) {
        if (docArray && docArray.length > 0) {
          // found catalog - with given parameters.
          // so return false - that is catalog already exist with given name.
          callback(false);
        }
        else {
          // Add a new document
          var collectionRef = self.afs.collection("UserCollection").ref.doc(localStorage.id)
            .collection("GroupCollection");
          //.where("fieldId", "==", localStorage.currentFieldKeyId);

          var documentRef = collectionRef.doc();

          var userList = object.userList;
          // remove because we don't need this in group document
          // we are storing userList in separate Usercollection inside GroupDocument
          delete object['userList'];

          // set the group id into the group details..
          object["id"] = documentRef.id;
          documentRef.set(object)
            .then(function (docRef) {
              //add userCollection in GroupCollection
              for (var i = 0; i < userList.length; i++) {
                var user = userList[i];
                //user["id"] = user;
                // add user in UserCollection inside GroupCollection
                collectionRef.doc(documentRef.id).collection("UserCollection")
                  .doc(user.userId).set(user);
              }

              callback(true);
            })
            .catch(function (error) {
              callback(false);
            });
        }
      }
    }, object.groupNameLC);
  }


  goBack(previousPageUrl, dataObject) {
    const navigationExtras: NavigationExtras = { state: { data: dataObject } };
    this.navCtrl.navigateBack(previousPageUrl, navigationExtras);
  }

  //set object in shareProductWithUserFunction collection
  shareProductWithUserFunction(callback, object) {
    let self = this;

    if (object.shareTimeUnit && object.shareTimeValue) {
      let productIdArray: any = [];
      let userIdArray: any = [];
      for (let product of object.productArray) {
        productIdArray.push(product.productId);
      }

      for (let user of object.userArray) {
        userIdArray.push(user.userId);
      }

      var unshareAfterTImeOut = {
        "userId": localStorage.id,
        "productArray": productIdArray,
        'sharedUserArray': userIdArray,
        "shareTimeUnit": object.shareTimeUnit ? object.shareTimeUnit : '',
        "shareTimeValue": object.shareTimeValue ? object.shareTimeValue : '',
        'timestamp': firebase.firestore.FieldValue.serverTimestamp()
      }
    }

    object["timestamp"] = firebase.firestore.FieldValue.serverTimestamp();
    let docRefId = this.afs.collection("shareProductWithUserFunction").ref.doc().id;
    object["id"] = docRefId;
    let docRef = this.afs.collection("shareProductWithUserFunction")
      .doc(docRefId).set(object)
      .then(function (docRef) {

        // send message of product sharing
        if (object.userArray) {
          for (var i = 0; i < object.userArray.length; i++) {
            var object3 = {
              'countryCode': "+91",
              'mobileNo': Number(object.userArray[i].userPhoneNumber),
              'msg': 'Dear, ' + object.userArray[i].firmName + ' , ' + localStorage.firmName
                + ' has shared ' + object.productArray.length
                + ' product with you. to view products, login with your phone number ' + Number(object.userArray[i].userPhoneNumber) + '  ' + (object.userArray[i].userType == "buyer" ? self.ownerUrl : '') + '.'
            }
            self.sendLinkTextMsg(function (isSuccess) {

            }, object3);

            self.addFireNotification(object.userArray[i].userId, {
              toUserId: object.userArray[i].userId,
              userObj: self.userInfo,
              fromUserId: localStorage.id,
              fromPersonName: localStorage.personName,
              fromFirmName: localStorage.firmName,
              fromPersonNameLC: localStorage.personName.toLowerCase(),
              fromFirmNameLC: localStorage.firmName.toLowerCase(),
              fireFor: "SHARED_PRODUCT",
              fireCategoryKeyId: "",
              fireFieldKeyId: localStorage.currentFieldKeyId,
              fireFieldName: localStorage.currentFieldName,
              productsId: "",
              count: object.productArray.length,
              firebaseCategoryName: "",
              isRead: false,
              toUser: object.userArray[i],
            });
          };
        }

        if (object.shareTimeUnit && object.shareTimeValue) {
          self.documentAddForUnshareAfteTimeOut(unshareAfterTImeOut);
        }
        callback(true);
      })
      .catch(function (error) {
        console.error("Error writing document3: ", error);
      });
  }

  documentAddForUnshareAfteTimeOut(object) {
    const self = this;
    let docRef = this.afs.collection("UnshareAfterTimeOut").add(object)
      .then(function (docRef) {
        self.afs.collection("UnshareAfterTimeOut").doc(docRef.id).ref.get().then(function (querySnapshotUC) {
          if (querySnapshotUC.exists) {
            var shareEndTimeStamp;
            var docUserArray = querySnapshotUC.data();
            var timestampDoc = moment(docUserArray['timestamp']['nenoseconds']);

            if (docUserArray['shareTimeUnit'] == 'day') {
              shareEndTimeStamp = timestampDoc.add(Number(docUserArray['shareTimeValue']), 'days');
            } else if (docUserArray['shareTimeUnit'] == 'hour') {
              shareEndTimeStamp = timestampDoc.add(Number(docUserArray['shareTimeValue']), 'hours');
            } else if (docUserArray['shareTimeUnit'] == 'minute') {
              shareEndTimeStamp = timestampDoc.add(Number(docUserArray['shareTimeValue']), 'minutes');
            } else {
              shareEndTimeStamp = timestampDoc;
            }

            let object = {};
            object['shareEndTimeStamp'] = shareEndTimeStamp._d;
            if (shareEndTimeStamp) {
              self.afs.collection("UnshareAfterTimeOut").ref.doc(docRef.id).update(object).then(function () {
                console.log('updated');
              });
            }
          }
        })
      })
  }

  //set object in shareAlbumWithUserFunction collection
  //set object in shareAlbumWithUserFunction collection
  shareAlbumWithUserFunction(callback, object) {
    let self = this;

    if (object.shareTimeUnit && object.shareTimeValue) {
      let folderIdArray: any = [];
      let userIdArray: any = [];
      for (let album of object.albumArray) {
        folderIdArray.push(album.productId);
      }

      for (let user of object.userArray) {
        userIdArray.push(user.userId);
      }

      var unshareFolderAfterTimeOut = {
        "userId": localStorage.id,
        "folderArray": folderIdArray,
        'sharedUserArray': userIdArray,
        "shareTimeUnit": object.shareTimeUnit ? object.shareTimeUnit : '',
        "shareTimeValue": object.shareTimeValue ? object.shareTimeValue : '',
        'timestamp': firebase.firestore.FieldValue.serverTimestamp()
      }
    }

    object["timestamp"] = firebase.firestore.FieldValue.serverTimestamp();
    let docRefId = this.afs.collection("shareProductWithUserFunction").ref.doc().id;
    object["id"] = docRefId;
    let docRef = this.afs.collection("shareProductWithUserFunction")
      .doc(docRefId).set(object)
      .then(function (docRef) {

        // send message of product sharing
					if(object.userArray) {
						for (var i = 0; i < object.userArray.length; i++) {

              // let albumTimeStampObject = {
              //   logedInUserId   : localStorage.id ,
              //   shareWithUserId : object.userArray[i].userId,
              //   timestamp      : firebase.firestore.FieldValue.serverTimestamp(),
              //   fieldId        : localStorage.currentFieldKeyId
              // };
              //create or update collection 
              // let query3 =  self.afs.collection("ShareWithAlbumTimestampCollection").ref.doc().id;
              //   albumTimeStampObject["id"] = query3;
              //   let query4 = self.afs.collection("ShareWithAlbumTimestampCollection").doc(query3).set(albumTimeStampObject)
              //   .then(function(docRef) {
							// 	}).catch(function(error) {
							// 		console.log("Error adding document: ", error);
							// 	});
                //send link text msg
								var object3 = {
									'countryCode' : "+91",
									'mobileNo'    : Number(object.userArray[i].userPhoneNumber),
									'msg'         : 'Dear, ' + object.userArray[i].firmName +' , '+ localStorage.firmName 
													+' has shared '+ object.albumArray.length  
													+' folder with you. to view folder, login with your phone number ' + Number(object.userArray[i].userPhoneNumber) + '  ' + (object.userArray[i].userType == "buyer" ? self.ownerUrl : '')+'.'
							  } 
								self.sendLinkTextMsg(function (isSuccess) {
									
                }, object3);
                
                self.addFireNotification(object.userArray[i].userId, {
                  toUserId: object.userArray[i].userId,
                  userObj: self.userInfo,
                  fromUserId: localStorage.id,
                  fromPersonName: localStorage.personName,
                  fromFirmName: localStorage.firmName,
                  fromPersonNameLC: localStorage.personName.toLowerCase(),
                  fromFirmNameLC: localStorage.firmName.toLowerCase(),
                  fireFor: "SHARED_FOLDER",
                  fireCategoryKeyId: "",
                  fireFieldKeyId: localStorage.currentFieldKeyId,
                  fireFieldName: localStorage.currentFieldName,
                  productsId: "",
                  count: object.albumArray.length,
                  firebaseCategoryName: "",
                  isRead: false
                });
						};
          }
          
          if (object.shareTimeUnit && object.shareTimeValue) {
            self.folderDocumentAddForUnshareAfteTimeOut(unshareFolderAfterTimeOut);
          }
        callback(true);
      })
      .catch(function (error) {
        console.error("Error writing document3: ", error);
      });
  }

  folderDocumentAddForUnshareAfteTimeOut (object) {
    const self = this;
    let docRef = this.afs.collection("UnshareFolderAfterTimeOut").add(object)
    .then(function (docRef) {
      self.afs.collection("UnshareFolderAfterTimeOut").doc(docRef.id).ref.get().then(function(querySnapshotUC) {
        if (querySnapshotUC.exists) {
          var shareEndTimeStamp;
          var docUserArray = querySnapshotUC.data();
          var timestampDoc = moment(docUserArray['timestamp']['nenoseconds']);

          if (docUserArray['shareTimeUnit'] == 'day') {
            shareEndTimeStamp = timestampDoc.add(Number(docUserArray['shareTimeValue']), 'days');
          } else if (docUserArray['shareTimeUnit'] == 'hour') {
            shareEndTimeStamp = timestampDoc.add(Number(docUserArray['shareTimeValue']), 'hours');
          } else if (docUserArray['shareTimeUnit'] == 'minute') {
            shareEndTimeStamp = timestampDoc.add(Number(docUserArray['shareTimeValue']), 'minutes');
          } else {
            shareEndTimeStamp = timestampDoc;
          }

          let object = {};
          object['shareEndTimeStamp'] = shareEndTimeStamp._d;
          if (shareEndTimeStamp) {
            self.afs.collection("UnshareFolderAfterTimeOut").ref.doc(docRef.id).update(object).then(function() {
              console.log('updated');
            });
          }
        }
      })
    })
  }


  /*
      @Copyright Notice:
      @(#) : Function will call by seller for store group details( with whom seller will share product) in seller. 
        @Type: js
        @For :   gg-app.html.
        @Description : Actual function for share product with group.  
     */
  shareWithInProductForGroup(callback: any, shareWithGrpId: any, productId: any, object: any) {
    var self = this;
    object["productId"] = productId;

    // Add a new document
    self.afs.collection("ProductCollection").ref.doc(productId)
      .collection("ShareWithGroupCollection").doc(shareWithGrpId)
      .set(object)
      .then(function (docRef) {
        callback(true);
      }).catch(function (error) {
        console.error("Error adding document: ", error);
        callback(false);
      });
  }

  // fetching UsersGroup (by seller) - group will be fetched by given doc key (group key).
  fetchUsersGroupByKey(callback, key) {
    var db = this.afs;
    var docRef = db.collection("UserCollection").ref.doc(localStorage.id)
      .collection("GroupCollection").doc(key);
    docRef.get().then(function (doc) {
      if (doc.exists) {
        var groupData = doc.data();
        // fetch UserCollection of GroupCollection
        docRef.collection("UserCollection")
          .get().then(function (querySnapshotUC) {
            if (!querySnapshotUC.empty) {
              var docUserArray = [];
              querySnapshotUC.forEach(function (docUC) {
                docUserArray.push(docUC.data());
              });
              // set userCollection users in groupData
              groupData["UserCollection"] = docUserArray;
              callback(true, groupData);
            }
          });
      } else {
        callback(false, null);
      }
    }).catch(function (error) {
      //callback(false, null);
    });
  }

  // update UsersGroup - by seller only - of a given key.
  updateUsersGroup(callback, groupId, object) {
    var self = this;
    // update timestamp and navigator
    object["timestamp"] = firebase.firestore.FieldValue.serverTimestamp();

    // Add a new document
    var collectionRef = self.afs.collection("UserCollection").ref.doc(localStorage.id)
      .collection("GroupCollection").doc(groupId).collection("UserCollection");

    if (object.userList.length != 0) {
      // add userCollection in GroupCollection
      for (var i = 0; i < object.userList.length; i++) {
        var user = object.userList[i];
        user["id"] = user.userId;
        // add user in UserCollection inside GroupCollection
        collectionRef.doc(user.userId).set(user);
      }
      callback(true);
    } else {
      callback(false);
    }
  }

  // remove UsersGroup - by seller only - of a given key.
  deleteUsersGroupMemberUser(callback, groupId, object) {

    var db = this.afs;
    var docRef = db.collection("UserCollection").ref.doc(localStorage.id)
      .collection("GroupCollection").doc(groupId).collection("UserCollection");
    if (object.userList.length != 0) {
      // add userCollection in GroupCollection
      for (var i = 0; i < object.userList.length; i++) {
        var user = object.userList[i];
        user["id"] = user.userId;
        // add user in UserCollection inside GroupCollection
        docRef.doc(user.userId).delete();
      }
      callback(true);
    } else {
      callback(false);
    }
  }

  // remove UsersGroup - by seller only - of a given key.
  deleteUsersGroup(callback, key) {
    var db = this.afs;
    var docRef = db.collection("UserCollection").ref.doc(localStorage.id)
      .collection("GroupCollection").doc(key);
    docRef.delete().then(function () {
      callback(true);
    }).catch(function (error) {
      callback(false);
    });
  }

  // update UsersGroup - by seller only - of a given key.
  updateUsersGroupName(callback, key, object) {
    var self = this;
    // update timestamp and navigator
    object["timestamp"] = firebase.firestore.FieldValue.serverTimestamp();
    self.fetchUsersGroup(function (isSuccess, docArray) {
      if (isSuccess) {
        if (docArray != null && docArray.length) {
          // found catalog - with given parameters.
          // so return false - that is catalog already exist with given name.
          callback(false);
        } else {
          // updating isRead true to all  s.
          //var userId = firebase.auth().currentUser.uid;
          self.afs.collection("UserCollection").ref.doc(localStorage.id)
            .collection("GroupCollection").doc(key)
            .update(object)
            .then(function () {

              // album updated - add user activity.
              self.addUserActivity({
                fireFor: "UPDATE_ALBUM",
                object: object
              });

              // do callback
              callback(true);
            });
        }
      }
    }, object.groupNameLC);
  }

  /*
    @Copyright Notice:
      @Type: TS
      @For :   share-multiple product.html.
      @Description : shareWithInGroupForProduct for share product with group.  
   */
  shareWithInGroupForProduct(callback: any, shareWithGrpId: any, productIdList: any, categoryId: any) {
    var self = this;
    if (categoryId != null && categoryId != undefined) {
      for (var i = 0; i < productIdList.length; i++) {
        var object = {
          productId: ''
        };
        object["productId"] = productIdList[i].productId;
        object["createDate"] = firebase.firestore.FieldValue.serverTimestamp();
        object["categoryId"] = categoryId;

        // Add a new document
        self.afs.collection("UserCollection").ref.doc(localStorage.id)
          .collection("GroupCollection").doc(shareWithGrpId)
          .collection("ProductCollection").doc(object.productId)
          .set(object)
          .then(function (doc) {
            callback(true);
          })
          .catch(function (error) {
            callback(false);
          });
      }
    }
  }

  // Update user Usage - this will call when anything action taken by user - to record its usage.
  updateUsage(callback, usageFor, userId, otherUserId, count, shareOrUnshare) {
    // update timestamp and navigator
    var object = {};
    //object["navigator"]     = getNavigator();
    object["timestamp"] = firebase.firestore.FieldValue.serverTimestamp();
    object["userId"] = userId;

    var db = this.afs;

    // Add a new document
    var ref = db.collection("UserCollection").doc(userId);

    switch (usageFor) {
      case "connections":
        db.collection("RelationConnectedCollection").ref
          .where("userId", "==", localStorage.id)
          .where("fieldId", "==", localStorage.currentFieldKeyId)
          .get().then(function (querySnapshot) {
            //if(!querySnapshot.empty) {
            // update count
            object["count"] = querySnapshot.size;
            ref.collection("UsageCollection").doc("connections")
              .set(object)
              .then(function (docRef) {
                callback(true);
              })
              .catch(function (error) {
                callback(true);
                console.error("Error adding document: ", error);
              });
            //}
          });
        break;
      // Sellers Created/total product.
      case "createdProducts":
        db.collection("ProductCollection").ref.where('userId', '==', localStorage.id)
          .where('fieldId', '==', localStorage.currentFieldKeyId)
          .get().then(function (querySnapshot) {
            // update count
            object["createdProducts"] = querySnapshot.size;
            ref.collection("UsageCollection").doc("createdProducts")
              .set(object)
              .then(function (docRef) {
                callback(true);
              })
              .catch(function (error) {
                callback(true);
                console.error("Error adding document: ", error);
              });
          });
        break;
      case "shareProduct":
        // var sharedoc =	db.collection("RelationConnectedCollection")
        // 	    .where("userId", "==", localStorage.id)
        //         .where("fieldId", "==", localStorage.currentFieldKeyId)
        //         .where("connectedUserId", "==", otherUserId)
        // 	   /*.collection("ShareWithCollection")*/
        // 	   .get().then(function(doc) {
        // 		if(doc.exist) {
        // update count
        // db.collection("RelationConnectedCollection").doc(doc.id)
        db.collection("ShareWithCollection").ref
          .where("userId", "==", localStorage.id)
          .where("fieldId", "==", localStorage.currentFieldKeyId)
          .where("shareWithUserId", "==", otherUserId)
          .get().then(function (querySnapshot) {
            object["recievedProductCount"] = querySnapshot.size;
            ref.collection("UsageCollection").doc("recievedProductCount")
              .set(object)
              .then(function (docRef) {
                callback(true);
              })
              .catch(function (error) {
                callback(true);
                console.error("Error adding document: ", error);
              });
          })
          .catch(function (error) {
            callback(true);
            console.error("Error adding document: ", error);
          });
        // 	}
        // });
        break;
      // shared product count - for inter and seller.
      case "sharedMyProduct":
        var cRef = ref.collection("UsageCollection").doc("sharedProductCount").ref
          .get().then(function (querySnapshot) {
            // update count
            if (querySnapshot.exists) {
              if (shareOrUnshare == "unshareProduct") {
                if (querySnapshot.data().sharedProductCount > 0 || querySnapshot.data().sharedProductCount == NaN) {
                  object["sharedProductCount"] = querySnapshot.data().sharedProductCount - count;
                } else {
                  object["sharedProductCount"] = 0;
                }
              } else {
                object["sharedProductCount"] = Number(querySnapshot.data().sharedProductCount) + count;
              }
              var cRef = ref.collection("UsageCollection").doc("sharedProductCount");
              cRef
                .update(object)
                .then(function (docRef) {
                  callback(true);
                })
                .catch(function (error) {
                  callback(true);
                  //console.error("Error adding document: ", error);
                });
            } else {

              object["sharedProductCount"] = count;
              var cRef = ref.collection("UsageCollection").doc("sharedProductCount");

              cRef.set(object)
                .then(function (docRef) {
                  callback(true);
                })
                .catch(function (error) {
                  callback(true);
                  //console.error("Error adding document: ", error);
                });
            }
          });
        break;
      // shared product count - for inter and seller.
      case "addToCart":
        var cRef = ref.collection("UsageCollection").doc("addToCartProductCount").ref
          .get().then(function (querySnapshot) {
            // update count
            if (querySnapshot.exists) {
              if (shareOrUnshare == "removeToCart") {
                if (querySnapshot.data().addToCartProductCount > 0 || querySnapshot.data().addToCartProductCount == NaN) {
                  object["addToCartProductCount"] = querySnapshot.data().addToCartProductCount - count;
                } else {
                  object["addToCartProductCount"] = 0;
                }
              } else {
                object["addToCartProductCount"] = Number(querySnapshot.data().addToCartProductCount) + count;
              }
              var cRef = ref.collection("UsageCollection").doc("addToCartProductCount");
              cRef
                .update(object)
                .then(function (docRef) {
                  callback(true);
                })
                .catch(function (error) {
                  callback(true);
                  //console.error("Error adding document: ", error);
                });
            } else {
              object["addToCartProductCount"] = count;
              var cRef = ref.collection("UsageCollection").doc("addToCartProductCount");

              cRef.set(object)
                .then(function (docRef) {
                  callback(true);
                })
                .catch(function (error) {
                  callback(true);
                  //console.error("Error adding document: ", error);
                });
            }
          });
        break;
      case "shareCatalog":
        db.collection("RelationConnectedCollection").ref
          .where("userId", "==", localStorage.id)
          .where("fieldId", "==", localStorage.currentFieldKeyId)
          .where("connectedUserId", "==", otherUserId)
          /*.collection("ShareWithCatalogCollection")*/
          .get().then(function (doc) {
            if (!doc.empty) {
              //db.collection("RelationConnectedCollection").doc(doc.id)
              //.collection("ShareWithCatalogCollection")
              db.collection("ShareWithCatalogCollection").ref
                .where("userId", "==", localStorage.id)
                .where("fieldId", "==", localStorage.currentFieldKeyId)
                .where("shareWithUserId", "==", otherUserId)
                .get().then(function (querySnapshot) {
                  // update count
                  object["recievedCatalogCount"] = querySnapshot.size;
                  ref.collection("UsageCollection").doc("recievedCatalogCount")
                    .set(object)
                    .then(function (docRef) {
                      callback(true);
                    })
                    .catch(function (error) {
                      callback(true);
                      //console.error("Error adding document: ", error);
                    });
                })
                .catch(function (error) {
                  callback(true);
                  console.error("Error adding document: ", error);
                });
            }
          });
        break;
      case "shareAlbum":
        var querySize = 0;
        db.collection("RelationConnectedCollection").ref
          .where("userId", "==", localStorage.id)
          .where("fieldId", "==", localStorage.currentFieldKeyId)
          .where("connectedUserId", "==", otherUserId)
          /*.collection("ShareWithAlbumCollection")*/
          .get().then(function (doc) {
            if (!doc.empty) {
              //db.collection("RelationConnectedCollection").doc(doc.id)
              //.collection("ShareWithAlbumCollection")
              db.collection("ShareWithAlbumCollection").ref
                .where("userId", "==", localStorage.id)
                .where("fieldId", "==", localStorage.currentFieldKeyId)
                .where("shareWithUserId", "==", otherUserId)
                .get().then(function (querySnapshot) {
                  // update count
                  querySize = querySnapshot.size;
                  object["recievedAlbumCount"] = querySize;
                  ref.collection("UsageCollection").doc("recievedAlbumCount")
                    .set(object)
                    .then(function (docRef) {
                      callback(true);
                    })
                    .catch(function (error) {
                      callback(true);
                      console.error("updateUsage 1 : ", error);
                    });
                })
                .catch(function (error) {
                  callback(true);
                  console.error("updateUsage 2 : ", error);
                });
            }
          });
        break;
      // shared Catalog count - for inter and seller.
      case "sharedMyCatalog":
        var cRef = ref.collection("UsageCollection").doc("sharedCatalogCount").ref
          .get().then(function (querySnapshot) {
            // update count
            if (querySnapshot.exists) {
              if (shareOrUnshare == "unshareCatalog") {
                if (querySnapshot.data().sharedCatalogCount > 0 || querySnapshot.data().sharedCatalogCount == NaN) {
                  object["sharedCatalogCount"] = querySnapshot.data().sharedCatalogCount - count;
                } else {
                  object["sharedCatalogCount"] = 0;
                }
              } else {
                object["sharedCatalogCount"] = querySnapshot.data().sharedCatalogCount + count;
              }
              var cRef = ref.collection("UsageCollection").doc("sharedCatalogCount");
              cRef
                .update(object)
                .then(function (docRef) {
                  callback(true);
                })
                .catch(function (error) {
                  callback(true);
                  //console.error("Error adding document: ", error);
                });
            } else {
              object["sharedCatalogCount"] = count;
              var cRef = ref.collection("UsageCollection").doc("sharedCatalogCount");
              cRef.set(object)
                .then(function (docRef) {
                  callback(true);
                })
                .catch(function (error) {
                  callback(true);
                  //console.error("Error adding document: ", error);
                });
            }
          });
        break;
      // shared album count - for inter and seller.
      case "sharedMyAlbum":
        var cRef = ref.collection("UsageCollection").doc("sharedAlbumCount").ref
          .get().then(function (querySnapshot) {
            // update count
            if (querySnapshot.exists) {
              if (shareOrUnshare == "unshareAlbum") {
                if (querySnapshot.data().sharedAlbumCount > 0 || querySnapshot.data().sharedAlbumCount == NaN) {
                  object["sharedAlbumCount"] = querySnapshot.data().sharedAlbumCount - count;
                } else {
                  object["sharedAlbumCount"] = 0;
                }
              } else {
                object["sharedAlbumCount"] = querySnapshot.data().sharedAlbumCount + count;
              }
              var cRef = ref.collection("UsageCollection").doc("sharedAlbumCount");
              cRef
                .update(object)
                .then(function (docRef) {
                  callback(true);
                })
                .catch(function (error) {
                  callback(true);
                  console.error("updateUsage 3 : ", error);
                });
            } else {

              object["sharedAlbumCount"] = count;
              var cRef = ref.collection("UsageCollection").doc("sharedAlbumCount");

              cRef.set(object)
                .then(function (docRef) {
                  callback(true);
                })
                .catch(function (error) {
                  console.error("updateUsage 4 : ", error);
                  callback(true);
                });
            }
          });
        break;
      case "createdAlbums":
        db.collection("ProductsAlbumCollection").ref
          .where("userId", "==", localStorage.id)
          .where("fieldId", "==", localStorage.currentFieldKeyId)
          .get().then(function (querySnapshot) {
            //if(!querySnapshot.empty) {
            // update count
            object["createdAlbums"] = querySnapshot.size;
            ref.collection("UsageCollection").doc("createdAlbums")
              .set(object)
              .then(function (docRef) {
                callback(true);
              })
              .catch(function (error) {
                callback(true);
                //console.error("Error adding document: ", error);
              });
            //}
          });
        break;
      case "createdCatalog":
        db.collection("ProductsCatalogCollection").ref
          .where("userId", "==", localStorage.id)
          .where("fieldId", "==", localStorage.currentFieldKeyId)
          .get().then(function (querySnapshot) {
            //if(!querySnapshot.empty) {
            // update count
            object["createdCatalog"] = querySnapshot.size;
            ref.collection("UsageCollection").doc("createdCatalog")
              .set(object)
              .then(function (docRef) {
                callback(true);
              })
              .catch(function (error) {
                callback(true);
                //console.error("Error adding document: ", error);
              });
            //}
          });
        break;
      case "createdGroups":
        db.collection("GroupCollection").ref
          .where("userId", "==", localStorage.id)
          .where("fieldId", "==", localStorage.currentFieldKeyId)
          .get().then(function (querySnapshot) {
            //if(!querySnapshot.empty) {
            // update count
            object["createdGroups"] = querySnapshot.size;
            ref.collection("UsageCollection").doc("createdGroups")
              .set(object)
              .then(function (docRef) {
                callback(true);
              })
              .catch(function (error) {
                callback(true);
                //console.error("Error adding document: ", error);
              });
            //}
          });
        break;
    }
  }

  //navigate by url (navigate to other page)
  openNavigateToPage(pageName, navigationExtras) {
    var self = this;
    pageName = pageName ? pageName : "";
    self.router.navigateByUrl(pageName, navigationExtras);
  }

  //useCountryCode
  useCountryCode(callback) {
    var countryCodeVar = ["+91", "+213", "+376", "+244", "+1264", "+1268", "+54", "+374", "+297", "+61", "+43", "+994", "+1242", "+973", "+880", "+1246", "+375", "+32", "+501", "+229", "+1441", "+975"];
    callback(true, countryCodeVar);
  }

  fetchPublicProduct() {
    var self = this;
    self._publicProductData = new BehaviorSubject<ProductInterface[]>([]);
    self.publicProductData = self._publicProductData.asObservable();
    var scoresRefConn: any;

    scoresRefConn = self.getCollection('ProductCollection', ref => ref
      .where("userId", "==", environment.projectOwnerId)
      .where("productType", "==", 'public')
      .orderBy('createDate', 'desc')
      .limit(15))
    if (scoresRefConn) {
      scoresRefConn.subscribe(data => {
        var productsUserObj = [];
        if (data[data.length - 1]) {
          self.latestPublicProduct = data[data.length - 1].doc;
        }
        data.forEach((data1: "id") => {
          // get logedin user products
          if (self._publicProductData.value.findIndex(x => x["id"] == data1["id"]) == -1) {
            productsUserObj.push(data1);
          }
        });
        const currentValue = self._publicProductData.value;
        const updatedValue = [...currentValue, ...productsUserObj];
        self._publicProductData.next(updatedValue);
      });
    }
  }

  fetchPublicProductLoadMore() {

    var self = this;
    var scoresRefConn: any;
    scoresRefConn = self.getCollection('ProductCollection', ref => ref
      .where("userId", "==", environment.projectOwnerId)
      .where("productType", "==", 'public')
      .orderBy('createDate', 'desc')
      .startAfter(self.latestPublicProduct)
      .limit(15))

    if (scoresRefConn) {
      scoresRefConn.subscribe(data => {
        var productsUserObj = [];
        if (data[data.length - 1]) {
          self.latestPublicProduct = data[data.length - 1].doc;
        }
        data.forEach((data1: "id") => {
          // get logedin user products
          if (self._publicProductData.value.findIndex(x => x["id"] == data1["id"]) == -1) {
            productsUserObj.push(data1);
          }
        });
        const currentValue = self._publicProductData.value;
        //   // ... concat two arrays into single array
        const updatedValue = [...currentValue, ...productsUserObj];
        self._publicProductData.next(updatedValue);
        console.log('self._publicProductData ', self._publicProductData);
      });
    }
  }

  //function for check Product Is Already Share
  checkProductIsAlreadyShare(object) {
    var self = this;
    if (object.shareTimeUnit == "noTime" || object.shareTimeUnit == "") {
    } else {
      let updateValue = {
        "shareTimeUnit": object.shareTimeUnit,
        "shareTimeValue": object.shareTimeValue,
        "shareEndTimeStamp": object.shareEndTimeStamp,
        "timestamp": firebase.firestore.FieldValue.serverTimestamp()
      }
      for (let user of object.userArray) {
        for (let product of object.productArray) {
          let collectionName = "";
          let shareWithUserId = "";
          if (object.userArray.userType == "intermediary") {
            collectionName = "ReShareWithCollection";
            shareWithUserId = "reShareWithUserId"
          } else {
            collectionName = "ShareWithCollection";
            shareWithUserId = "shareWithUserId"
          }

          let query = this.afs.collection(collectionName).ref.where(shareWithUserId, "==", user.userId)
            .where("userId", "==", localStorage.id)
            .where("productId", "==", product.productId);
          query.get().then(function (querySnapShot) {
            if (querySnapShot.empty) {
            } else {
              self.afs.collection(collectionName).ref.doc(querySnapShot.docs[0].id).update(updateValue).then(function () {
              }).catch(function (error) {
              });
            }
          })
        }
      }
    }
  }

  //function for check Folder Is Already Share
  checkFolderIsAlreadyShare(object) {
    var self = this;
    if (object.shareTimeUnit == "noTime" || object.shareTimeUnit == "") {
    } else {
      let updateValue = {
        "shareTimeUnit": object.shareTimeUnit,
        "shareTimeValue": object.shareTimeValue,
        "shareEndTimeStamp": object.shareEndTimeStamp,
        "timestamp": firebase.firestore.FieldValue.serverTimestamp()
      }
      for (let user of object.userArray) {
        for (let product of object.albumArray) {
          let collectionName = "";
          let shareWithUserId = "";
          if (object.userArray.userType == "intermediary") {
            collectionName = "ReShareWithAlbumCollection";
            shareWithUserId = "reShareWithUserId"
          } else {
            collectionName = "ShareWithAlbumCollection";
            shareWithUserId = "shareWithUserId"
          }

          let query = this.afs.collection(collectionName).ref.where(shareWithUserId, "==", user.userId)
            .where("userId", "==", localStorage.id)
            .where("productId", "==", product.productId);
          query.get().then(function (querySnapShot) {
            if (querySnapShot.empty) {
            } else {
              self.afs.collection(collectionName).ref.doc(querySnapShot.docs[0].id).update(updateValue).then(function () {
              }).catch(function (error) {
              });
            }
          })
        }
      }
    }
  }

  addRequestAccess(callback, object) {
    const self = this;
    this.afs.collection("RequestAccessCollection").ref.where('phoneNumber', "==", object.phoneNumber)
      .get().then(function (querySnapShot) {
        if (querySnapShot.empty) {
          var db = self.afs;
          db.collection("RequestAccessCollection").add(object)
            .then(function () {
              callback(true);
            });
        } else {
          callback(false);
        }
      });
  }

  async fetchRequestAccess() {
    let self = this;
    return await this.afs.collection('RequestAccessCollection').ref.get();
  }

  async showToast(message) {
    let toast = await this.toastCtrl.create({
      message: message,
      duration: 1000,
      position: 'bottom'
    });
    toast.present();
  }

  //createAlbumInFB function for create catalog in the FB
  createAlbumInFB(callback, object) {
    var self = this;
    object["timestamp"] = firebase.firestore.FieldValue.serverTimestamp();
    object["createDate"] = firebase.firestore.FieldValue.serverTimestamp();

    //Check Ojecct is exist or not
    if (object != undefined && object != null) {

      //update timestamp and navigator
      self.fetchAlbumOneOrMany(function (isSuccess, docArray) {
        if (isSuccess) {
          if (docArray != null && docArray.length) {
            self.showToast('Folder is already exist with name');

            callback(false);
          } else {
            //var userId = firebase.auth().currentUser.uid;
            var docRef = self.afs.collection("ProductsAlbumCollection").ref;
            var document = docRef.doc();
            // get key from doc and set in object - so that the doc unique key will stored in object. 
            object["id"] = document.id;
            object["timestamp"] = firebase.firestore.FieldValue.serverTimestamp();
            // set new object in doc ref
            docRef.doc(document.id).set(object)
              .then(function () {

                // album created - add user activity.
                self.addUserActivity({
                  fireFor: "CREATE_FOLDER",
                  object: object
                });

                callback(true);
              })
              .catch(function (error) {
                callback(false);
              });
          }
        }

      }, null, String(object.categoryId), null, null, object.albumNameLC, localStorage.currentFieldKeyId, "");
    } else {
    }
  }

  //fetching album on given parameter
  fetchAlbumOneOrMany(callback, next, categoryKey, buyerUserTypeKeyId, otherUserTypeKeyId,
    albumNameLC, fieldKeyId, userTypeId) {
    var self = this;
    //var userId = firebase.auth().currentUser.uid;
    var query: any;
    query = this.afs.collection("ProductsAlbumCollection").ref;
    if (localStorage.id) {
      query = query.where("userId", "==", localStorage.id);
    }
    if (localStorage.currentFieldKeyId != undefined && localStorage.currentFieldKeyId != null) {
      query = query.where("fieldId", "==", localStorage.currentFieldKeyId);
    }
    if (categoryKey != undefined && categoryKey != null) {
      query = query.where("categoryId", "==", String(categoryKey));
    }
    if (albumNameLC != undefined && albumNameLC != null) {
      query = query.where("albumNameLC", "==", albumNameLC);
    }
    if (buyerUserTypeKeyId != undefined && buyerUserTypeKeyId != null) {
      query = query.where("sharedBuyerIdList", "==", buyerUserTypeKeyId);
    }
    if (otherUserTypeKeyId != undefined && otherUserTypeKeyId != null) {
      query = query.where("sharedIntermediaryIdList", "==", otherUserTypeKeyId);
    }
    if (fieldKeyId != undefined && fieldKeyId != null) {
      query = query.where("fieldId", "==", String(fieldKeyId));
    }
    // fetch by sellerUserTypeKeyId - sellerUserTypeKeyId is the userTypeKeyId of a seller
    // get doc - doc of fire notification by giving different param in different cases.
    if (!next && next != null) {
      // using pagination - calling first time
      self.fetchAlbumOneOrManyFN = query.limit(25);

      self.fetchAlbumOneOrManyFN.get().then(function (querySnapshot) {
        if (!querySnapshot.empty) {
          var docArray = [];
          querySnapshot.forEach(function (doc) {
            docArray.push(doc.data());
          });
          callback(true, docArray);
        } else {
          callback(true, null);
        }
      }).catch(function (error) {
        callback(false, null);
      });
    } else if (next && next != null) {
      // using pagination - calling from show more button
      return self.fetchAlbumOneOrManyFN.get().then(function (documentSnapshots) {
        // Get the last visible document
        var lastVisible = documentSnapshots.docs[documentSnapshots.docs.length - 1];
        // Construct a new query starting at this document,
        // get the next 5.
        if (lastVisible != undefined) {
          self.fetchAlbumOneOrManyFN = query.startAfter(lastVisible).limit(10);
          self.fetchAlbumOneOrManyFN.get().then(function (querySnapshot) {
            if (!querySnapshot.empty) {
              var docArray = [];
              querySnapshot.forEach(function (doc) {
                docArray.push(doc.data());
              });
              callback(true, docArray);
            } else {
              callback(true, null);
            }
          }).catch(function (error) {
            callback(false, null);
          });
        } else {
          callback(true, null);
        }
      });
    } else {
      query.get().then(function (querySnapshot) {
        if (!querySnapshot.empty) {
          var docArray = [];
          querySnapshot.forEach(function (doc) {
            docArray.push(doc.data());
          });
          callback(true, docArray);
        } else {
          callback(true, null);
        }
      }).catch(function (error) {
        callback(false, null);
      });
    }
  }

  //delete folder from collection & already shared folder from collection
  deleteFolderFun(callback, folderId) {
    const self = this;
    let query = self.afs.collection("ProductsAlbumCollection").ref.doc(folderId)
      .collection("ShareWithAlbumCollection").get().then(function (querySnapshot) {
        if (!querySnapshot.empty) {
          querySnapshot.forEach(function (doc) {
            // doc.data() is never undefined for query doc snapshots
            self.afs.collection("ShareWithAlbumCollection").ref
              //.where("userId"          ,"==",  localStorage.id)
              .where("shareWithUserId", "==", doc.data().userId)
              .where("fieldId", "==", localStorage.currentFieldKeyId)
              .where("productId", "==", folderId)
              .get().then(function (querySnapsort1) {
                if (!querySnapsort1.empty) {
                  querySnapsort1.docs[0].ref.delete().then(function () {
                    // callback(true);
                    var query3 = self.afs.collection("ShareWithAlbumTimestampCollection").ref
                      .where("logedInUserId", "==", localStorage.id)
                      .where("fieldId", "==", localStorage.currentFieldKeyId)
                      .where("shareWithUserId", "==", doc.data().userId)
                      .get().then(function (querySnapshot) {
                        if (!querySnapshot.empty) {
                          querySnapshot.forEach(function (data) {
                            // And save it again for more queries
                            var userObject = {};
                            var query4 = self.afs.collection("ShareWithAlbumTimestampCollection").doc(data.id)
                              .collection("sellers").doc(localStorage.id).collection("folders").doc(folderId).ref
                            query4.get().then(function (docArray) {
                              if (docArray.exists) {
                                //deleted matched product
                                docArray.ref.delete();
                              }
                            })
                          })
                        }
                      }).catch(function (error) {
                        console.log("create an index", error);
                      });
                  }).catch(function (error) {
                    // callback(false);
                  });
                }
              }).catch(function (error) {
                console.log("Error Documents :", error);
              });
          });
        }
        if (localStorage.userType == "seller") {
          var query2 = self.afs.collection("ReShareWithAlbumCollection").ref
            .where("userId", "==", localStorage.id)
            .where("fieldId", "==", localStorage.currentFieldKeyId)
            // .where("reShareWithUserId", "==", userId)
            .where("productId", "==", folderId)
            .get().then(function (querySnapshot) {
              if (!querySnapshot.empty) {
                querySnapshot.docs[0].ref.delete().then(function () {
                  var query3 = self.afs.collection("ReShareWithAlbumTimestampCollection").ref
                    .where("logedInUserId", "==", localStorage.id)
                    .where("fieldId", "==", localStorage.currentFieldKeyId)
                    //.where("reShareWithUserId", "==", userId)
                    .get().then(function (querySnapshot) {
                      if (!querySnapshot.empty) {
                        querySnapshot.forEach(function (data) {
                          // And save it again for more queries
                          var userObject = {};
                          var query4 = self.afs.collection("ReShareWithAlbumTimestampCollection").doc(data.id)
                            .collection("sellers").doc(localStorage.id).collection("folders").doc(folderId).ref
                          query4.get().then(function (docArray) {
                            if (docArray.exists) {
                              //deleted matched product
                              docArray.ref.delete();
                            }
                          })
                        })
                      }
                    }).catch(function (error) {
                      console.log("create an index", error);
                    });
                })
              }
            }).catch(function (error) {
              console.log("create an index", error);
            });
        }
      }).catch(function (error) {
        console.log("Error Documnet", error);
      })
    // delete from ProductsAlbumCollection folder
    this.afs.collection('ProductsAlbumCollection').doc(folderId)
      .delete().then(function () {
        callback(true);
        self.navCtrl.back();
      })
  }

  updateAlbumNameFun(callback: any, object, folderId) {
    const self = this;
    this.afs.collection('ProductsAlbumCollection').doc(folderId)
      .update(object).then(function () {
        //self.showToast("Folder name updated.");
        callback(true);
      })
  }

  updateProductInFolderFun(callback: any, object, folderId) {
    const self = this;
    this.afs.collection('ProductsAlbumCollection').doc(folderId)
      .update(object).then(function () {
        //self.showToast("Folder updated.");
        callback(true);
      })
  }

  //set object in updateAlbumWithUserFunction collection
  updateAlbumWithUserFunction(callback, object) {
    let self = this;
    object["timestamp"] = firebase.firestore.FieldValue.serverTimestamp();
    let docRefId = this.afs.collection("shareProductWithUserFunction").ref.doc().id;
    object["id"] = docRefId;
    let docRef = this.afs.collection("shareProductWithUserFunction")
      .doc(docRefId).set(object)
      .then(function (docRef) {
        callback(true);
      })
      .catch(function (error) {
        console.error("Error writing document3: ", error);
      });
  }
  //get user for already shareAlbumWithUser
  shareAlbumWithUser(callback, albumId) {
    var self = this;
    var list = [];
    self.afs.collection("ProductsAlbumCollection").ref.doc(albumId)
      .collection("ShareWithAlbumCollection")
      .get().then(function (querySnapshot) {
        querySnapshot.forEach(function (doc) {
          const data = doc.data();
          //check reshare of seller products by intermediary or other user 
          if (!data.reShare) {
            list.push(data);
          }
        });
        callback(true, list);
      }).catch(function (error) {
        console.log("ShareWithAlbumCollection  : ", error);
        callback(true, list);
      });
  }

  //get user for already reShareAlbumWithUser
  reShareAlbumWithUser(callback, albumId) {
    console.log("albumId", albumId);
    var self = this;
    var list = [];
    self.afs.collection("ProductsAlbumCollection").ref.doc(albumId)
      .collection("ReShareWithAlbumCollection")
      .get().then(function (querySnapshot) {
        querySnapshot.forEach(function (doc) {
          const data = doc.data();
          //check reshare of seller products by intermediary or other user 
          if (!data.reShare) {
            list.push(data);
          }
        });
        callback(true, list);
      }).catch(function (error) {
        console.log("ReShareWithAlbumCollection  : ", error);
        callback(true, list);
      });
  }

  //folder share with any updateAlbumWithShare 
  async updateAlbumWithShare(callback, object: any) {
    let timestamp = firebase.firestore.FieldValue.serverTimestamp();
    const querySnapshort = await this.afs.collection("ShareWithAlbumCollection").ref
    const query4 = querySnapshort.where("userId", "==", object.userId).where("shareWithUserId", "==", object.shareWithUserId)
      .where("productId", "==", object.folderId).where("fieldId", "==", object.currentFieldKeyId)
    const querySnapshortTS = await query4.get();
    try {
      if (!querySnapshortTS.empty) {
        //get product data by id and set in an object to share with
        this.getAlbumById(function (isSuccess, data) {
          if (isSuccess && data) {
            //console.log("productId" ,productId);
            const productData = data;
            const ShareWithAlbumCollectionId = querySnapshortTS.docs[0].id;
            console.log(`querySnapshortTS.docs[0].id: ${querySnapshortTS.docs[0].id}`);
            querySnapshort.doc(ShareWithAlbumCollectionId).update(
              {
                "timestamp": timestamp,
                "productObject": productData
              }
            );
            callback(true)
          }
        }, object.folderId);
      } else {
        callback(false)
      }
    } catch (error) {
      console.log("Error adding document: ", error);
      callback(false)
    }
  };

  //folder reshare with any updateAlbumWithReShare 
  async updateAlbumWithReShare(callback, object: any) {
    let timestamp = firebase.firestore.FieldValue.serverTimestamp();
    const querySnapshort = await this.afs.collection("ReShareWithAlbumCollection").ref
    const query4 = querySnapshort.where("userId", "==", object.userId).where("reShareWithUserId", "==", object.reShareWithUserId)
      .where("productId", "==", object.folderId).where("fieldId", "==", object.currentFieldKeyId)
    const querySnapshortTS = await query4.get();
    try {
      if (!querySnapshortTS.empty) {
        //get product data by id and set in an object to share with
        this.getAlbumById(function (isSuccess, data) {
          if (isSuccess && data) {
            //console.log("productId" ,productId);
            const productData = data;
            const ShareWithAlbumCollectionId = querySnapshortTS.docs[0].id;
            console.log(`querySnapshortTS.docs[0].id: ${querySnapshortTS.docs[0].id}`);
            querySnapshort.doc(ShareWithAlbumCollectionId).update(
              {
                "timestamp": timestamp,
                "productObject": productData
              }
            );
            callback(true)
          }
        }, object.folderId);
      } else {
        callback(false)
      }
    } catch (error) {
      console.log("Error adding document: ", error);
      callback(false)
    }
  };

  //get folder data by id
  async getAlbumById(callback, folderId: any) {
    if (folderId) {
      var docRef = this.afs.collection("ProductsAlbumCollection").ref.doc(folderId);
      docRef.get().then(function (doc) {
        if (doc.exists) {
          var folderData = doc.data();
          callback(true, folderData)
        } else {
          callback(false, null)
        }
      }).catch(function (error) {
        callback(false, null)
      });
    }
  }

}

